{
  "app": {
    "name": "كور هب"
  },
  "nav": {
    "new_chat": "محادثة جديدة",
    "search": "بحث",
    "device_connections": "اتصالات الأجهزة",
    "agent_manager": "الوكلاء",
    "models": "النماذج",
    "knowledge": "المعرفة",
    "chat": "محادثة",
    "rooms": "الغرف",
    "tasks": "المهام",
    "schedules": "الجدولة",
    "settings": "الإعدادات",
    "account": "الحساب",
    "users": "المستخدمون",
    "webhooks": "وجهات الإشعار",
    "display": "العرض",
    "notifications": "الإشعارات",
    "privacy": "الخصوصية",
    "this_device": "هذا الجهاز",
    "about": "حول",
    "logs": "السجلات",
    "usage": "الاستخدام",
    "skills_usage": "استخدام المهارات",
    "performance": "الأداء",
    "theme": "السمة",
    "workspaces": "البروفايلات",
    "updates": "التحديثات",
    "plugins": "الإضافات",
    "skills": "المهارات",
    "mcp": "MCP",
    "memory": "الذاكرة",
    "jobs": "المهام المجدولة",
    "channels": "القنوات",
    "agent_settings": "الإعدادات",
    "global_agent": "الوكيل العام",
    "new_room": "غرفة جديدة",
    "join_by_code": "انضمام برمز",
    "sign_out": "تسجيل الخروج",
    "login": "تسجيل الدخول",
    "setup": "تهيئة أول تشغيل",
    "agent_skills": "المهارات",
    "agent_mcp": "MCP",
    "agent_memory": "الذاكرة",
    "agent_channels": "القنوات",
    "back_to_agents": "رجوع إلى الوكلاء",
    "terminal": "الطرفية",
    "files": "الملفات",
    "config_files": "ملفات الإعداد",
    "linked_hubs": "المراكز المرتبطة",
    "workflows": "سير العمل",
    "tools": "الأدوات",
    "secrets": "الأسرار"
  },
  "common": {
    "loading": "جارٍ التحميل…",
    "retry": "إعادة المحاولة",
    "save": "حفظ",
    "cancel": "إلغاء",
    "delete": "حذف",
    "more": "المزيد",
    "rename": "إعادة تسمية",
    "edit": "تحرير"
  },
  "errors": {
    "not_implemented": "المركز يعلن {operation} في العقد لكنه لم ينفّذها بعد.",
    "connection": "تعذّر الوصول إلى المركز. تحقق من الاتصال وحاول مجددًا.",
    "unexpected": "حدث خطأ: {message}"
  },
  "login": {
    "title": "تسجيل الدخول",
    "hub": "{name} · الخادم {version}",
    "username": "اسم المستخدم",
    "password": "كلمة المرور",
    "submit": "دخول",
    "signing_in": "جارٍ الدخول…",
    "setup_unknown": "تعذّر التحقق مما إذا كان المركز يحتاج إلى تهيئة أولية. حاول تسجيل الدخول أو أعد تحميل الصفحة.",
    "forgot": "نسيت كلمة المرور؟",
    "forgot_waiting": "بانتظار أن يؤكّد حاسوبك أنه أنت…",
    "forgot_hint": {
      "macos": "سيطلب جهاز الماك أولًا بصمة Touch ID أو كلمة مرور مدير الجهاز.",
      "windows_hello": "سيطلب ويندوز أولًا Windows Hello: وجهك أو بصمتك أو رمز PIN.",
      "polkit": "سيطلب لينكس أولًا كلمة مرورك. ستظهر عبارة تشغيل «true» بصلاحية المدير: هذا للتحقق فقط ولا يُشغَّل شيء آخر.",
      "test": "تأكيد اختباري يجيب بدل نظام التشغيل."
    },
    "local_sign_in": "ادخل على هذا الحاسوب",
    "recovery": {
      "title": "اختر كلمة مرور جديدة",
      "confirmed": "أكّد حاسوبك أنه أنت. هذا حساب المالك للمركز الذي يعمل على هذا الحاسوب.",
      "username_label": "اسم مستخدم المالك",
      "username_hint": "ادخل بهذا الاسم كما هو تمامًا: كل حرف ونقطة مهمّان.",
      "password": "كلمة المرور الجديدة",
      "password_hint": "{min} أحرف على الأقل.",
      "confirm": "تأكيد كلمة المرور الجديدة",
      "mismatch": "كلمتا المرور غير متطابقتين.",
      "too_short": "يجب ألا تقل كلمة المرور عن {min} أحرف.",
      "signs_out": "الحفظ يُخرج المالك من الأجهزة الأخرى: الهواتف والحواسيب الأخرى يجب أن تسجّل الدخول من جديد.",
      "save": "احفظ وادخل",
      "saving": "جارٍ الحفظ…",
      "cancel": "إلغاء",
      "errors": {
        "cancelled": "لم يؤكّد حاسوبك أنه أنت. لم يتغيّر شيء.",
        "unavailable": "لا توجد على هذا الحاسوب طريقة لتأكيد أنه أنت، لذا لا يمكن إعادة تعيين كلمة المرور هنا.",
        "rate_limited": "محاولات كثيرة. انتظر بضع دقائق ثم حاول مرة أخرى.",
        "expired": "انتهت صلاحية التأكيد. اضغط «نسيت كلمة المرور؟» من جديد.",
        "invalid_password": "رفض المركز كلمة المرور الجديدة. استخدم {min} أحرف على الأقل.",
        "no_owner": "لا يوجد مالك لهذا المركز بعد.",
        "owner_disabled": "حساب المالك معطّل.",
        "busy": "حاسوبك يطلب التأكيد الآن. أجب عن ذلك الطلب أولًا.",
        "failed": "حدث خطأ. حاول مرة أخرى، أو ادخل بكلمة المرور."
      }
    }
  },
  "setup": {
    "title": "إنشاء حساب المالك",
    "intro": "لا يوجد لهذا المركز مالك بعد. أنشئ حساب المالك من هنا.",
    "checking": "جارٍ التحقق من حالة المركز…",
    "open_title": "التسجيل مفتوح لأول شخص يفتح هذه الصفحة — أكمله الآن",
    "open_body": "إلى أن يوجد المالك يستطيع أي شخص يصل إلى هذا المركز إنشاءه، فأكمله الآن. وإن سبقك غيرك فأعد تشغيل المركز مع ⁨COREHUB_RESET_OWNER=1⁩ وهيّئه من جديد.",
    "open_remaining": "الوقت المتبقي: ⁨{time}⁩",
    "closed_title": "التهيئة تحتاج الآن رمز التهيئة",
    "closed_body": "انتهت المدة التي كانت التهيئة فيها مفتوحة للجميع، أو أن هذا المركز مضبوط على الرمز فقط. الصق الرمز الذي كتبه المركز عند تشغيله. وإعادة تشغيل المركز تفتح التهيئة من جديد مدةً محدودة دون رمز، ما لم يكن مضبوطًا على الرمز فقط.",
    "where_title": "أين تجد رمز التهيئة",
    "where_body": "طبعه المركز مرة واحدة في سجلّه عند الإقلاع، وكتبه في الملف ⁨setup-token.txt⁩ داخل مجلد البيانات. في المكدّس المرجعي:",
    "where_local": "إن كنت تشغّل المركز خارج Docker فالملف في مجلد ⁨DATA_DIR⁩ لديك (⁨./data/setup-token.txt⁩ افتراضيًا). ويُولَّد رمز جديد عند كل إعادة تشغيل إلى أن يوجد هذا الحساب.",
    "token": "رمز التهيئة",
    "token_hint": "ألصقه كما هو؛ تتم مقارنته كاملًا ولا يُحفظ في المتصفح.",
    "username": "اسم المستخدم",
    "username_hint": "حروف إنجليزية صغيرة وأرقام ونقطة أو شرطة أو شرطة سفلية — من 2 إلى 40 محرفًا.",
    "display_name": "الاسم الظاهر (اختياري)",
    "workspace_name": "اسم البروفايل (اختياري)",
    "workspace_hint": "اسم أول بروفايل؛ يصبح ⁨«Default»⁩ إن تُرك فارغًا.",
    "password": "كلمة المرور",
    "password_hint": "‏{min} محارف فأكثر. لا تُعرض ولا تُسجَّل ولا تُخزَّن إلا كبصمة.",
    "confirm": "تأكيد كلمة المرور",
    "mismatch": "كلمتا المرور غير متطابقتين.",
    "submit": "أنشئ الحساب وادخل",
    "creating": "ننشئ الحساب…",
    "unattended": "التركيب غير التفاعلي ما زال ممكنًا بضبط ⁨HUB_ADMIN_PASSWORD⁩ قبل أول إقلاع؛ عندها ينشئ المركز حساب المالك بنفسه ولا تظهر هذه الشاشة."
  },
  "shell": {
    "sidebar": "القائمة الرئيسية",
    "segments": "الأقسام",
    "workspace": "البروفايل",
    "open_menu": "فتح القائمة",
    "close_menu": "إغلاق القائمة",
    "segment_later": "{name} يصل مع وحدته في مرحلة لاحقة.",
    "language_chip": "تبديل لغة الواجهة",
    "theme_chip": "تبديل السمة",
    "connection": {
      "connected": "متصل",
      "connecting": "جارٍ الاتصال…",
      "offline": "غير متصل"
    },
    "theme_next": "السمة: {next}",
    "in_profile": "البروفايل: {name}",
    "fold": "طيّ القائمة الجانبية",
    "unfold": "توسيع القائمة الجانبية",
    "person_menu": "قائمتك",
    "back_to_chats": "رجوع إلى المحادثات",
    "no_profile_title": "لا بروفايل لك بعد",
    "no_profile_body": "لم يُعطَ حسابك أي بروفايل، فلا شيء يُفتح بعد. اطلب من المشرف أن يعطيك واحدًا، ثم تحقّق مرة أخرى.",
    "no_profile_retry": "تحقّق مرة أخرى"
  },
  "pane": {
    "resize": "تغيير عرض اللوحة الجانبية (الأسهم للتغيير، Home للطيّ، End للتوسيع)",
    "collapse": "طيّ اللوحة الجانبية",
    "expand": "توسيع اللوحة الجانبية",
    "close": "إغلاق اللوحة الجانبية",
    "kind": {
      "tool": "مخرجات الأداة",
      "code": "كود",
      "preview": "معاينة",
      "artifact": "ناتج",
      "tasks": "المهام"
    }
  },
  "sessions": {
    "untitled": "محادثة جديدة",
    "filter": "تصفية المحادثات",
    "all_profiles": "كل البروفايلات",
    "profile_filter": "عرض محادثات",
    "empty": "لا توجد محادثات في هذا البروفايل بعد. ابدأ محادثة جديدة.",
    "none_match": "لا توجد محادثات تطابق التصفية.",
    "pin": "تثبيت",
    "unpin": "إلغاء التثبيت",
    "pinned": "مثبّتة",
    "archive": "أرشفة",
    "delete": "حذف",
    "reorder": "إعادة ترتيب {title} (مسافة للالتقاط، الأسهم للتحريك)",
    "confirm_delete": "حذف «{title}» ورسائلها؟",
    "status": {
      "idle": "خاملة",
      "running": "تعمل",
      "waiting": "بانتظارك"
    },
    "source": {
      "chat": "محادثة",
      "global_agent": "الوكيل العام",
      "room": "الغرف",
      "task": "مهام اللوحة",
      "schedule": "الجدولة",
      "workflow": "سير العمل",
      "channel": "القنوات",
      "cli": "الطرفية",
      "api": "API"
    },
    "unarchive": "إلغاء الأرشفة",
    "none_archived": "لا محادثة مؤرشفة.",
    "scope": {
      "label": "نطاق القائمة",
      "active": "النشطة",
      "archived": "المؤرشفة",
      "all": "الكل"
    },
    "confirm_delete_body": "ستُحذف رسائلها أيضًا، ولا يمكن التراجع عن الحذف.",
    "rename": "إعادة التسمية",
    "rename_label": "اسم المحادثة",
    "retitle": "أعد التسمية تلقائيًا",
    "more": "المزيد لـ {title}",
    "retitle_hint": "سيُنشئ المركز عنوانًا جديدًا للمحادثة بناءً على بدايتها.",
    "select": "تحديد",
    "select_all": "تحديد الكل",
    "select_none": "إلغاء التحديد",
    "select_one": "حدّد {title}",
    "selected_count": "المحددة: {count}",
    "confirm_delete_many": "حذف المحادثات المحددة ({count})؟",
    "categories": {
      "new": "تصنيف جديد",
      "new_label": "اسم التصنيف",
      "new_in_profile": "يُنشأ في البروفايل {profile}، ويراه كل من يدخل هذا البروفايل.",
      "create": "إنشاء",
      "rename": "إعادة تسمية التصنيف",
      "move_up": "نقل لأعلى",
      "move_down": "نقل لأسفل",
      "delete": "حذف التصنيف",
      "confirm_delete": "حذف التصنيف «{name}»؟",
      "confirm_delete_body": "تبقى محادثاته، وتعود إلى القائمة بلا تصنيف.",
      "more": "المزيد لـ {name}",
      "count": "المحادثات: {count}",
      "move_to": "نقل إلى تصنيف",
      "move_title": "نقل «{title}» إلى تصنيف",
      "move_hint": "تصنيفات البروفايل {profile}.",
      "none": "بلا تصنيف",
      "current": "الحالي",
      "new_and_move": "تصنيف جديد…",
      "empty_group": "اسحب محادثة إلى هنا، أو استخدم قائمتها.",
      "colour": "اللون",
      "colour_title": "لون {name}",
      "colour_none": "بلا لون",
      "colours": {
        "blue": "أزرق",
        "green": "أخضر",
        "amber": "كهرماني",
        "red": "أحمر",
        "purple": "بنفسجي",
        "pink": "وردي",
        "teal": "أزرق مخضر",
        "slate": "رمادي"
      }
    },
    "channels": {
      "telegram": "تيليجرام",
      "whatsapp": "واتساب",
      "other": "القنوات: {name}",
      "readonly_banner": "محادثة من {channel} — للقراءة فقط؛ الرد يكون من {channel}",
      "unreachable": "تعذّرت قراءة محادثات القنوات من هرمز الآن؛ المعروض هو آخر ما جُلب.",
      "untitled": "محادثة على {channel}",
      "has_more": "تُعرض آخر 500 رسالة فقط من هذه المحادثة.",
      "no_messages": "لا رسائل نصية في هذه المحادثة بعد.",
      "continue": {
        "button": "أكمل في كور هب",
        "title": "أكمل هذه المحادثة في كور هب",
        "hint": "تبدأ محادثة جديدة في هذا البروفايل ومعها هذه المحادثة مرفقةً ليقرأها الوكيل. المحادثة في {channel} تبقى كما هي.",
        "note": "ماذا تريد من الوكيل أن يفعل بها؟ (اختياري)",
        "go": "أكمل",
        "no_agent": "لا وكيل في هذا البروفايل يستطيع تولّيها. ثبّت وكيلًا من «الوكلاء» أولًا."
      },
      "hide": "إخفاء من قائمتي",
      "unhide": "إظهار مرة أخرى",
      "delete": "حذف من هرمز…",
      "delete_title": "حذف «{title}» من هرمز؟",
      "delete_body": "تُحذف المحادثة ورسائلها من هرمز للجميع، نهائيًا، ولا يمكن استرجاعها. المحادثة نفسها في {channel} لا تتأثر.",
      "delete_confirm": "حذف نهائي",
      "hidden_toast": "أُخفيت «{title}» من قائمتك",
      "hidden_toast_body": "أنت وحدك لا تراها. «إظهار المحادثات المخفية» في آخر القائمة يعيدها.",
      "show_hidden": "إظهار المحادثات المخفية ({count})",
      "hide_hidden": "إيقاف إظهار المحادثات المخفية",
      "actions": "إجراءات المحادثة",
      "action_failed": "تعذّر تغيير المحادثة",
      "show_older": "محادثات قنوات أقدم",
      "load_older": "حمّل رسائل أقدم",
      "picture": "صورة أُرسلت في القناة",
      "picture_gone": "أُرسلت هنا صورة. يحتفظ هرمز بصور القنوات يومًا واحدًا، وهذه حُذفت.",
      "send": {
        "label": "اكتب في محادثة {channel} هذه",
        "placeholder": "اكتب إلى {peer} على {channel}…",
        "send": "أرسل على {channel}",
        "hint": "تُنشر أولًا على {channel} بصيغة «من كور هب (اسمك): …»، ثم تصل إلى الوكيل فيرد هناك. يظهر الرد هنا حين ينتهي الوكيل.",
        "from_hub": "{name} · من كور هب",
        "you": "أنت · من كور هب",
        "open_current": "افتح المحادثة الحالية",
        "error_channel": "رفض {channel} الرسالة، فلم تصل إلى الوكيل: {message}",
        "status": {
          "sending": "تُرسل على {channel}…",
          "posted": "نُشرت على {channel} · بانتظار أن يستلمها الوكيل",
          "delivered": "وصلت الوكيل · يرد حين ينتهي دوره الحالي",
          "answering": "الوكيل يرد على {channel}…",
          "answered": "تم الرد على {channel}"
        },
        "failed": {
          "bridge_no_answer": "نُشرت على {channel}، لكن Hermes لم يستلمها في الوقت (ربما يُعاد تشغيل بوابة المراسلة). إرسالها من جديد ينشرها على {channel} مرة أخرى.",
          "not_accepted": "نُشرت على {channel}، لكن Hermes رفض أن يسلّمها للوكيل.",
          "not_picked_up": "نُشرت على {channel}، لكن الوكيل لم يستلمها أبدًا. سجل Hermes يذكر السبب."
        },
        "unavailable": {
          "not_admin": "محادثة من {channel}. الكتابة فيها من هنا للمشرف فقط؛ والرد يكون من {channel}.",
          "platform_unsupported": "محادثة من {channel} — للقراءة فقط هنا حاليًا. الكتابة من كور هب متاحة لتيليجرام وواتساب.",
          "hermes_not_managed": "محادثة من {channel} — للقراءة فقط: هذا المركز لا يشغّل Hermes، فلا يستطيع الكتابة فيها.",
          "bridge_offline": "محادثة من {channel} — الكتابة من هنا غير متاحة ما دامت بوابة المراسلة في Hermes تبدأ أو متوقفة.",
          "not_current": "انتقلت محادثة {channel} هذه إلى محادثة أحدث؛ ما تكتبه من هنا يذهب إليها.",
          "no_route": "محادثة من {channel} — لا يحتفظ Hermes بطريق للرد على هذه المحادثة، فلا يمكن الكتابة فيها من هنا."
        }
      }
    }
  },
  "search": {
    "placeholder": "ابحث في العناوين والرسائل…",
    "none": "لا نتائج."
  },
  "new_chat": {
    "pick_agent": "اختر الوكيل الذي تحادثه. القائمة من سجلّ المركز.",
    "no_agents": "لا وكيل مفعّل على هذا المركز. ثبّت أو فعّل واحدًا من صفحة الوكلاء.",
    "greeting": "بم نبدأ؟",
    "lede": "اختر وكيلًا، وحدّد مجلد العمل إن أردت، ثم اكتب رسالتك.",
    "in_profile": "محادثة جديدة في {name}. لبدئها في بروفايل آخر، بدّل البروفايل من أعلى الصفحة.",
    "none_installed": "لا يوجد وكيل مثبّت على هذا المركز. هرمز مضمّن معه؛ إذا ظهر أنه غير مثبّت، فتحقّق من تشغيله أو ثبّت وكيلًا من صفحة الوكلاء.",
    "open_agents": "افتح صفحة الوكلاء"
  },
  "chat": {
    "pick_one": "اختر محادثة من القائمة أو ابدأ محادثة جديدة.",
    "empty": "لا توجد رسائل بعد. اكتب رسالتك أدناه.",
    "assistant": "الوكيل",
    "streaming": "يكتب…",
    "failed": "فشل",
    "interrupted": "أُوقف",
    "thinking": "يفكّر",
    "reasoning": "التفكير",
    "copy_code": "نسخ الكود",
    "open_in_pane": "فتح في اللوحة الجانبية",
    "location": "موقع",
    "usage": "{input} داخل · {output} خارج",
    "resumed": "أُعيد الاتصال؛ أُعيد إرسال {replayed} حدثًا فائتًا.",
    "resynced": "أُعيد الاتصال؛ أُعيد تحميل المحادثة من المركز.",
    "session_deleted": "حُذفت هذه المحادثة.",
    "run_failed": "فشل التشغيل: {error} ({code})",
    "empty_title": "بم نبدأ؟",
    "no_provider": "‏لم يُضبط مزوّد نماذج لهذا البروفايل بعد، لذلك لا يمكن للوكيل الرد.",
    "no_provider_action": "‏افتح الإعدادات ← النماذج ← الافتراضيات",
    "agent_help": {
      "goose_provider": "لم يُضبط مزوّد نماذج لـ{name} بعد: ملف إعداده يحتاج GOOSE_PROVIDER وGOOSE_MODEL.",
      "claude_auth": "{name} يحتاج تسجيل دخول أو مزوّدًا متوافقًا مع Anthropic. أضف مزوّد Anthropic من «النماذج»، أو سجّل دخول Claude Code على جهاز المركز.",
      "codex_auth": "{name} يحتاج مفتاح OpenAI أو تسجيل دخول ChatGPT. أضف مزوّد OpenAI من «النماذج».",
      "gemini_auth": "{name} يحتاج تسجيل دخول Google أو مفتاح Gemini API. أضف مزوّد Google من «النماذج».",
      "provider_auth": "ليس لدى {name} مفتاح أو تسجيل دخول يرد به. أضف مزوّدًا يستطيع استخدامه من «النماذج».",
      "sign_in": "{name} يحتاج تسجيل الدخول إلى حسابه.",
      "open_config_files": "افتح ملفات إعداد {name}",
      "open_models": "افتح الإعدادات ← النماذج",
      "open_sign_in": "سجّل دخول {name}",
      "agent_said": "قال {name}:"
    },
    "no_key": "‏رفض المزوّد المفتاح المحفوظ، فلم يستطع الوكيل الوصول إليه.",
    "no_key_action": "‏افتح الإعدادات ← النماذج",
    "quota_exhausted": "نفدت حصة «{provider}» من «{model}». اختر نموذجًا آخر لهذه المحادثة.",
    "quota_pick_model": "اختر نموذجًا آخر",
    "no_capacity": "لا تتوفر لدى «{provider}» سعة لـ«{model}» الآن. أعد المحاولة بعد قليل، أو اختر نموذجًا آخر لهذه المحادثة.",
    "rate_limited": "«{provider}» يحدّ الطلبات على «{model}» الآن. أعد المحاولة بعد دقيقة، أو اختر نموذجًا آخر لهذه المحادثة.",
    "model_status": {
      "trying": "يجرّب {model}…",
      "waiting_capacity": "لا سعة الآن لدى {model} — يعيد السؤال بعد {seconds} ث",
      "waiting_capacity_now": "لا سعة الآن لدى {model} — يعيد السؤال",
      "waiting_limit": "{model} يحدّ الطلبات — يعيد السؤال بعد {seconds} ث",
      "waiting_limit_now": "{model} يحدّ الطلبات — يعيد السؤال"
    },
    "you": "أنت",
    "queued": "في الانتظار",
    "seconds": "{seconds} ث",
    "thought_for": "فكّر لمدة {seconds} ث",
    "pick_one_body": "لكل محادثة وكيلها ومجلد عملها وسجل رسائلها.",
    "copied": "نُسخ",
    "agent_menu": "الوكيل: {name} — أكمل مع وكيل آخر",
    "agent_of_session": "وكيل هذه المحادثة",
    "fork_explains": "اختيار وكيل آخر ينسخ هذه المحادثة إلى محادثة جديدة معه ويترك هذه كما هي. أمّا منتقي النموذج في الأسفل فيغيّر هذه المحادثة وحدها.",
    "continue_with": "أكمل مع {name}",
    "no_other_agent": "لا يوجد وكيل آخر مثبَّت.",
    "copy": "نسخ",
    "reply": "الرد على هذه الرسالة",
    "fork_here": "فرّع من هنا",
    "time_yesterday": "أمس {time}",
    "replying_to": "ردًّا على: {text}",
    "estimated": "≈ {amount}",
    "anchor_missing": "الرسالة التي أشار إليها البحث لم تعد في هذه المحادثة.",
    "older_loading": "جارٍ تحميل الرسائل الأقدم…",
    "older_start": "بداية المحادثة",
    "older_failed": "تعذّر تحميل الرسائل الأقدم.",
    "answered_by": "أجاب {model}",
    "fallback_note": "فشل {failed}، فأجاب {model}",
    "fallback_reason": "السبب: {reason}",
    "bar_more": "المزيد"
  },
  "composer": {
    "label": "محرّر الرسالة",
    "placeholder": "راسل الوكيل…",
    "disabled": "المحادثة غير جاهزة بعد.",
    "send": "إرسال",
    "stop": "إيقاف التشغيل",
    "attach": "إرفاق ملفات",
    "drop_here": "أفلت الملفات هنا لإرفاقها",
    "upload_failed": "فشل الرفع",
    "remove_attachment": "إزالة {name}",
    "busy_hint": "الوكيل مشغول الآن؛ ستُرسل رسالتك بعد انتهاء التشغيل الحالي.",
    "agents": "الوكلاء المثبَّتون",
    "agent_pick": "اختيار {name} لهذه المحادثة",
    "agent_current": "الوكيل الحالي: {name}",
    "agent_new_chat": "بدء محادثة جديدة مع {name}",
    "more": "إضافة إلى الرسالة",
    "upload": "رفع ملف",
    "drop_hint": "أو أفلت الملفات في مربع الكتابة مباشرةً.",
    "model": "النموذج",
    "model_default": "النموذج الافتراضي",
    "model_default_named": "الافتراضي · {model}",
    "model_small_context": "سياق صغير (أقل من {tokens} ألف)",
    "model_agent_default": "افتراضي الوكيل نفسه",
    "approval": "وضع الصلاحيات",
    "approval_no_agent": "اختر وكيلًا أولًا.",
    "approval_unsupported": "هذا الوكيل لا يعلن وضع صلاحيات.",
    "approval_mode": {
      "ask": "افتراضي: يسأل",
      "auto_safe": "تحرير تلقائي",
      "auto_all": "بلا سؤال",
      "off": "بلا موافقات",
      "always": "يسأل دائمًا",
      "manual": "يدوي: يسأل عن كل أمر خطر",
      "smart": "ذكي"
    },
    "add_agent": "إضافة وكيل",
    "approval_hint": {
      "ask": "الوكيل يسأل قبل كل أمر أو تعديل خارج مجلد العمل.",
      "always": "يسأل قبل كل شيء، حتى القراءة — الأبطأ والأكثر أمانًا.",
      "auto_safe": "ينفّذ ما يراه آمنًا وحده، ويسأل عن الباقي.",
      "auto_all": "ينفّذ كل شيء بلا سؤال، ولا فرصة للاعتراض.",
      "off": "بلا بوّابة إطلاقًا: أوامر وملفات وشبكة بلا إذن.",
      "manual": "يسأل قبل كل أمر خطر.",
      "smart": "نموذج مساعد يمرّر الآمن ويسأل عن الباقي."
    },
    "effort": {
      "label": "مستوى التفكير",
      "default": "تلقائي",
      "none": "بلا تفكير",
      "minimal": "أدنى",
      "low": "منخفض",
      "medium": "متوسط",
      "high": "عالٍ",
      "max": "أقصى"
    },
    "context_ring": "السياق: {percent}% — {used} من {window} رمز",
    "placeholder_agent": "راسل {agent}…"
  },
  "slash": {
    "title": "الأوامر",
    "skills_title": "المهارات — اختر مهارة تُستعمل في هذه الرسالة",
    "no_match": "لا أمر مطابق. اضغط Enter لإرسالها رسالةً عادية.",
    "needs_argument": "يحتاج {command} إلى كلام بعده.",
    "model_unknown": "لا يوجد نموذج اسمه «{model}» في هذا البروفايل.",
    "cleared": "مُسحت الشاشة؛ الرسائل ما زالت في المحادثة.",
    "show_cleared": "أظهرها",
    "describe": {
      "compress": "اضغط سياق هذه المحادثة الآن (أضف كلامًا يقول ما يُحتفظ به)",
      "steer": "وجّه الدور الجاري دون إيقافه",
      "skill": "استعمل إحدى مهارات الوكيل في هذه الرسالة",
      "plan": "اطلب من الوكيل خطة دون تنفيذ العمل",
      "goal": "حدّد هدفًا دائمًا يعمل عليه الوكيل عبر الأدوار، أو اعرضه",
      "learn": "حوّل العمل الأخير، أو ما تصفه، إلى مهارة",
      "new": "ابدأ محادثة جديدة مع هذا الوكيل",
      "fork": "انسخ هذه المحادثة إلى محادثة جديدة",
      "archive": "أرشف هذه المحادثة",
      "model": "غيّر النموذج (أضف اسمًا، أو اختر من القائمة)",
      "clear-screen": "امسح الشاشة؛ لا يُحذف شيء"
    }
  },
  "context_meter": {
    "title": "نافذة السياق",
    "percent": "ممتلئة {percent}%",
    "used": "{used} من {window} رمز",
    "ring_estimate": "السياق (تقدير): {percent}% — نحو {used} من {window} رمز",
    "source": {
      "reported": "كما أبلغ عنه الوكيل بعد الدور الأخير.",
      "agent_estimate": "عدّ تقريبي من الوكيل نفسه بعد الدور الأخير.",
      "estimate": "تقدير: رموز الدور الأخير مقابل نافذة النموذج في الكتالوج."
    },
    "compress": "اضغط الآن",
    "compressing": "جارٍ الضغط…",
    "compressing_manual": "يُضغط سياق المحادثة…",
    "compressing_auto": "الوكيل يضغط السياق ليفسح مكانًا…",
    "last_compressed": "آخر ضغط: من نحو {before} إلى {after} رمز.",
    "last_done": "انتهى آخر ضغط.",
    "last_failed": "فشل آخر ضغط.",
    "wait_for_run": "انتظر حتى ينتهي الدور الجاري، ثم اضغط.",
    "breakdown_title": "ما الذي يملؤها",
    "breakdown_note": "حسب الفئة، كما يعدّها الوكيل تقريبًا.",
    "category": {
      "system_prompt": "تعليمات النظام",
      "tool_definitions": "تعريفات الأدوات",
      "rules": "القواعد",
      "skills": "المهارات",
      "mcp": "MCP",
      "subagent_definitions": "تعريفات الوكلاء الفرعيين",
      "memory": "الذاكرة",
      "conversation": "المحادثة"
    }
  },
  "compression_settings": {
    "title": "ضغط السياق",
    "subtitle": "حدّد كيف يختصر هرمز المحادثات الطويلة في هذا البروفايل. يسري التغيير من الرسالة التالية.",
    "enabled": "اضغط تلقائيًا",
    "enabled_hint": "عندما يبلغ سياق المحادثة الحد المحدد، يلخّص هرمز جزءها الأقدم.",
    "threshold": "الحدّ (% من النافذة)",
    "threshold_hint": "إذا أدخلت حدًا أقل من 75%، يرفعه هرمز إلى 75% للنماذج التي تقل نافذتها عن 512K رمز.",
    "target": "ما يبقى كما هو (% من الحدّ)",
    "target_hint": "يحتفظ هرمز بالنص الأحدث كما هو، ضمن نسبة تتراوح بين 10% و80%.",
    "protect_first": "أول رسائل تبقى دائمًا",
    "protect_last": "أحدث رسائل تبقى دائمًا",
    "context_length": "تجاوز نافذة السياق (رموز)",
    "context_length_hint": "فقط حين تُبلَّغ نافذة النموذج خطأً. فارغ = نافذة النموذج نفسه.",
    "saved": "حُفظت الإعدادات، وسيطبّقها هرمز من الرسالة التالية.",
    "invalid": "أدخل عددًا صحيحًا ضمن المدى (1024 على الأقل للنافذة)."
  },
  "approval": {
    "from": "{agent} ينتظر قرارك",
    "once": "مرة واحدة",
    "session": "لهذه الجلسة",
    "always": "دائمًا",
    "deny": "رفض",
    "answer": "إجابتك",
    "send": "إجابة",
    "skip": "تخطٍّ (رفض)",
    "waiting": "بانتظار قرارك",
    "answer_hint": "اكتب ردك…"
  },
  "pending": {
    "open": "بانتظارك",
    "open_count": "بانتظارك: {count}",
    "title": "بانتظارك",
    "close": "إغلاق",
    "none": "لا شيء بانتظارك.",
    "none_body": "تظهر هنا الموافقات وأسئلة الوكلاء وخطوات سير العمل التي تحتاجك.",
    "open_item": "افتحه في مكانه",
    "workflow_step": "خطوة سير عمل",
    "pairing": "{name} يريد مراسلة الوكيل عبر {platform}",
    "pairing_hint": "وافق عليه أو ارفضه هنا، أو من «الموافقات» في صفحة قنوات الوكيل.",
    "global_agent": "اسأل الوكيل العام",
    "write_hint": "يريد الوكيل أن يحتفظ بهذا؛ وهو بانتظار المراجعة.",
    "room_item": "غرفة"
  },
  "global_agent": {
    "intro": "محادثة واحدة دائمة مع وكيلك في هذا البروفايل، خارج قائمة المحادثات. تصل إليها من البحث ومن شريط ما ينتظرك.",
    "opening": "يفتح الوكيل العام…",
    "no_agent": "لا وكيل مثبّت في هذا البروفايل بعد، فلا أحد تحادثه."
  },
  "tool": {
    "activity": {
      "steps": {
        "zero": "لا خطوات",
        "one": "خطوة واحدة",
        "two": "خطوتان",
        "few": "{count} خطوات",
        "many": "{count} خطوة",
        "other": "{count} خطوة"
      },
      "failed": {
        "zero": "لم تفشل أي خطوة",
        "one": "فشلت خطوة",
        "two": "فشلت خطوتان",
        "few": "فشلت {count} خطوات",
        "many": "فشلت {count} خطوة",
        "other": "فشلت {count} خطوة"
      },
      "earlier": {
        "zero": "لا خطوات سابقة",
        "one": "+ خطوة سابقة",
        "two": "+ خطوتان سابقتان",
        "few": "+ {count} خطوات سابقة",
        "many": "+ {count} خطوة سابقة",
        "other": "+ {count} خطوة سابقة"
      },
      "hide_earlier": "إخفاء الخطوات السابقة",
      "seconds": "{seconds} ث",
      "minutes": "{minutes} د {seconds} ث"
    },
    "status": {
      "running": "يعمل",
      "succeeded": "تم",
      "failed": "فشل",
      "interrupted": "أُوقف",
      "awaiting_approval": "بانتظار الموافقة"
    },
    "truncated": "المخرجات مقتطعة",
    "arguments": "المدخلات",
    "result": "الناتج"
  },
  "agents": {
    "empty": "السجلّ فارغ.",
    "install": "تثبيت",
    "remove": "إزالة",
    "restart": "إعادة تشغيل",
    "restart_named": "إعادة تشغيل {name}",
    "restart_done": "تمّت إعادة التشغيل",
    "restart_failed": "تعذّرت إعادة التشغيل",
    "limited": "هذا الوكيل يعمل عبر حزام العمليات وهو محدود.",
    "needs_setup": "يحتاج مزوّدًا أو تسجيل دخول",
    "model_source": {
      "hub": "النماذج: مزوّدو كور هب",
      "agent": "النماذج: حساب الوكيل نفسه"
    },
    "update_available": "تحديث متاح: {version}",
    "under_agent": "تحت الوكيل",
    "status": {
      "available": "متاح",
      "not_installed": "غير مثبّت",
      "installing": "جارٍ التثبيت…",
      "updating": "جارٍ التحديث…",
      "error": "خطأ",
      "limited": "محدود",
      "disabled": "معطّل"
    },
    "capability": {
      "approvals": "موافقات",
      "channels": "قنوات",
      "jobs": "وظائف",
      "kanban": "المهام",
      "mcp": "MCP",
      "memory": "ذاكرة",
      "plugins": "إضافات",
      "resume": "استئناف",
      "skills": "مهارات",
      "streaming": "بث مباشر",
      "tasks": "المهام",
      "tools": "أدوات",
      "worktrees": "أشجار عمل",
      "vision": "رؤية الصور",
      "audio": "صوت",
      "presets": "إعدادات جاهزة",
      "journey": "مسار العمل",
      "compress": "ضغط السياق",
      "steer": "توجيه التشغيل",
      "goals": "أهداف",
      "plans": "خطط",
      "learn": "تعلّم المهارات",
      "skill_commands": "أوامر المهارات",
      "config_files": "ملفات الإعداد"
    },
    "settings_of": "إعدادات {name}",
    "settings_none": "هذا الوكيل لا يعلن أي إعداد.",
    "restart_required": "تغييرها يعيد تشغيل الوكيل.",
    "settings": "الإعدادات",
    "field_hint": {
      "list": "سطر لكل عنصر.",
      "json": "JSON صالح."
    },
    "updates": "التحديثات",
    "version_now": "المثبَّت الآن: {version}",
    "up_to_date": "لا تحديث متاح.",
    "check_update": "ابحث عن تحديث",
    "update_now": "حدّث الآن",
    "auto_update": "تحديث تلقائي",
    "auto_update_hint": "يبحث المركز عن نسخة أحدث كل ست ساعات، ولا يثبّتها إلا والوكيل خامل؛ وأي تشغيل يبدأ أثناء التحديث ينتظره. مطفأ افتراضيًا.",
    "signin_title": "تسجيل الدخول إلى حساب {name}",
    "signin_hint": "يستخدم {name} حسابه الخاص بدل مفتاح مزوّد. تسجيل الدخول هنا يحفظه لكل البروفايلات على هذا المركز.",
    "signin_action": "تسجيل الدخول",
    "signin_approved": "تم تسجيل الدخول. المحادثات الجديدة مع {name} تستخدم هذا الحساب.",
    "version_tested": "النسخة المختبرة: {version}",
    "newer_than_tested": "أحدث من النسخة المختبرة",
    "below_minimum": "نسخة هرمز هذه ({version}) أقدم من {minimum}، أقدم نسخة جرّبها كور هب. ما زال يعمل، لكن قد لا تعمل بعض الميزات حتى يُحدَّث.",
    "update_hermes": "تحديث هرمز",
    "update_hermes_title": "تحديث هرمز المثبّت على هذا الحاسوب؟",
    "update_hermes_body": "سيشغّل كور هب أداة التحديث الخاصة بهرمز (hermes update --yes) على هرمز المثبّت على هذا الحاسوب. يتحدّث بذلك هرمز لكل ما يستخدمه على الحاسوب أيضًا، ثم يُعاد تشغيل هرمز الذي يشغّله كور هب.",
    "newer_than_tested_hint": "هذه النسخة أحدث من التي اختُبر عليها كور هب ({version}). يُتوقّع أن تعمل؛ وإن تعطّل شيء فأخبرنا.",
    "update_available_untested": "تحديث متاح: {version} — أحدث من النسخة المختبرة",
    "hermes_newer_than_tested": "نسخة هرمز هذه ({version}) أحدث من {tested}، النسخة التي اختُبر عليها كور هب. قد لا تكون مدعومة بعد: قد لا تعمل بعض الميزات معها.",
    "hermes_update_available": "هرمز {version} متاح (على هذا الحاسوب {current}).",
    "hermes_update_tested": "اختُبر كور هب على هذه النسخة.",
    "hermes_update_untested": "لم يُختبر كور هب على هذه النسخة بعد (اختُبر على {tested})؛ قد لا تعمل بعض الميزات معها.",
    "tools": {
      "not_supervised": "هذا المركز لا يشغّل هرمز بنفسه، فلا يستطيع أن يطلب منه هذا.",
      "refused": "رفض هرمز: {message}",
      "api_unavailable": "لم تُجب واجهة هرمز: {message}",
      "profile_absent": "لا يوجد في هرمز بروفايل باسم {profile} بعد، فلا ملفات له تُعرض هنا.",
      "runtime_absent": "هرمز غير مثبّت أو غير مشغّل هنا، فلا مجلد يُقرأ."
    },
    "sections": "أقسام {name}",
    "open_section": "{section} · {name}",
    "not_found": "لا وكيل بهذا المعرّف في هذا البروفايل.",
    "gateways": {
      "title": "بوابات الرسائل",
      "default": "البروفايل الافتراضي",
      "no_channels": "بلا قنوات",
      "state": {
        "running": "تعمل",
        "starting": "تُقلع",
        "stopped": "متوقّفة",
        "error": "متعطّلة"
      },
      "jobs_n": "المهام المجدولة: {count}"
    },
    "applies_next_message": "تسري من الرسالة التالية.",
    "saved": "حُفظ.",
    "saved_next_message": "حُفظ في إعدادات هرمز، ويسري من الرسالة التالية.",
    "saved_restart_needed": "حُفظ في إعدادات هرمز، ويسري بعد إعادة تشغيله.",
    "saved_restarting": "حُفظ، ويُعاد تشغيل هرمز الآن ليسري.",
    "default_is": "الافتراضي في هرمز: {value}",
    "default_none": "لا شيء",
    "default_on": "يعمل",
    "default_off": "متوقف",
    "use_default": "افتراضي هرمز ({value})",
    "pending": {
      "title": "بانتظار المراجعة",
      "subtitle": "ما كتبه الوكيل في ذاكرته أو مهاراته ولم يُحفظ بعد",
      "empty": "لا شيء بانتظار المراجعة.",
      "kind_memory": "ذاكرة الوكيل",
      "kind_user": "ما يعرفه عنك",
      "kind_skill": "مهارة",
      "origin_review": "مراجعة هرمز الذاتية",
      "origin_chat": "أثناء محادثة",
      "approve": "موافقة",
      "reject": "رفض"
    }
  },
  "jobs": {
    "status": {
      "queued": "في الطابور",
      "running": "يعمل…",
      "succeeded": "تم",
      "failed": "فشل",
      "cancelled": "أُلغي"
    }
  },
  "settings": {
    "tools": "الأدوات",
    "back": "العودة إلى الإعدادات",
    "global_note": "هذه الشاشة على مستوى المركز كله، خارج البروفايل الحالي.",
    "management": "الإدارة",
    "management_hint": "ما يُضبط مرة واحدة: صفحات كاملة، لا تبويبات.",
    "about": {
      "agent_manager": "تثبيت الوكلاء وتحديثها وإعداد كل واحد",
      "models": "المزوّدون ومفاتيحهم والنماذج والصوت",
      "device_connections": "ربط الهاتف والأجهزة الموثوقة",
      "knowledge": "اليوميات والملاحظات والملفات"
    }
  },
  "account": {
    "username": "اسم المستخدم",
    "display_name": "الاسم المعروض",
    "role": "الدور",
    "workspaces": "البروفايلات",
    "field": "الحقل",
    "value": "القيمة",
    "password": "كلمة المرور",
    "password_hint": "ستبقى مسجّلًا دخولك على هذا الجهاز، وسيُسجَّل خروجك من بقية أجهزتك.",
    "current_password": "كلمة المرور الحالية",
    "new_password": "كلمة المرور الجديدة",
    "confirm_password": "تأكيد كلمة المرور الجديدة",
    "password_mismatch": "كلمتا المرور الجديدتان غير متطابقتين.",
    "password_changed": "تغيّرت كلمة المرور، وسُجّل خروجك من بقية أجهزتك.",
    "change_password": "تغيير كلمة المرور"
  },
  "roles": {
    "owner": "المالك",
    "admin": "مشرف",
    "member": "عضو"
  },
  "display": {
    "theme": {
      "label": "السمة",
      "system": "النظام",
      "light": "فاتحة",
      "dark": "داكنة"
    },
    "glass": {
      "0": "صلب",
      "1": "خفيف",
      "2": "متوسط",
      "3": "كامل",
      "label": "شدة الزجاج",
      "hint": "تؤثر الشفافية والتمويه في العناصر العائمة فقط؛ يبقى محتوى الصفحات واضحًا."
    },
    "language": "اللغة",
    "text_scale": "حجم النص",
    "local_only": "محفوظ على هذا الجهاز فقط؛ تعذّر حفظ التفضيل في المركز.",
    "reasoning": {
      "label": "إظهار تفكير الوكيل",
      "hint": "تظهر مدة التفكير فوق الرد، ويمكن توسيع القسم لقراءة تفاصيله."
    }
  },
  "theme": {
    "intro": "اختر مظهر التطبيق على هذا الجهاز. يمكنك تغييره أيضًا من القائمة الجانبية.",
    "reduced_note": "إن طلب نظامك تقليل الشفافية أو الحركة، يحترم التطبيق ذلك تلقائيًا."
  },
  "devices": {
    "pair_intro": "لإقران هاتفك، امسح رمز QR بتطبيق كور هب أو أدخل الرمز يدويًا. تنتهي صلاحية الرمز بعد خمس دقائق.",
    "pair": "إقران جهاز",
    "pair_again": "إقران جديد",
    "expires_in": "ينتهي بعد {seconds} ث",
    "pairing_expired": "انتهت صلاحية رمز الإقران. ابدأ إقرانًا جديدًا.",
    "pairing_cancelled": "أُلغي الإقران.",
    "pair_link": "على حاسوب فيه تطبيق كور هب افتح هذا الرابط هناك، أو الصقه في التطبيق:",
    "copy_link": "نسخ الرابط",
    "copied": "نُسخ",
    "list_empty_title": "لا أجهزة بعد",
    "list_empty_body": "اقرن جوالًا أو حاسوبًا من الأعلى، أو فعّل إشعارات المتصفح من الإعدادات ← الإشعارات.",
    "never_seen": "لا نشاط بعد",
    "online": "متصل",
    "this_browser": "هذا المتصفح",
    "this_device": "هذا الجهاز",
    "owner_other": "لشخص آخر",
    "rename": "إعادة التسمية",
    "rename_title": "تسمية الجهاز",
    "name_label": "الاسم",
    "revoke": "إزالة",
    "revoke_title": "إزالة {name}؟",
    "revoke_body": "لن تصله الإشعارات بعد الآن. والتطبيق المقترن يُسجَّل خروجه ويحتاج إلى إقران جديد.",
    "test_push": "إرسال تجربة",
    "test_sent": "أُرسل. سيظهر على الجهاز خلال لحظات.",
    "test_failed": "لم يصل: {error}",
    "kind": {
      "phone": "هاتف",
      "tablet": "جهاز لوحي",
      "computer": "حاسوب",
      "browser": "متصفح"
    },
    "push": {
      "title": "مرسِلات الإشعارات",
      "intro": "Web Push (المتصفحات وتطبيق سطح المكتب) يعمل دون أي إعداد. أما أندرويد (FCM) وآيفون (APNs) فيحتاجان إلى بيانات اعتماد المالك.",
      "provider": {
        "webpush": "Web Push",
        "fcm": "FCM (أندرويد)",
        "apns": "APNs (آيفون)"
      },
      "state": {
        "ready": "جاهز",
        "disabled": "موقوف",
        "not_configured": "غير مُعدّ",
        "error": "خطأ"
      },
      "source": {
        "generated": "مفاتيح صنعها المركز",
        "environment": "من متغيرات البيئة",
        "settings": "من الإعدادات",
        "relay": "عبر مرحّل كور هب",
        "none": "لا شيء"
      },
      "devices": "الأجهزة: {count}",
      "set_up": "إعداد",
      "change": "تغيير",
      "form": {
        "fcm_intro": "من Firebase Console ← إعدادات المشروع ← حسابات الخدمة ← إنشاء مفتاح خاص جديد. الصق ملف JSON كاملًا.",
        "apns_intro": "من Apple Developer ← Certificates, IDs & Profiles ← Keys: مفتاح مفعّل فيه Apple Push Notifications service (APNs).",
        "enabled": "الإرسال عبر هذه الخدمة",
        "service_account": "ملف حساب الخدمة (JSON)",
        "service_account_hint": "يُحفظ مشفّرًا ولا يُعرض مرة أخرى.",
        "secret_kept": "اتركه فارغًا لإبقاء المحفوظ.",
        "key_id": "معرّف المفتاح (Key ID)",
        "team_id": "معرّف الفريق (Team ID)",
        "bundle_id": "معرّف حزمة التطبيق (Bundle ID)",
        "environment": "البيئة",
        "production": "الإنتاج",
        "sandbox": "التجربة (نسخ التطوير)",
        "private_key": "مفتاح ‎.p8",
        "private_key_hint": "محتوى الملف AuthKey_….p8. يُحفظ مشفّرًا ولا يُعرض مرة أخرى.",
        "forget": "حذف المحفوظ",
        "refused": "رفضه المركز: {detail}",
        "drop_here": "أو أفلت الملف هنا",
        "paste_instead": "اللصق بدلًا من ذلك",
        "paste_hide": "إخفاء حقل النص",
        "fcm_upload": "رفع ملف حساب الخدمة (JSON)",
        "fcm_ok": "حساب خدمة للمشروع {project}.",
        "fcm_not_json": "هذا الملف ليس JSON. اختر مفتاح حساب الخدمة الذي نزّلته من Firebase.",
        "fcm_google_services": "هذا ملف google-services.json الخاص بتطبيق أندرويد نفسه. المركز يحتاج مفتاح حساب خدمة: من Firebase Console ← إعدادات المشروع ← حسابات الخدمة ← إنشاء مفتاح خاص جديد.",
        "fcm_not_service_account": "هذا الـJSON ليس مفتاح حساب خدمة. أنشئ واحدًا من Firebase Console ← إعدادات المشروع ← حسابات الخدمة.",
        "fcm_missing": "ينقص حساب الخدمة هذا type أو project_id أو client_email أو private_key. نزّل مفتاحًا جديدًا من Firebase.",
        "apns_upload": "رفع ملف AuthKey_….p8",
        "apns_ok": "قُرئ المفتاح، وأُخذ معرّفه (Key ID) من اسم الملف.",
        "apns_not_a_key": "هذا ليس مفتاح ‎.p8: يجب أن يبدأ بـ -----BEGIN PRIVATE KEY-----.",
        "apns_not_p8": "هذا ليس ملف ‎.p8. تتيح Apple تنزيله مرة واحدة باسم AuthKey_<Key ID>.p8."
      },
      "manage": "إدارة",
      "hide": "إخفاء",
      "env_title": "أو اضبطه بمتغيرات البيئة",
      "env_body": "متغيرات البيئة في المركز تتقدّم على ما يُحفظ هنا. القائمة كاملة في",
      "saved": "محفوظ",
      "saved_project": "المشروع {project}",
      "saved_key": "مفتاح ينتهي بـ …{ending}",
      "saved_team": "الفريق {team}",
      "saved_incomplete": "حُفظ، لكنه لم يكتمل بعد: افتحه مرة أخرى لإكمال الناقص.",
      "valid": {
        "fcm": "حُفظ. ملف حساب الخدمة يبدو سليمًا؛ وأول إشعار يُثبت ذلك مع Google.",
        "apns": "حُفظ. المفتاح يبدو سليمًا (وقّع رمزًا تجريبيًا)؛ وأول إشعار يُثبت ذلك مع Apple."
      }
    },
    "pair_heading": "إقران جوال أو حاسوب",
    "list_title": "أجهزتك",
    "list_title_admin": "الأجهزة",
    "group": {
      "mobile": "الجوالات والأجهزة اللوحية",
      "computer": "الحواسيب",
      "browser": "المتصفحات"
    },
    "last_active": "آخر نشاط",
    "paired_on": "أُقرن في {date}",
    "added_on": "أُضيف في {date}",
    "just_paired": "أُقرن الآن",
    "os": {
      "android": "أندرويد",
      "ios": "iOS",
      "ipados": "iPadOS",
      "macos": "macOS",
      "windows": "ويندوز",
      "linux": "لينكس"
    },
    "push_state": {
      "on": "الإشعارات تعمل · {provider}",
      "not_in_build": "الإشعارات غير متاحة في هذه النسخة من التطبيق",
      "permission_pending": "بانتظار السماح بالإشعارات",
      "permission_denied": "الإشعارات مطفأة في الجهاز",
      "no_sender": "الإشعارات متوقفة: لا مرسِل {provider} في هذا المركز بعد",
      "off": "الإشعارات متوقفة"
    },
    "push_set_up": "إعداد الإشعارات",
    "pair_through_relay": "سيصل الجوال إلى هذا المركز بالعنوان {url} (الوصول من خارج البيت، في «هذا الجهاز»)."
  },
  "placeholder": {
    "later": "{name} يصل مع وحدته في المرحلة {phase}. لا شيء مخفي هنا.",
    "agent": "الوكيل {id}"
  },
  "models": {
    "tab": {
      "general": "المزوّدون",
      "auxiliary": "الافتراضيات",
      "ensembles": "الفِرَق",
      "stt_providers": "تحويل الكلام إلى نص",
      "tts_providers": "تحويل النص إلى كلام",
      "images": "الصور"
    },
    "providers": {
      "hint": "المزوّدون الذين أضفتهم. المشترك يُضاف مرة واحدة ويستخدمه كل بروفايل، ومزوّد البروفايل الخاص يُستخدم في ذلك البروفايل وحده بدل المشترك من النوع نفسه.",
      "none": "لم تُضف أي مزوّد بعد. أضف مزوّدًا لعرض نماذجه."
    },
    "provider": {
      "key": "مفتاح الواجهة",
      "key_hint": "ألصِق المفتاح",
      "key_stored": "‏المفتاح محفوظ — ألصق مفتاحًا جديدًا لاستبداله",
      "save_key": "حفظ المفتاح",
      "clear_key": "إزالة المفتاح",
      "configured": "المفتاح محفوظ",
      "not_configured": "بلا مفتاح",
      "no_key_needed": "لا يحتاج مفتاحًا",
      "test": "اختبار",
      "testing": "جارٍ اختبار الاتصال بالمزوّد…",
      "refresh": "تحديث النماذج",
      "enabled": "مُفعَّل",
      "remove": "إزالة",
      "add": "إضافة مزوّد",
      "label": "الاسم",
      "base_url": "عنوان الواجهة",
      "model_count": "‏النماذج: {count}",
      "key_optional": "المفتاح اختياري",
      "confirm_remove": "حذف مزوّد «{label}»؟",
      "confirm_remove_body": "يُحذف مفتاحه وقائمة نماذجه معه، ولا رجوع.",
      "scope_shared": "مشترك",
      "scope_only": "‏⁨{profile}⁩ فقط"
    },
    "defaults": {
      "hint": "حدّد نموذجي المحادثة والبرمجة لهذا البروفايل. يستخدمهما وكلاؤه ما لم تضبط لهم نموذجًا آخر. وتُورث الاختيارات غير المحددة من البروفايل الافتراضي.",
      "chat": "المحادثة",
      "none": "لم يُختَر",
      "inherited": "من البروفايل الافتراضي",
      "no_models": "لا نماذج بعد. أضف مفتاح مزوّد ويجلب المركز قائمة نماذجه.",
      "inheriting": "الوكلاء الذين يرثون هذه",
      "inheriting_hint": "ما سيستخدمه كل وكيل حين لا تسمّي المحادثة نموذجًا.",
      "fallbacks": "النماذج الاحتياطية",
      "fallbacks_hint": "تُجرَّب هذه النماذج بالترتيب إذا تعطل المزوّد الأساسي أو بلغ حد الطلبات أو لم يستجب. لا تُجرَّب إذا رفض المزوّد الطلب لأنه غير صالح. تنطبق على جميع وكلاء هذا البروفايل.",
      "fallbacks_empty": "لا نماذج احتياطية: إذا فشل مزوّد نموذج المحادثة فشل الدور.",
      "fallbacks_need_default": "اختر نموذج المحادثة أولًا؛ النماذج الاحتياطية تُجرَّب بعده.",
      "fallback_add": "أضف نموذجًا احتياطيًا",
      "fallback_reorder": "اسحب لترتيب {model} (المسافة للإمساك، والأسهم للتحريك)",
      "fallback_instructions": "لترتيب نموذج احتياطي: اضغط المسافة أو Enter على مقبضه، وحرّكه بالأسهم، ثم اضغط المسافة أو Enter مرة أخرى لإفلاته. Escape يعيده مكانه.",
      "fallback_picked": "أمسكت {model}، في المكان {position} من {total}.",
      "fallback_moved": "{model} الآن في المكان {position} من {total}.",
      "fallback_dropped": "أُفلت {model} في المكان {position} من {total}.",
      "fallback_cancelled": "أُلغي الترتيب؛ عاد {model} إلى المكان {position} من {total}.",
      "fallback_remove": "احذف {model}"
    },
    "ensembles": {
      "hint": "تُنشأ الفِرَق عبر الواجهة البرمجية حاليًا؛ هذا التبويب يصل مع شاشات الغرف."
    },
    "test": {
      "ok": "استجاب المزوّد.",
      "http_error": "أجاب المزوّد بخطأ."
    },
    "refresh_all": "تحديث قائمة النماذج",
    "more_models": "+{count} أخرى",
    "row": {
      "provider": "المزوّد",
      "models": "النماذج"
    },
    "badge": {
      "builtin": "جاهز",
      "custom": "مخصّص",
      "default": "الافتراضي الحالي",
      "disabled": "موقوف"
    },
    "action": {
      "set_default": "اجعله المزوّد الافتراضي",
      "display_names": "أسماء العرض",
      "visible_models": "النماذج الظاهرة",
      "edit": "تعديل",
      "clear_credentials": "مسح المفتاح"
    },
    "panel": {
      "model": "النموذج",
      "alias": "اسم العرض",
      "visible": "ظاهر",
      "alias_for": "اسم العرض لـ {model}",
      "visible_for": "أظهر {model} في القوائم",
      "no_models": "لا نماذج بعد. حدّث قائمة النماذج أولًا.",
      "done": "تم",
      "visibility": "النماذج الظاهرة",
      "visibility_all": "كل النماذج",
      "visibility_all_hint": "وأي نموذج يضيفه المزوّد لاحقًا.",
      "visibility_include": "المختارة فقط",
      "visibility_include_hint": "اختر من الجدول بالأسفل.",
      "caption": "نماذج {provider}",
      "alias_saved": "حُفظ الاسم المعروض."
    },
    "add": {
      "type": "نوع المزوّد",
      "type_preset": "جاهز",
      "type_custom": "مخصّص",
      "select_provider": "اختر المزوّد",
      "where_key": "من أين تحصل على مفتاح",
      "key_required": "مفتاح الواجهة",
      "key_optional": "مفتاح الواجهة (اختياري)",
      "show_key": "إظهار",
      "hide_key": "إخفاء",
      "default_model": "النموذج الافتراضي",
      "model_placeholder": "اجلب القائمة أولًا",
      "fetch": "اجلب",
      "fetching": "جارٍ سؤال المزوّد…",
      "fetched": "تم جلب النماذج: {count}.",
      "fetch_failed": "لم يُرجِع المزوّد قائمة نماذج.",
      "fetch_empty": "أجاب المزوّد لكنه لم يذكر أي نموذج.",
      "submit": "أضف",
      "loopback": "هذا العنوان محلّي (loopback) والمركز يعمل داخل حاوية — سيصل إلى الحاوية نفسها لا إلى جهازك. جرّب {url}، وعلى مضيف لينكس أضف extra_hosts: [\"host.docker.internal:host-gateway\"] إلى الحزمة.",
      "scope": "لمن هذا المزوّد؟",
      "scope_all": "كل البروفايلات",
      "scope_profile": "هذا البروفايل فقط",
      "scope_all_hint": "مشترك: يستخدمه كل بروفايل، ومنها البروفايلات التي تُنشأ لاحقًا.",
      "scope_profile_hint": "يستخدمه ⁨{profile}⁩ وحده، ومفتاحه يغلب هناك المزوّد المشترك من النوع نفسه. لا تراه البروفايلات الأخرى.",
      "kind": "نوعه",
      "kind_llm": "محادثة",
      "kind_stt": "تحويل كلام إلى نص",
      "kind_tts": "تحويل نص إلى كلام",
      "sign_in_hint": "هذا المزوّد يُستخدم بتسجيل الدخول إلى حسابك لا بمفتاح. أضفه ثم سجّل الدخول من بطاقته.",
      "key_on_file": "لحساب هذا المزوّد مفتاح محفوظ هنا؛ يُستعمل ما لم تكتب غيره.",
      "subscription_badge": "اشتراك",
      "group_subscriptions": "الاشتراكات",
      "group_keys": "بمفتاح API",
      "hermes_sign_in_detail": "تسجيل دخول برمز قصير عبر هرمز · لهرمز ووكيل كور هب نفسه"
    },
    "runtime": {
      "title": "وقت التشغيل",
      "hint": "تحقّق من وصول إعدادات هذا البروفايل إلى بيئة تشغيل الوكيل.",
      "runtime_writable": {
        "ok": "‏المركز يدير وقت تشغيل الوكيل.",
        "missing": "‏لا يوجد وقت تشغيل يستطيع المركز ضبطه."
      },
      "provider_keys": {
        "ok": "‏مفاتيح المزوّدين موجودة في بيئة وقت التشغيل.",
        "missing": "‏مفتاح مزوّد لم يصل إلى وقت التشغيل."
      },
      "provider_verified": {
        "ok": "‏كل مزوّد أجاب على آخر فحص له.",
        "missing": "‏رفض أحد المزوّدين آخر فحص — افتحه وأصلِح المفتاح."
      },
      "model_selected": {
        "ok": "‏تم اختيار نموذج محادثة لوقت التشغيل.",
        "missing": "‏لا يوجد نموذج محادثة مختار — اختر واحدًا من الافتراضيات."
      },
      "gateway_reloaded": {
        "ok": "‏أُعيد تشغيل وقت التشغيل بعد آخر تغيير.",
        "missing": "لم يُعِد هرمز التشغيل بعد آخر تغيير. أعِد تشغيله لتطبيق الإعدادات.",
        "scheduled": "جارٍ تطبيق التغيير — يُعاد تشغيل هرمز تلقائيًا بعد لحظات.",
        "waiting_for_run": "جارٍ تطبيق التغيير — يُعاد تشغيل هرمز تلقائيًا بعد انتهاء الرد الجاري."
      },
      "ready": "وقت التشغيل جاهز · الفحوص {passed}/{total}",
      "passed": "نجح {passed} من {total} فحوص",
      "restart_now": "إعادة التشغيل الآن"
    },
    "speech": {
      "active_stt": "تحويل الكلام إلى نص في هذا البروفايل",
      "active_tts": "تحويل النص إلى كلام في هذا البروفايل",
      "hint_stt": "تُرسل التسجيلات من ميكروفون مربع الكتابة والوضع الصوتي إلى هذا المزوّد لتحويل كلامك إلى نص.",
      "hint_tts": "يستخدم زر قراءة الردود والقراءة التلقائية والوضع الصوتي هذا المزوّد لتحويل النص إلى كلام.",
      "provider": "المزوّد",
      "none": "لا شيء",
      "model": "النموذج",
      "voice": "الصوت",
      "voice_hint": "معرّف الصوت عند المزوّد، مثل alloy",
      "language": "اللغة (اختياري)",
      "save": "حفظ",
      "saved": "حُفظ.",
      "ready": "جاهز",
      "not_ready": "غير جاهز",
      "try": "معاينة",
      "try_failed": "تعذّر تشغيل الصوت: {detail}",
      "add_hint": "أضف Groq أو OpenAI (يأتي معهما صفّا الكلام بالمفتاح نفسه)، أو ElevenLabs أو Deepgram أو Azure Speech، أو خادم كلام متوافقًا مع OpenAI خاصًا بك من «إضافة مزوّد» ← مخصّص.",
      "add_stt": "أضف مزوّد تحويل الكلام إلى نص",
      "add_tts": "أضف مزوّد تحويل النص إلى كلام",
      "none_stt": "لا مزوّد لتحويل الكلام إلى نص بعد. للصوت عادةً مزوّدون خاصون به؛ أضف واحدًا من هنا.",
      "none_tts": "لا مزوّد لتحويل النص إلى كلام بعد. للصوت عادةً مزوّدون خاصون به؛ أضف واحدًا من هنا.",
      "custom_value": "مكتوب يدويًا",
      "custom_group": "مكتوب يدويًا",
      "model_pick": "اختر نموذجًا",
      "model_id": "معرّف النموذج",
      "model_custom": "…أو اكتب معرّف نموذج",
      "language_auto": "اكتشاف تلقائي",
      "lang_popular": "اللغات الأشهر",
      "lang_all": "كل اللغات",
      "lang_all_count": "كل اللغات ({count} صوتًا)",
      "language_stt": "لغة الكلام (تُكتشف تلقائيًا إن تُركت فارغة)",
      "language_tts": "اللغة (اختياري)",
      "language_code": "رمز اللغة",
      "language_custom": "…أو اكتب رمزًا، مثل ar-EG",
      "gender_female": "أنثى",
      "gender_male": "ذكر",
      "gender_neutral": "محايد",
      "any_language": "أي لغة",
      "voice_language": "لغة الصوت",
      "voice_pick": "اختر صوتًا",
      "voice_id": "معرّف الصوت",
      "voices_loading": "نسأل المزوّد عن أصواته…",
      "voices_documented": "من وثائق المزوّد: ليس له قائمة أصوات تُسأل.",
      "voices_none": "هذا المزوّد لا يعرض أصواتًا: اكتب معرّف الصوت.",
      "sample": "لغة المعاينة",
      "sample_ar": "مرحبًا، هكذا ستُقرأ الردود بهذا الصوت.",
      "sample_en": "Hello, this is how replies will sound in this voice."
    },
    "signin": {
      "signed_in": "تم تسجيل الدخول",
      "signed_out": "لم يُسجَّل الدخول",
      "action": "سجّل الدخول",
      "again": "سجّل الدخول من جديد",
      "title": "تسجيل الدخول إلى {provider}",
      "steps": "افتح صفحة الدخول، وسجّل الدخول إلى حسابك هناك، وأدخل هذا الرمز:",
      "open": "افتح صفحة الدخول",
      "code": "الرمز",
      "copy": "انسخ الرمز",
      "waiting": "بانتظار موافقتك في صفحة المزوّد…",
      "approved": "تم تسجيل الدخول. نجلب نماذجه الآن.",
      "denied": "رُفض تسجيل الدخول.",
      "expired": "انتهت صلاحية الرمز قبل استخدامه.",
      "failed": "لم يكتمل تسجيل الدخول.",
      "retry": "ابدأ من جديد",
      "close": "إغلاق",
      "link_steps": "افتح صفحة الدخول وسجّل الدخول إلى حسابك. بعدها ينتقل المتصفح إلى عنوان قد لا يفتح — انسخ ذلك العنوان كاملًا من شريط العنوان والصقه هنا.",
      "paste_label": "العنوان الذي وصل إليه المتصفح",
      "paste_hint": "يبدأ بـ {start}",
      "paste_hint_any": "الصق العنوان كاملًا من شريط عنوان المتصفح.",
      "paste_submit": "أكمل الدخول"
    },
    "images": {
      "hint": "النموذج الذي يرسم به هذا البروفايل الصور ويعدّلها. يأتي من مزوّدي المحادثة عندك — لا مزوّدو صور منفصلون. البروفايل الذي لا يختار يستخدم اختيار البروفايل الافتراضي.",
      "model": "نموذج الصور",
      "none": "لا يقدّم أيٌّ من مزوّدي المحادثة عندك نموذج صور.",
      "none_hint": "أضف مزوّدًا فيه نموذج صور أو حدّث قائمته — مثل وسيط يقدّم gemini-3.1-flash-image، أو OpenAI مع gpt-image، أو اشتراك ChatGPT مسجَّل الدخول — فيظهر هنا.",
      "to_providers": "اذهب إلى المزوّدين",
      "clear": "استخدم اختيار البروفايل الافتراضي",
      "used_by": "أداة الصور في هرمز ومهارات الصور (التوليد، والتعديل، وإزالة الخلفية) تستخدم هذا النموذج بمفتاح مزوّده. لا شيء آخر يُضبط.",
      "via_subscription": "الصور عبر اشتراك {provider} ({model} من خلال نموذج المحادثة)"
    },
    "catalogue": {
      "fallback": "هذه قائمة احتياطية محفوظة في الكود، لا قائمة المزوّد نفسه: تعذّر سؤال المزوّد ({reason}). حدّثها حين يمكن سؤاله.",
      "from_account": "هذه النماذج التي تقدّمها خطتك في {provider}، كما يعرضها المزوّد لحسابك."
    },
    "subscription": {
      "intro": "استخدم اشتراكًا تدفع له أصلًا. يسجّل Core Hub الدخول إليه، وتعمل نماذجه مع كل الوكلاء.",
      "unavailable": "لا يمكن الدخول بالاشتراكات في هذا المركز: {reason}",
      "flow_device": "دخول برمز قصير — يعمل من الجوال أو الخادم",
      "flow_link": "دخول برابط، ثم لصق العنوان",
      "has_windows": "يعرض الاستهلاك ومواعيد التصفير",
      "continue": "متابعة للدخول",
      "legacy": "مسجَّل الدخول عبر Hermes (الطريقة القديمة). يمكن لبوابة Core Hub أن تحمل هذا الدخول بدلًا منه.",
      "move": "انقله إلى بوابة Core Hub",
      "move_title": "نقل {provider} إلى بوابة Core Hub",
      "move_body": "ستحمل بوابة Core Hub هذا الاشتراك، وتعرض حساباته واستهلاكه، وتعطي نماذجه لكل الوكلاء. اختيارات النماذج التي تستخدمه تنتقل بعد أن تسجّل الدخول.",
      "move_no_copy": "لا يمكن نسخ الدخول من Hermes، لذا تسجّل الدخول مرة أخرى. الدخول الحالي يبقى يعمل حتى تحذفه.",
      "move_start": "سجّل الدخول عبر البوابة",
      "move_done": "تم الدخول. يمكنك حذف مزوّد {provider} القديم متى شئت.",
      "gemini_desktop_scope": "يرد Gemini Desktop بالنص فقط، فلا يستخدمه إلا الوكيل المباشر في كور هب — لا Hermes ولا وكلاء البرمجة. وكل محادثة في كور هب تبقى محادثة واحدة في سجل Gemini.",
      "gemini_desktop_unofficial": "يستخدم هذا دخول تطبيق Gemini للكمبيوتر وخدمته، ولا تتيحهما Google لتطبيقات أخرى؛ وقد تغيّرهما Google أو تحدّ منهما في أي وقت."
    },
    "accounts": {
      "title": "الحسابات",
      "open": "الحسابات والاستهلاك",
      "count": "{count} (الجاهز {ready})",
      "description": "الحسابات المسجَّلة تحت هذا الاشتراك، واستهلاكها، وآخر أخطائها.",
      "reload": "تحديث",
      "add_account": "سجّل دخول حساب آخر",
      "unavailable": "تعذّر سؤال البوابة: {reason}",
      "none": "لا حساب مسجَّل بعد.",
      "errors": "آخر الأخطاء",
      "status": {
        "active": "يعمل",
        "cooling": "ينتظر",
        "error": "يفشل",
        "disabled": "متوقف",
        "refreshing": "يُجدَّد",
        "unknown": "غير معروف"
      },
      "enabled": "مفعّل",
      "retry_at": "يُعاد تجربته",
      "no_windows": "هذا المزوّد لا يذكر نوافذ استهلاك.",
      "no_windows_check": "لم يُرَ استهلاك بعد. استخدم «افحص الآن» لسؤال المزوّد.",
      "limit_reached": "المزوّد يقول إن حدّ هذا الحساب انتهى.",
      "check_failed": "«افحص الآن» لم يقرأ شيئًا: {reason}",
      "requests": "{success} أُجيب · {failed} فشل",
      "buckets": "الطلبات في آخر 3 ساعات و20 دقيقة، 10 دقائق لكل عمود",
      "last_refresh": "جُدِّد الدخول",
      "email": "البريد",
      "check": "افحص الآن",
      "renew": "جدّد الدخول",
      "remove": "سجّل الخروج",
      "remove_confirm": "تسجيل خروج {account}؟",
      "remove_body": "يُحذف الحساب من Core Hub. جلستك عند المزوّد لا تُلغى؛ يمكنك إلغاؤها من موقع المزوّد.",
      "left": "المتبقي {percent}%",
      "resets": "يُصفَّر",
      "checked": "فُحص",
      "observed": "من آخر إجابة"
    }
  },
  "working_dir": {
    "label": "مجلد العمل",
    "hint": "أين تعمل هذه المحادثة على القرص.",
    "automatic": "مجلد تلقائي",
    "automatic_note": "ينشئه المركز باسم المحادثة",
    "new": "مجلد جديد",
    "new_placeholder": "اسم مجلد جديد",
    "create": "إنشاء",
    "locked": "المجلد يثبت بعد أول تشغيل.",
    "button": "المجلد: {name}"
  },
  "combobox": {
    "search": "ابحث…",
    "recent": "المستعملة أخيرًا",
    "loading": "جارٍ تحميل القائمة…",
    "unfetched": "اجلب القائمة أولًا.",
    "none": "لا نماذج في هذه القائمة.",
    "no_match": "لا نتيجة لـ«{query}».",
    "error": "تعذّر جلب القائمة.",
    "count": "النماذج: {count}",
    "all": "الكل"
  },
  "ui": {
    "close": "إغلاق",
    "dismiss": "إخفاء الإشعار",
    "breadcrumb": "مسار التنقل"
  },
  "queue": {
    "title": "رسائل في الانتظار",
    "send_now": "أرسلها الآن",
    "steer": "توجيه",
    "steer_hint": "أوقف الدور الجاري وخُذ هذه بدله، في السياق نفسه.",
    "remove": "إزالة"
  },
  "tasks": {
    "project": "المشروع",
    "count": "المهام: {count}",
    "new_task": "مهمة جديدة",
    "new_task_in": "مهمة جديدة في {name}",
    "add": "أضف",
    "no_projects": "لا مشروع بعد",
    "no_projects_body": "تُنظَّم المهام داخل مشاريع. أنشئ مشروعًا للبدء.",
    "new_project": "مشروع جديد",
    "project_name": "اسم المشروع",
    "rename": "إعادة التسمية",
    "title_label": "عنوان المهمة",
    "reorder": "أعد ترتيب {title}",
    "more": "المزيد لـ {title}",
    "move_to": "انقل إلى {column}",
    "blocked_why": "ما الذي يوقفها؟",
    "reason": "السبب",
    "confirm_delete": "حذف «{title}»؟",
    "confirm_delete_body": "لا يمكن التراجع عن هذا.",
    "status": {
      "triage": "واردة",
      "todo": "للعمل",
      "ready": "جاهزة",
      "scheduled": "مجدولة",
      "running": "تعمل",
      "blocked": "متعثّرة",
      "review": "للمراجعة",
      "done": "مكتملة",
      "archived": "مؤرشفة"
    },
    "priority": {
      "urgent": "عاجلة",
      "high": "مرتفعة",
      "normal": "عادية",
      "low": "منخفضة"
    },
    "columns": {
      "queue": "قائمة التنفيذ",
      "waiting": "بانتظار إجراء",
      "review": "قيد المراجعة",
      "done": "مكتملة"
    },
    "intake_hint": "تُحدَّد تفاصيل المهام الواردة هنا قبل نقلها إلى قائمة التنفيذ.",
    "nothing": "لا شيء",
    "which_waiting": "ما الذي تنتظره هذه المهمة؟",
    "action": {
      "promote": "جاهزة",
      "archive": "أرشفة",
      "schedule": "جدولة",
      "block": "وضعها في حالة تعثّر",
      "unblock": "إزالة حالة التعثّر",
      "requestReview": "للمراجعة",
      "reopenReview": "أعد فتحها",
      "complete": "إكمال المهمة",
      "queue": "إلى قائمة التنفيذ"
    },
    "confirm": {
      "archive": "أرشفة «{title}»؟"
    },
    "all_projects": "كل المشاريع",
    "hermes": {
      "origin": "على لوحة هرمز",
      "refused": "رفض هرمز: {message}",
      "owns_text": "هذه البطاقة على لوحة هرمز، وهذا المركز لا يشغّل هرمز هنا، فعنوانها ووصفها يغيّرهما هرمز.",
      "owns_card": "هذه البطاقة على لوحة هرمز، وهذا المركز لا يشغّل هرمز هنا، فهرمز هو من يقرر ما يحدث لها.",
      "writes_through": "هذه البطاقة على لوحة هرمز: كل تعديل يُجرى على هرمز أولًا.",
      "api_unavailable": "واجهة هرمز غير متاحة الآن، فلم يتغيّر شيء: {message}",
      "confirm_delete_body": "تُحذف من لوحة هرمز أيضًا، ولا يمكن التراجع عن هذا.",
      "history": {
        "title": "في هرمز",
        "runs": "المحاولات",
        "events": "ما جرى",
        "no_runs": "لم يعمل هرمز عليها بعد.",
        "no_events": "لم يُسجَّل شيء بعد.",
        "attempt": "المحاولة {id}",
        "event": {
          "created": "أُنشئت",
          "assigned": "أُسندت",
          "claimed": "التقطها عامل",
          "spawned": "بدأ العامل",
          "heartbeat": "العامل ما زال يعمل",
          "completed": "اكتملت",
          "blocked": "تعطّلت",
          "unblocked": "زال التعطّل",
          "commented": "تعليق",
          "edited": "عُدّلت",
          "reprioritized": "تغيّرت الأولوية",
          "status": "نُقلت",
          "archived": "أُرشفت",
          "reclaimed": "استُعيدت من عاملها",
          "timed_out": "انتهت المهلة",
          "review_requested": "أُرسلت للمراجعة",
          "review_reopened": "أُعيد فتحها بعد المراجعة",
          "changes_requested": "طُلبت تعديلات",
          "scheduled": "جُدولت",
          "promoted": "رُقّيت",
          "promoted_manual": "رُقّيت يدويًا",
          "gave_up": "توقّفت المحاولات",
          "attached": "أُرفق ملف",
          "linked": "رُبطت",
          "unlinked": "فُكّ ربطها",
          "specified": "حُدّدت تفاصيلها"
        },
        "run": {
          "running": "تعمل",
          "done": "منجزة",
          "completed": "اكتملت",
          "blocked": "متعطّلة",
          "review": "قيد المراجعة",
          "review_requested": "أُرسلت للمراجعة",
          "reclaimed": "استُعيدت",
          "crashed": "تعطّلت",
          "timed_out": "انتهت المهلة",
          "scheduled": "مجدولة",
          "changes_requested": "طُلبت تعديلات"
        }
      }
    },
    "assign": {
      "open": "إسناد إلى وكيل…",
      "again": "إعادة الإسناد…",
      "title": "إسناد إلى وكيل",
      "agent": "الوكيل",
      "instructions": "تعليمات",
      "instructions_hint": "اختيارية، تصل إلى الوكيل مع المهمة.",
      "start": "إسناد وبدء",
      "only": "إسناد فقط",
      "no_agents": "لا يوجد في هذا المركز وكيل يستطيع تنفيذ مهمة بعد. ثبّت وكيلًا أو فعّله من صفحة الوكلاء.",
      "not_started": "سُلّمت المهمة إلى لوحة هذا الوكيل الخاصة، وهو من يبدأ تنفيذها هناك لا المركز.",
      "waiting": "هذه المهمة تعتمد على مهام لم تنتهِ بعد: {titles}. «إسناد وبدء» يبدؤها الآن رغم ذلك."
    },
    "stop": "إيقاف",
    "unassign": "إلغاء الإسناد",
    "open_session": "فتح المحادثة",
    "show_archived": "عرض المؤرشفة ({count})",
    "hide_archived": "إخفاء المؤرشفة ({count})",
    "waiting_on": "بانتظار {count}",
    "waiting_on_list": "بانتظار: {titles}",
    "stuck": "متوقفة",
    "stuck_since": "لا نشاط في تشغيلها منذ {time}",
    "details": {
      "open": "التفاصيل…",
      "title": "تفاصيل المهمة",
      "description": "الوصف",
      "priority": "الأولوية",
      "waiting_on": "بانتظار",
      "waiting_hint": "لا تبدأ وحدها إلا حين تنتهي هذه كلها.",
      "comments": "التعليقات",
      "no_comments": "لا تعليقات بعد.",
      "add_comment": "أضف تعليقًا",
      "send_comment": "علّق"
    },
    "handover": {
      "open": "تسليم إلى بروفايل آخر…",
      "title": "تسليم إلى بروفايل آخر",
      "workspace": "البروفايل",
      "submit": "سلّم",
      "hint": "يسلّم هرمز البطاقة إلى هرمز ذلك البروفايل، وتنتقل البطاقة إليه.",
      "no_workspaces": "لا يوجد بروفايل آخر تُسلَّم إليه.",
      "confirm_running": "تسليم «{title}» وهي قيد التنفيذ؟",
      "confirm_running_body": "يوقف هرمز تشغيلها الحالي أولًا، ثم يسلّم البطاقة."
    },
    "project_settings": {
      "open": "إعدادات المشروع",
      "title": "إعدادات المشروع",
      "hint": "إذا حدّدت مستودعًا، تُنشأ لكل مهمة تبدأها شجرة عمل Git وفرع مستقل يعمل فيهما الوكيل.",
      "repository": "مسار المستودع",
      "branch": "الفرع الأساسي",
      "branch_hint": "تُنشأ منه فروع المهام الجديدة. إذا تركته فارغًا، يُستخدم الفرع الحالي في المستودع."
    },
    "repo": {
      "hint": "مستودع git داخل مجلّد هذا البروفايل. المسار النسبي يبدأ من ذلك المجلّد. اتركه فارغًا لمشروع بلا مستودع.",
      "placeholder": "my-repo",
      "invalid": {
        "outside_root": "يجب أن يكون المستودع داخل مجلّد هذا البروفايل: {message}",
        "not_found": "هذا المجلّد غير موجود: {message}",
        "symlink": "يمرّ المسار عبر رابط رمزي، وهذا غير مسموح: {message}",
        "not_a_git_repo": "هذا المجلّد ليس مستودع git: {message}"
      }
    },
    "auto_start": {
      "label": "البدء تلقائيًا",
      "hint": "تبدأ وحدها متى صارت في «جاهزة» ومُسندة إلى وكيل وانتهى كل ما تعتمد عليه. إيقافها يُطفئ هذا الخيار."
    },
    "worktree": {
      "title": "شجرة العمل",
      "branch": "الفرع",
      "path": "المجلّد",
      "changes": "التغييرات",
      "counts": "{files} ملفات متغيّرة · {ahead} إيداعات متقدّمة على {base}",
      "remove": "إزالة شجرة العمل",
      "confirm_remove": "إزالة شجرة عمل هذه المهمة؟",
      "confirm_remove_body": "يُحذف المجلّد، ويبقى الفرع {branch} في المستودع، وتضيع التغييرات غير المودَعة.",
      "running": "المهمة تعمل في شجرة العمل هذه. أوقفها أولًا.",
      "failed": "تعذّر على git إنشاء شجرة عمل المهمة: {message}",
      "no_repository": "مشروع هذه المهمة بلا مستودع. حدّده في إعدادات المشروع.",
      "status": {
        "creating": "قيد الإنشاء",
        "ready": "جاهزة",
        "dirty": "فيها تغييرات",
        "merged": "مدموجة",
        "removed": "أُزيلت",
        "error": "رفض git"
      }
    },
    "count_one": "مهمة واحدة",
    "dod": {
      "title": "تعريف الإنجاز",
      "hint": "ما يجب أن يتحقق لتُعدّ المهمة منجزة. يُعطى للوكيل مع كل تشغيل.",
      "review_hint": "قيد المراجعة: علّم كل سطر تحقّق، ثم احفظ.",
      "ticked": "{done} من {total} مُعلَّمة",
      "tick": "تحقّق: {text}",
      "remove": "إزالة «{text}»",
      "line": "السطر {number}",
      "placeholder": "مثل: الاختبارات تنجح",
      "add": "أضف سطرًا",
      "card": "تعريف الإنجاز: {done} من {total} مُعلَّمة",
      "hermes_card": "هذه البطاقة على لوحة هرمز، وهرمز يوجّه عامله من البطاقة نفسها، فلا تأخذ هنا تعريف إنجاز ولا قيودًا."
    },
    "constraints": {
      "title": "القيود",
      "hint": "ما يلتزم به الوكيل أثناء العمل — ملف لا يُلمس، أو مكتبة لا تُضاف. يُعطى مع كل تشغيل.",
      "line": "القيد {number}",
      "placeholder": "مثل: لا تضف مكتبات جديدة",
      "add": "أضف قيدًا"
    },
    "bulk": {
      "select": "تحديد",
      "count": "{count} محدّدة",
      "priority": "حدّد الأولوية",
      "comment": "علّق على الكل",
      "comment_title": "تعليق واحد على {count} مهمة",
      "refused": "لم يتغيّر: {count} (رفض هرمز، أو لم تعد موجودة). تغيّر: {done}.",
      "tick": "حدّد «{title}»"
    },
    "new": {
      "name": "العنوان",
      "name_required": "اكتب عنوانًا للمهمة.",
      "description": "الوصف",
      "description_hint": "التفاصيل والتعليمات التي يعمل منها الوكيل. يمكنك استخدام Markdown هنا.",
      "who": "من ينفّذها",
      "agent": "أسندها إلى",
      "agent_none": "لا أحد الآن",
      "model": "النموذج",
      "model_default": "النموذج الافتراضي للوكيل",
      "model_hint": "يُستخدم عند البدء الآن. المهمة التي تبدأ لاحقًا تعمل على النموذج الافتراضي للوكيل.",
      "hermes_note": "يضع Hermes هذه البطاقة على لوحته ويشغّلها من هناك بنموذجه. اتركها في «واردة» لتحدّد تفاصيلها أولًا.",
      "details": "التفاصيل",
      "due": "موعد التسليم",
      "due_past": "هذا الموعد مضى.",
      "due_invalid": "هذا ليس تاريخًا صحيحًا.",
      "tags": "الوسوم",
      "tags_hint": "افصل بينها بفواصل.",
      "project": "المشروع",
      "project_own": "قائمة البروفايل نفسه",
      "when": "متى تبدأ",
      "start_now": "ابدأ الآن",
      "start_now_hint": "يبدأ الوكيل فورًا، في محادثة المهمة نفسها.",
      "start_needs_agent": "أسندها إلى وكيل لتبدأ الآن.",
      "start_later": "ليس الآن",
      "start_later_hint": "تنتظر على اللوحة حتى يبدأها أحد.",
      "status": "أين تنتظر",
      "status_hint": "«واردة» لمهمة ما زالت تُحدَّد تفاصيلها؛ «جاهزة» تعني أنها التالية في الدور.",
      "create": "إنشاء",
      "start_again": "ابدأ مرة أخرى",
      "close": "إغلاق",
      "not_started": "أُنشئت المهمة لكنها لم تبدأ. ابدأ مرة أخرى، أو أغلق وابدأها من بطاقتها."
    },
    "subtasks": {
      "title": "المهام الفرعية",
      "hint": "خطوات أصغر داخل المهمة، تصل إلى الوكيل معها.",
      "line": "المهمة الفرعية {number}",
      "placeholder": "مثلًا: اكتب المخطط",
      "add": "أضف مهمة فرعية"
    }
  },
  "schedules": {
    "new": "جدول جديد",
    "new_hint": "احفظ الجدول ليُحدَّد موعد تشغيله التالي. ينفّذ هرمز جداوله عبر مجدوله الخاص، وينفّذ المركز الجداول الأخرى.",
    "name": "الاسم",
    "kind": "النوع",
    "prompt": "ما الذي يُطلب من الوكيل؟",
    "empty": "لا جداول بعد",
    "kinds": {
      "cron": "تعبير cron",
      "interval": "كل مدة",
      "once": "مرة واحدة"
    },
    "value": {
      "cron": "التعبير",
      "interval": "كل كم دقيقة",
      "once": "التاريخ والوقت"
    },
    "cron_hint": "خمسة حقول بالترتيب: الدقيقة، الساعة، يوم الشهر، الشهر، يوم الأسبوع.",
    "every": "كل {minutes} دقيقة",
    "next": "التالي: {at}",
    "never": "لا موعد",
    "enabled": "مفعّل",
    "run_now": "شغّله الآن",
    "confirm_delete": "حذف «{name}»؟",
    "state": {
      "scheduled": "مجدول",
      "running": "يعمل",
      "paused": "موقوف",
      "exhausted": "انتهى"
    },
    "agent": "الوكيل",
    "delivers_to": "ينشر في {channel}",
    "last_error": "فشل آخر تشغيل: {error}",
    "hermes": {
      "origin": "في مجدول هرمز",
      "refused": "رفض هرمز: {message}",
      "unreachable": "هرمز لا يجيب الآن، فلم يتغيّر شيء.",
      "timezone": "هرمز يشغّل كل تعبير cron بتوقيت {zone}. استعمل هذا التوقيت، أو غيّر توقيت هرمز.",
      "use_zone": "استعمل {zone}",
      "delivery": "هرمز ينشر في منصّات المراسلة بنفسه — اطلب ذلك في النص.",
      "prompt_required": "جدول هرمز يحتاج نصًّا يُطلب منه.",
      "fired": "سيشغّله هرمز في دورته التالية.",
      "run_options": "هرمز يقرر هذين الخيارين بنفسه لمهامه، فلا يُضبطان هنا."
    },
    "in_profile": "الجداول الجديدة تُنشأ في {name}. لإنشاء جدول في بروفايل آخر، بدّل البروفايل من أعلى الصفحة.",
    "options": {
      "show": "خيارات التشغيل",
      "hide": "إخفاء الخيارات",
      "title": "خيارات التشغيل",
      "missed": "تشغيل الموعد الفائت خلال 24 ساعة",
      "missed_hint": "إذا كان المركز متوقفًا عند الموعد، يُشغَّل الجدول مرة واحدة عند عودته خلال 24 ساعة. عند تعطيل الخيار، يُسجَّل فوات الموعد دون تشغيله. التأخر حتى دقيقتين يُعدّ في الموعد.",
      "overlap": "إذا كان التشغيل السابق لا يزال جاريًا",
      "overlap_hint": "التشغيل اليدوي عبر «شغّله الآن» يبدأ فورًا، ولا يوقف التشغيل السابق.",
      "overlaps": {
        "skip": {
          "label": "تخطّي الموعد",
          "hint": "لا يبدأ تشغيل جديد، ويُسجَّل تخطّي الموعد في السجل."
        },
        "wait": {
          "label": "انتظار انتهاء السابق",
          "hint": "يبدأ التشغيل عند انتهاء السابق. يمكن أن ينتظر موعد واحد فقط؛ وتُتخطّى المواعيد اللاحقة مع تسجيلها."
        },
        "parallel": {
          "label": "تشغيلهما معًا",
          "hint": "يبدأ تشغيل جديد في محادثة مستقلة بالتزامن مع السابق."
        },
        "replace": {
          "label": "إيقاف السابق وبدء الجديد",
          "hint": "يُوقَف التشغيل السابق، ثم يبدأ تشغيل الموعد الجديد."
        }
      },
      "saved": "حُفظت خيارات «{name}»."
    },
    "fired": "بدأ «{name}».",
    "target_unavailable": "تعذّر البدء: {message}",
    "history": {
      "show": "السجل",
      "hide": "إخفاء السجل",
      "empty": "لم يعمل بعد.",
      "open_session": "فتح المحادثة",
      "open_run": "فتح التشغيل",
      "waiting": "ينتظر انتهاء التشغيل السابق",
      "trigger": {
        "schedule": "في موعده",
        "manual": "تشغيل يدوي"
      },
      "status": {
        "queued": "في الانتظار",
        "running": "يعمل",
        "succeeded": "تم",
        "failed": "فشل",
        "cancelled": "لم يعمل"
      }
    },
    "run": {
      "title": "تشغيل سير العمل",
      "waiting": "هذا التشغيل ينتظر موافقتك.",
      "reason": "السبب (اختياري)",
      "approve": "موافقة",
      "deny": "رفض",
      "status": {
        "queued": "في الانتظار",
        "running": "يعمل",
        "waiting": "ينتظر",
        "succeeded": "تم",
        "failed": "فشل",
        "cancelled": "أُلغي"
      },
      "step_status": {
        "pending": "لم تبدأ",
        "queued": "في الانتظار",
        "running": "تعمل",
        "waiting_approval": "تنتظر الموافقة",
        "succeeded": "تمت",
        "failed": "فشلت",
        "skipped": "تُخطّيت",
        "cancelled": "أُلغيت",
        "rejected": "رُفضت"
      }
    },
    "templates": {
      "label": "جداول شائعة",
      "every_hour": "كل ساعة",
      "daily_8": "كل يوم الساعة 8:00",
      "weekdays_9": "أيام العمل الساعة 9:00",
      "monday_9": "كل اثنين الساعة 9:00",
      "monthly_1": "أول كل شهر الساعة 9:00",
      "every_15": "كل 15 دقيقة"
    },
    "preview": {
      "title": "مواعيد التشغيل القادمة ({zone})",
      "incomplete": "حدّد وقت الجدول لعرض مواعيد تشغيله القادمة.",
      "none": "لن يعمل مرة أخرى.",
      "cron_invalid": "لا يستطيع الخادم قراءة هذا: {message}",
      "timezone_unknown": "لا يعرف الخادم المنطقة الزمنية «{zone}»."
    },
    "limits": {
      "title": "الحدود",
      "edit": "غيّر حدود سير العمل هذا",
      "hide": "أخفِ نموذج الحدود",
      "time": "حد الوقت",
      "cost": "حد التكلفة",
      "step": "مهلة الخطوة",
      "spent": "التكلفة حتى الآن",
      "none": "بلا حد",
      "not_priced": "لا دور مسعّر بعد",
      "form_hint": "للتشغيلات القادمة من سير العمل هذا. اترك الحقل فارغًا ليكون بلا حد. وقت انتظار موافقة أحد لا يُحسب.",
      "time_minutes": "حد وقت التشغيل (بالدقائق)",
      "cost_usd": "حد تكلفة التشغيل (بالدولار الأمريكي، بتقدير الخادم)",
      "step_minutes": "مهلة كل خطوة (بالدقائق)",
      "invalid_time": "عدد دقائق أكبر من صفر، أسبوع على الأكثر.",
      "invalid_cost": "مبلغ بالدولار الأمريكي أكبر من صفر، مثل 2.50.",
      "invalid_step": "عدد دقائق أكبر من صفر، يوم على الأكثر.",
      "saved": "حُفظت الحدود، وتسري من التشغيل القادم.",
      "units": {
        "hours": "{n} س",
        "minutes": "{n} د",
        "seconds": "{n} ث"
      },
      "stopped": {
        "max_duration": "توقّف: تجاوز التشغيل حد الوقت.",
        "max_cost": "توقّف: تجاوز التشغيل حد التكلفة.",
        "step_timeout": "توقّف: تجاوزت خطوة مهلتها ولم يتولّها شيء."
      },
      "run_with": "شغّل بحدود لهذا التشغيل",
      "run_title": "حدود هذا التشغيل",
      "run_hint": "تبدأ من حدود سير العمل. ما تغيّره يسري على هذا التشغيل وحده، والحقل الفارغ يعني بلا حد.",
      "save_first": "احفظ سير العمل لتضبط حدوده."
    }
  },
  "workflows": {
    "section": "سير العمل",
    "new": "سير عمل جديد",
    "new_hint": "أضف الخطوات واربط بينها لإنشاء سير عمل في البروفايل {name}.",
    "empty": "لا يوجد سير عمل بعد",
    "empty_hint": "أنشئ سير عمل، ثم أضف خطواته واربط بينها.",
    "untitled": "سير عمل بلا اسم",
    "steps_count": "عدد الخطوات: {count}",
    "runs_count": "عدد مرات التشغيل: {count}",
    "open": "تحرير",
    "run": "شغّل",
    "duplicate": "نسخ",
    "copy_name": "{name} (نسخة)",
    "confirm_delete": "حذف «{name}»؟ تُحذف معه تشغيلاته وجداوله.",
    "started": "بدأ «{name}».",
    "open_run": "اعرض التشغيل",
    "status": {
      "idle": "متوقف",
      "running": "يعمل",
      "waiting": "ينتظر",
      "error": "خطأ"
    },
    "activity": {
      "running_step": "يعمل · {step}",
      "waiting": "ينتظر الموافقة",
      "waiting_step": "ينتظر الموافقة · {step}"
    },
    "kinds": {
      "agent": "وكيل",
      "condition": "شرط",
      "delay": "انتظار",
      "notify": "إشعار",
      "approval": "موافقة"
    },
    "kind_hints": {
      "agent": "يُكلَّف وكيل بتنفيذ طلب",
      "condition": "يختار المسار بحسب تحقق شرط",
      "delay": "يؤخّر الخطوة التالية حتى ساعة",
      "notify": "يُرسل إشعارًا إلى صندوق الوارد",
      "approval": "ينتظر موافقة أحد الأشخاص"
    },
    "routes": {
      "success": "عند النجاح",
      "failure": "عند الفشل",
      "always": "دائمًا"
    },
    "condition_routes": {
      "success": "نعم",
      "failure": "لا",
      "always": "دائمًا"
    },
    "states": {
      "idle": "لم يصل إليها بعد",
      "waiting": "تنتظر",
      "running": "تعمل",
      "done": "تمّت",
      "failed": "فشلت",
      "skipped": "تُخطّيت"
    },
    "editor": {
      "back": "رجوع إلى سير العمل",
      "name": "اسم سير العمل",
      "unsaved": "تغييرات غير محفوظة",
      "saved": "حُفظ.",
      "palette": "أضف خطوة",
      "canvas_label": "لوحة رسم سير العمل",
      "canvas_help": "اسحب الخطوة لتحريكها. اسحب من النقطة الخضراء (نجاح) أو الحمراء (فشل) إلى خطوة أخرى لتصل بينهما. المفاتيح: Tab يتنقّل بين الخطوات، والأسهم تحرّك الخطوة المحددة، وDelete يحذفها، و+ و− للتكبير والتصغير، و0 يعرض الكل.",
      "zoom_in": "تكبير",
      "zoom_out": "تصغير",
      "fit": "عرض الكل",
      "legend": "الأخضر: عند النجاح · الأحمر: عند الفشل · الرمادي: دائمًا",
      "no_selection": "اختر خطوة لتعديلها، أو أضف خطوة جديدة.",
      "checking": "يجري الفحص…",
      "valid": "جاهز للتشغيل",
      "problems": "مشكلات: {count}",
      "warnings": "تنبيهات: {count}",
      "save_blocked": "أصلح المشكلات قبل الحفظ.",
      "name_required": "سمِّ سير العمل قبل الحفظ.",
      "check_failed": "تعذّر فحص الرسم: {message}",
      "check_fields": "تعذّر فحص الرسم: صحّح الحقول المعلَّمة.",
      "name_refused": "الاسم غير مقبول: {message}",
      "fields_refused": "لم يُحفظ: صحّح الحقول المعلَّمة.",
      "delete_step": "احذف الخطوة",
      "delete_edge": "احذف الوصلة",
      "connections": "الوصلات من هذه الخطوة",
      "no_connections": "لا شيء بعد هذه الخطوة.",
      "connect_target": "الخطوة التالية",
      "connect_route": "متى",
      "connect_add": "صِل",
      "edge_title": "وصلة",
      "edge_label": "من «{from}» إلى «{to}»: {route}",
      "run_input": "مدخل التشغيل (اختياري)",
      "run_input_hint": "تقرؤه الخطوات بـ {input}.",
      "run_from_here": "شغّل من هذه الخطوة",
      "rerun_from_here": "أعد التشغيل من هذه الخطوة",
      "rerun_hint": "يبدأ تشغيل جديد من هذه الخطوة، مع إعادة استخدام مخرجات الخطوات السابقة من التشغيل الحالي.",
      "save_first": "يحفظ سير العمل ثم يشغّله.",
      "mode_edit": "تحرير",
      "mode_runs": "التشغيلات",
      "runs_empty": "لم يُشغَّل بعد. شغّله لترى كل خطوة هنا.",
      "run_pick": "التشغيل",
      "run_status": "حالة التشغيل",
      "run_of": "{status} · {at}",
      "cancel_run": "أوقف التشغيل",
      "step_output": "الناتج",
      "step_output_show": "اعرض الناتج كاملًا",
      "step_error": "الخطأ",
      "step_not_reached": "لم يصل هذا التشغيل إلى هذه الخطوة.",
      "run_readonly": "يعرض هذا التشغيل نسخة سير العمل التي استُخدمت فيه. انتقل إلى «تحرير» لتعديل سير العمل.",
      "issue_count": "ملاحظات: {count}",
      "run_find": "ابحث عن تشغيل",
      "run_find_hint": "معرّف المهمة أو الحدث",
      "run_filtered": "مُصفّى: ليس مما يُعمل عليه",
      "run_task": "المهمة {id}",
      "run_event": "الحدث {id}",
      "panel_failed": "واجه هذا الجزء من المحرر خطأً فأُغلق ليبقى الباقي يعمل: {message}",
      "panel_retry": "اعرضه مجددًا"
    },
    "form": {
      "title": "العنوان",
      "id": "معرّف الخطوة",
      "id_hint": "تقرأ الخطوات اللاحقة ناتج هذه الخطوة بـ {path}.",
      "agent": "الوكيل",
      "agent_none": "اختر وكيلًا",
      "model": "النموذج (اختياري)",
      "model_default": "نموذج الوكيل نفسه",
      "prompt": "الطلب",
      "insert": "أدرج",
      "insert_input": "مدخل التشغيل",
      "insert_step": "ناتج «{name}»",
      "insert_none": "صِل خطوات سابقة لتستعمل ناتجها هنا.",
      "attachments_note": "لا تحمل خطوات سير العمل مرفقات بعد.",
      "condition_path": "ما يُفحص",
      "condition_path_hint": "قيمة يقرؤها التشغيل: input أو steps.<id>.output أو trigger.<field>.",
      "condition_operator": "المقارنة",
      "condition_value": "يُقارن بـ",
      "condition_text": "الشرط",
      "condition_raw_hint": "لا يستطيع النموذج تقسيم هذا الشرط إلى أجزاء؛ حرّره نصًّا.",
      "condition_routes_hint": "«نعم» تتبع وصلات النجاح، و«لا» تتبع وصلات الفشل.",
      "operators": {
        "eq": "يساوي",
        "ne": "لا يساوي",
        "gt": "أكبر من",
        "gte": "على الأقل",
        "lt": "أصغر من",
        "lte": "على الأكثر",
        "contains": "يحتوي",
        "matches": "يطابق (تعبير نمطي)",
        "exists": "موجود",
        "empty": "فارغ"
      },
      "delay_amount": "الانتظار",
      "delay_unit": "الوحدة",
      "seconds": "ثوانٍ",
      "minutes": "دقائق",
      "delay_hint": "حتى ساعة. الانتظار الأطول مكانه جدول.",
      "delay_template": "يُقرأ الانتظار من {value} عند تشغيل الخطوة.",
      "notify_text": "الرسالة",
      "notify_to": "يصل الإشعار إلى صندوق وارد الشخص الذي شغّل سير العمل.",
      "approval_question": "طلب الموافقة",
      "approval_who": "يمكن لأي شخص مخوّل بالموافقات في هذا البروفايل قبول الطلب أو رفضه من هنا أو من صندوق الوارد أو من قائمة «بانتظارك».",
      "approval_timeout": "تنتظر حتى يجيب أحد؛ لا مهلة لها.",
      "approval_required": "اطلب موافقة قبل أن تعمل هذه الخطوة",
      "rules_toggle": "عدة قواعد",
      "rules_match": "قل نعم عندما",
      "rules_all": "تتحقق كل القواعد",
      "rules_any": "تتحقق أي قاعدة",
      "rules_remove": "احذف هذه القاعدة",
      "rules_add": "أضف قاعدة",
      "rules_hint": "كل قاعدة تقارن مسارًا — trigger.event أو trigger.task_id أو trigger.body.… أو steps.<id>.output — بقيمة. «نعم» تتبع الوصلات الخضراء و«لا» الحمراء؛ و«لا» بلا شيء بعدها تُنهي التشغيل «مُصفّى»."
    },
    "issues": {
      "field_invalid": "لم يقبل المركز «{detail}» بصيغته الحالية.",
      "node_id_missing": "خطوة بلا معرّف.",
      "node_id_duplicate": "خطوتان بالمعرّف نفسه.",
      "edge_from_unknown": "تبدأ هذه الوصلة من خطوة غير موجودة.",
      "edge_to_unknown": "تنتهي هذه الوصلة عند خطوة غير موجودة.",
      "condition_unreadable": "لا يُقرأ الشرط ({detail}).",
      "delay_out_of_range": "الانتظار من 0 إلى {detail} ثانية.",
      "template_root_unknown": "تقرأ {detail}، والخطوة لا تقرأ إلا input أو trigger أو steps.",
      "template_step_unknown": "تقرأ {detail}، ولا توجد خطوة بهذا المعرّف.",
      "workflow_empty": "لا خطوات في سير العمل بعد.",
      "no_start": "لكل خطوة خطوةٌ قبلها، فلا نقطة بداية لسير العمل.",
      "many_starts": "{detail} خطوات لا شيء قبلها؛ تبدأ كلها معًا.",
      "agent_missing": "لا تسمّي هذه الخطوة وكيلًا.",
      "rule_path_invalid": "قاعدة بلا مسار مقروء (حروف وأرقام و_ ونقاط).",
      "rule_operator_invalid": "قاعدة تستعمل عملية لا يعرفها المركز.",
      "rule_value_missing": "قاعدة تقارن بلا شيء: أعطها قيمة.",
      "rule_regex_invalid": "نمط القاعدة ليس تعبيرًا نمطيًا صالحًا.",
      "send_no_target": "هذه الخطوة لا ترسل إلى أي مكان: اختر تيليجرام أو محادثة.",
      "send_platform_unknown": "الوجهة {detail} منصة لا يرسل إليها هذا المركز.",
      "send_chat_missing": "الوجهة {detail} بلا معرّف محادثة تيليجرام.",
      "send_formatting_unknown": "الوجهة {detail} تذكر تنسيق تيليجرام لا يعرفه هذا المركز (نص عادي أو HTML أو MarkdownV2).",
      "send_conversation_missing": "الوجهة {detail} لا تسمّي محادثة.",
      "conversation_mode_unknown": "وضع المحادثة في هذه الخطوة غير معروف لهذا الهاب.",
      "conversation_id_missing": "اختر المحادثة التي تتحدث فيها هذه الخطوة، أو الصق معرّفها.",
      "conversation_id_invalid": "معرّف المحادثة في هذه الخطوة ليس معرّف محادثة."
    },
    "triggers": {
      "title": "المشغّلات",
      "hint": "عنوان على هذا المركز ترسل إليه خدمة أخرى (ClickUp أو GitHub…) أحداثها. كل حدث يجتاز فحص التوقيع ومرشّح الأحداث يبدأ تشغيلًا والحدث فيه {{trigger.…}}. يجب أن يكون المركز متاحًا من الإنترنت.",
      "save_first": "احفظ سير العمل أولًا ثم أضف مشغّلًا.",
      "preset": "المرسِل",
      "add": "أضف مشغّلًا",
      "presets": {
        "clickup": "ClickUp",
        "github": "GitHub",
        "generic_hmac": "Webhook موقّع (HMAC)",
        "token": "Webhook برمز"
      },
      "enabled": "مفعّل",
      "url": "العنوان",
      "url_hint": "أعطِ هذا العنوان للمرسِل. لا يتغيّر.",
      "copy": "انسخ",
      "copied": "نُسخ",
      "secret": "السر",
      "secret_hint": {
        "clickup": "سجّل الـWebhook في ClickUp بالعنوان أعلاه، ثم ألصق هنا «secret» من ردّ ClickUp.",
        "github": "السر الذي كتبته في إعدادات Webhook في GitHub.",
        "generic_hmac": "السر الذي يوقّع به المرسِل المحتوى (HMAC-SHA256).",
        "token": "الرمز الذي يضعه المرسِل في الترويسة."
      },
      "secret_stored": "السر محفوظ ولا يُعرض أبدًا؛ كتابة سر جديد تستبدله.",
      "secret_missing": "لا سر بعد: يُرفض كل ما يصل حتى يُحفظ سر.",
      "header": "الترويسة",
      "prefix": "بادئة قبل التوقيع",
      "encoding": "الترميز",
      "events": "الأحداث التي يأخذها",
      "events_hint": "إن لم تختر شيئًا يأخذ كل الأحداث.",
      "test_event": "حدث تجريبي",
      "test": "أرسل حدثًا تجريبيًا",
      "status": {
        "received": "وصل",
        "duplicate": "مكرّر، تُجوهل",
        "signature_rejected": "رُفض التوقيع",
        "filtered_out": "حدث لا يأخذه",
        "run_started": "بدأ التشغيل",
        "run_succeeded": "نجح التشغيل",
        "run_failed": "فشل التشغيل"
      },
      "deliveries": "ما وصل (آخر 7 أيام)",
      "no_deliveries": "لم يصل شيء بعد.",
      "filtered": "مُصفّى",
      "test_badge": "تجريبي",
      "open_run": "افتح التشغيل",
      "delete": "احذف المشغّل",
      "delete_title": "أتحذف هذا المشغّل؟",
      "delete_body": "يتوقف عنوانه عن الرد ويُحذف سجل ما وصل إليه. يواصل المرسِل الإرسال حتى تحذف الـWebhook عنده أيضًا."
    },
    "send": {
      "title": "أرسل رسالة",
      "hint": "ترسل كلمات الخطوة إلى تيليجرام و/أو محادثة في كور هب.",
      "message": "الرسالة",
      "targets": "أرسل إلى",
      "telegram": "تيليجرام",
      "chat_id": "معرّف محادثة تيليجرام",
      "telegram_hint": "معرّف محادثة أو مستخدم أو مجموعة (المجموعة مثل ‎-1001234567890). يرسلها بوت تيليجرام الخاص بهذا البروفايل؛ والنص الطويل يُقسَّم إلى عدة رسائل.",
      "conversation": "محادثة في كور هب",
      "conversation_hint": "تُنشر في المحادثة فتظهر في كل التطبيقات. إن حُذفت المحادثة تُنشأ واحدة جديدة بالعنوان نفسه وتشير إليها الخطوة.",
      "pick": "اختر محادثة",
      "untitled": "محادثة بلا عنوان",
      "test": "أرسل رسالة تجريبية",
      "sample_title": "قيم التجربة",
      "sample_hint": "الرسالة فيها متغيرات، وكل متغير يحتاج قيمة قبل إرسال التجربة: اكتبها، أو خذها من آخر تشغيل لسير العمل.",
      "use_last_run": "استخدم قيم آخر تشغيل",
      "last_run_filled": "مُلئت من آخر تشغيل. المتغير الذي لم يكن له قيمة في ذلك التشغيل يبقى فارغًا؛ عدّل أي قيمة قبل الإرسال.",
      "no_run": "لا يوجد تشغيل بعد. اكتب القيم، أو شغّل سير العمل (أو «شغّل من هنا») واستخدم قيمه.",
      "value_of": "قيمة {path}",
      "preview": "معاينة ما سيُرسل",
      "preview_formatting": "تنسيق تيليجرام: {mode}",
      "preview_invalid": "سيرفض تيليجرام تنسيق {mode} هذا:",
      "formatting": "تنسيق تيليجرام",
      "formatting_plain": "نص عادي",
      "formatting_html": "HTML",
      "formatting_markdown_v2": "MarkdownV2",
      "formatting_plain_hint": "تُرسل الكلمات كما كُتبت: تظهر الوسوم والعلامات كما هي.",
      "formatting_html_hint": "وسوم تيليجرام وحدها، مثل هذه. واكتب في النص علامات الأصغر والأكبر والعطف بصيغة الكيانات، كما في السطر الأخير من المثال.",
      "formatting_markdown_v2_hint": "علامات مثل هذه. وخارجها اسبق كل رمز محجوز بشرطة مائلة عكسية، كما في السطر الأخير من المثال.",
      "missing": "املأ هذه قبل الإرسال: {names}",
      "status": {
        "sent": "أُرسلت",
        "partial": "أُرسلت إلى بعض الوجهات فقط",
        "failed": "لم تُرسل"
      },
      "sending": "تُرسَل الرسالة التجريبية…",
      "sent_to": "أُرسلت إلى",
      "message_ids": "معرّف الرسالة",
      "no_answer": "لم يُجب الهاب خلال {seconds} ثانية. لا يُعرف أن شيئًا أُرسل؛ راجع سجل الهاب بحثًا عن «workflow send test».",
      "bad_answer": "تعذّرت قراءة جواب الهاب، فلا يُعرف أن شيئًا أُرسل. راجع سجل الهاب بحثًا عن «workflow send test».",
      "last_run_empty": "آخر تشغيل لم يكن فيه قيمة لـ: {names}. اكتب قيمة قبل الإرسال.",
      "blocked": {
        "no_target": "اختر أولًا أين تُرسل: تيليجرام و/أو محادثة.",
        "no_chat": "اكتب أولًا معرّف محادثة تيليجرام.",
        "no_conversation": "اختر المحادثة أولًا.",
        "no_text": "اكتب الرسالة أولًا."
      }
    },
    "conversation": {
      "label": "المحادثة",
      "mode_new": "محادثة جديدة لكل تشغيل",
      "mode_new_hint": "كل تشغيل يفتح محادثته الخاصة (كما كان).",
      "mode_reuse": "المحادثة نفسها في كل تشغيل",
      "mode_reuse_hint": "كل تشغيل يرسل نصه إلى محادثة موجودة واحدة، فيبقى سجلها في مكان واحد.",
      "pick": "اختر المحادثة",
      "pick_placeholder": "ابحث في محادثات هذا البروفايل",
      "count": "{count} محادثة",
      "none": "لا توجد محادثات في هذا البروفايل بعد.",
      "last_active": "آخر نشاط {when}",
      "paste_id": "الصق معرّف محادثة بدلًا من ذلك",
      "use_list": "اختر من القائمة بدلًا من ذلك",
      "id": "معرّف المحادثة",
      "id_hint": "معرّف محادثة في هذا البروفايل، أو متغير مثل {{trigger.body.conversation}} يُملأ عند تشغيل الخطوة.",
      "template_note": "هذا المعرّف متغير: يُملأ عند تشغيل الخطوة، فلا يمكن اختباره الآن.",
      "not_an_id": "هذا ليس معرّف محادثة. الصق المعرّف كاملًا، أو اختر من القائمة.",
      "none_yet": "اختر محادثة، أو الصق معرّفها.",
      "test": "اختبر المحادثة",
      "open": "افتح المحادثة",
      "create_if_missing": "أنشئها إن لم توجد",
      "create_on_hint": "إن لم تعد المحادثة موجودة، ينشئ التشغيل محادثة جديدة بوكيل هذه الخطوة وبالعنوان أدناه، ثم تستخدمها الخطوة (ويُذكر ذلك في صندوق الوارد).",
      "create_off_hint": "إن كانت المحادثة مفقودة أو محذوفة أو ليست في هذا البروفايل، تفشل الخطوة وتذكر السبب. لا تُنشأ محادثة جديدة.",
      "new_title": "عنوان المحادثة الجديدة",
      "agent_hint": "المحادثة تحتفظ بوكيلها: يجب أن يكون وكيل الخطوة هو نفسه، أو اترك الوكيل فارغًا لتستخدم وكيل المحادثة. التشغيلات التي تصلها في الوقت نفسه تأخذ أدوارها واحدًا بعد الآخر.",
      "status": {
        "ready": "«{title}» جاهزة. وكيلها {agent}، وهي متاحة الآن.",
        "busy": "«{title}» موجودة، لكن فيها دورًا جاريًا. سينتظر التشغيل حتى ينتهي (حتى 10 دقائق).",
        "not_found": "لا توجد محادثة بهذا المعرّف في هذا البروفايل. قد تكون حُذفت، أو لم تُنشأ، أو تتبع بروفايلًا آخر.",
        "not_allowed": "«{title}» محادثة مقعد في غرفة أو مساعد شخص آخر. لا يمكن لسير العمل أن يتحدث فيها.",
        "agent_mismatch": "«{title}» تتبع {agent}، لا وكيل هذه الخطوة. اختر الوكيل نفسه، أو اترك وكيل الخطوة فارغًا."
      }
    },
    "alert": {
      "title": "عند فشل تشغيل",
      "inbox": "أخبرني في صندوق الوارد",
      "hint": "اسم سير العمل وخطأ التشغيل. تيليجرام والمحادثة كما في خطوة «أرسل رسالة»."
    },
    "test": {
      "title": "اختبر هذه الخطوة",
      "input": "مدخل تجريبي ({{input}})",
      "trigger": "حدث تجريبي ({{trigger.…}}) بصيغة JSON",
      "bad_json": "الحدث التجريبي ليس JSON صالحًا.",
      "execute": "شغّل الوكيل فعليًا",
      "run": "جرّب",
      "yes": "نعم — تُتبع الوصلات الخضراء",
      "no": "لا — تُتبع الوصلات الحمراء"
    },
    "phase": {
      "received": "استُلم",
      "analyzing": "يحلّل",
      "needs_input": "ينتظر ردك",
      "approved": "وُوفق عليه",
      "executing": "ينفّذ",
      "completed": "اكتمل",
      "failed": "فشل"
    },
    "nodes": {
      "trigger": "مشغّل",
      "pending": "يُنشأ عند الحفظ",
      "off": "متوقف",
      "add_step": "أضف خطوة",
      "add_trigger": "أضف مشغّلًا",
      "add_first": "أضف أول خطوة بعد «{name}»",
      "add_after": "أضف خطوة بعد «{name}» ({route})",
      "add_first_trigger": "أضف مشغّلًا",
      "add_first_hint": "المشغّل يبدأ سير العمل: يدويًا، أو بجدول زمني، أو عندما ترسل خدمة أخرى حدثًا.",
      "trigger_link_hint": "المشغّل يبدأ الخطوات التي لا تسبقها خطوة. صِله بإحداها، أو احذف ما يسبق هذه الخطوة.",
      "canvas_help": "انقر الخطوة لفتحها، واسحبها لتحريكها. اسحب من النقطة الخضراء (نجاح) أو الحمراء (فشل) إلى خطوة أخرى لتصل بينهما، أو إلى مكان فارغ لتضيف خطوة هناك؛ وزر + بعد الخطوة يضيف التالية. المفاتيح: Tab يتنقّل بين الخطوات، وEnter يفتحها، والأسهم تحرّكها، وDelete يحذفها، و+ و− للتكبير والتصغير، و0 يعرض الكل. Ctrl+S يحفظ.",
      "pick_step": "أضف خطوة",
      "pick_trigger": "أضف مشغّلًا",
      "search": "ابحث",
      "none_found": "لا شيء يطابق.",
      "trigger_kinds": {
        "manual": "تشغيل يدوي",
        "clickup": "ClickUp",
        "github": "GitHub",
        "generic_hmac": "Webhook موقّع (HMAC)",
        "token": "Webhook برمز",
        "schedule": "بجدول زمني"
      },
      "trigger_hints": {
        "manual": "يعمل عندما تضغط «شغّل»، بالمدخل الذي تعطيه.",
        "clickup": "يعمل عندما يصل حدث مهمة من ClickUp.",
        "github": "يعمل عندما يصل حدث من GitHub.",
        "generic_hmac": "يعمل عندما ترسل خدمة محتوى موقّعًا بسرّ مشترك.",
        "token": "يعمل عندما ترسل خدمة رمزًا سريًا في ترويسة.",
        "schedule": "يعمل في أوقات محددة: تعبير cron، أو كل عدد من الدقائق، أو مرة واحدة."
      },
      "back_to_canvas": "رجوع إلى اللوحة",
      "preview": "ما تقرؤه هذه الخطوة وما قالته",
      "input": "المدخل",
      "output": "المخرج (آخر تشغيل)",
      "trigger_value": "ما أرسله المشغّل، حين يبدأ مشغّلٌ التشغيل.",
      "no_output": "آخر تشغيل لم يصل إلى هذه الخطوة.",
      "no_run": "لم يُشغَّل بعد. شغّل سير العمل، أو استخدم «اختبر هذه الخطوة»، لترى ما تقوله.",
      "no_value": "فارغ",
      "manual_about": "يمكن تشغيل كل سير عمل يدويًا. المدخل أدناه تقرؤه الخطوات بصيغة {input}.",
      "manual_detail": "اضغط «شغّل»",
      "remove_trigger": "احذف المشغّل",
      "pending_webhook": "يُنشأ هذا المشغّل عند حفظ سير العمل، ويظهر حينها العنوان الذي تعطيه للخدمة الأخرى.",
      "pending_schedule": "يُنشأ هذا الجدول عند حفظ سير العمل.",
      "schedule_save": "احفظ الجدول",
      "schedule_open": "افتح في الجدولة",
      "no_steps": "أضف خطوة أولًا.",
      "all_saved": "محفوظ",
      "save_shortcut": "احفظ (Ctrl+S)",
      "settings": "إعدادات سير العمل"
    },
    "leave": {
      "title": "لديك تغييرات غير محفوظة",
      "body": "هل تحفظها قبل مغادرة سير العمل هذا، أم تتجاهلها؟",
      "stay": "ابقَ",
      "discard": "تجاهل",
      "save": "احفظ وغادر",
      "left_behind": "غادرت سير العمل هذا وفيه تغييرات غير محفوظة.",
      "restore": "استعدها"
    }
  },
  "audit": {
    "period": "المدة",
    "between": "من {from} إلى {to}",
    "runs": "الأدوار",
    "runs_n": "الأدوار: {count}",
    "sessions_n": "المحادثات: {count}",
    "tokens": "الرموز",
    "tokens_n": "الرموز: {count}",
    "cost": "الكلفة",
    "cost_unknown": "بلا سعر معروف",
    "model": "النموذج",
    "by_model": "حسب النموذج",
    "period_7": "آخر 7 أيام",
    "period_30": "آخر 30 يومًا",
    "period_90": "آخر 90 يومًا",
    "period_365": "آخر 365 يومًا"
  },
  "usage": {
    "profile": "البروفايل",
    "all_profiles": "كل البروفايلات",
    "agent": "الوكيل",
    "all_agents": "كل الوكلاء",
    "removed_agent": "وكيل محذوف",
    "show_cost": "إظهار الكلفة",
    "show_cost_hint": "تقدير من الأسعار المنشورة، وليس فاتورة.",
    "total_tokens": "مجموع الرموز",
    "input_output": "{input} مُدخل · {output} مُخرج",
    "input": "المُدخل",
    "output": "المُخرج",
    "cache_read": "القراءة من الذاكرة المؤقتة",
    "cache_write": "الكتابة في الذاكرة المؤقتة",
    "cache_hit_rate": "نسبة الإصابة في الذاكرة المؤقتة",
    "not_reported": "غير مُبلَّغ",
    "cache_not_reported_hint": "لم يبلّغ أي مزوّد عن ذاكرته المؤقتة في هذه المدة.",
    "cost_estimated": "الكلفة التقديرية",
    "cost_unpriced": "لا شيء في هذه المدة له سعر معروف.",
    "conversations": "المحادثات",
    "per_day": "المحادثات يوميًا (متوسط)",
    "daily": "الرموز يوميًا",
    "day_table": "يومًا بيوم",
    "date": "اليوم",
    "only_active_days": "الأيام التي بلا أدوار غير مدرجة.",
    "by_agent": "حسب الوكيل",
    "no_usage_reported": "لا يبلّغ عن استهلاكه",
    "unreported_notice": "{count} من الأدوار لم تبلّغ عن استهلاكها (والوكلاء البرمجيون لا يبلّغون أبدًا): محسوبة، لكن بلا رموز ولا كلفة.",
    "nothing": "لم يعمل شيء في هذه المدة."
  },
  "skills_usage": {
    "counting_since": "بدأ العدّ في {date}؛ استخدام المهارات قبل ذلك لم يُسجَّل.",
    "not_counting": "لم يبدأ هذا المركز عدّ استخدام المهارات بعد.",
    "not_counted_acp": "الوكلاء البرمجيون لا يذكرون المهارة التي يحمّلونها، فلا تُحسب.",
    "total_uses": "مجموع الاستخدامات",
    "distinct": "مهارات مستخدَمة",
    "top": "الأكثر استخدامًا",
    "never_used": "لم تُستخدم في هذه المدة",
    "unknown": "غير معروف",
    "unknown_hint": "لا يستطيع المركز عرض المهارات المثبّتة في هرمز هذا.",
    "none": "لا شيء",
    "daily": "أبرز المهارات يوميًا",
    "other": "أخرى",
    "table": "أبرز المهارات",
    "skill": "المهارة",
    "uses": "الاستخدامات",
    "share": "الحصة",
    "last_used": "آخر استخدام",
    "uses_n": "الاستخدامات: {count}",
    "never_used_list": "مهارات مفعّلة لم يحمّلها أي دور",
    "nothing": "لم تُحمَّل أي مهارة في هذه المدة."
  },
  "notify": {
    "inbox": "الوارد",
    "filter": "العرض",
    "all": "الكل",
    "unread": "غير المقروء",
    "mark_all": "تعليم الكل مقروءًا",
    "none": "لا شيء بعد",
    "none_unread": "كل شيء مقروء",
    "none_body": "ما يحدث في المركز يظهر هنا: ردّ انتهى، أو إذن ينتظرك.",
    "is_unread": "غير مقروء",
    "is_read": "مقروء",
    "what_reaches_me": "ما يصلني",
    "quiet": "ساعات الهدوء",
    "quiet_hint": "نافذة لا يُرسَل فيها تنبيه إلى جهازك.",
    "quiet_from": "من",
    "quiet_to": "إلى",
    "push_note": "ساعات الهدوء تخصّ إشعارات الأجهزة، لا الوارد — ما يُكتب ليلًا يبقى هنا صباحًا.",
    "kind": {
      "run_completed": "انتهاء ردّ وكيل",
      "approval_requested": "طلب إذن",
      "room_mention": "ذِكرك في غرفة",
      "task_moved": "انتقال مهمة",
      "schedule_failed": "تعثّر جدولة",
      "update_available": "تحديث متاح",
      "system": "رسائل النظام"
    },
    "test": "إرسال إشعار تجريبي",
    "test_sent": "أُرسل. انظر هذا المتصفح وأجهزتك.",
    "browser": {
      "title": "الإشعارات في هذا المتصفح",
      "enable": "تفعيل إشعارات المتصفح",
      "disable": "إيقافها في هذا المتصفح",
      "on": "مفعّلة: ما يصل إلى الوارد يظهر أيضًا في هذا المتصفح، ولو كانت الصفحة مغلقة.",
      "off": "موقوفة: الإشعارات تظهر هنا فقط ما دامت الصفحة مفتوحة.",
      "denied": "المتصفح يمنع الإشعارات لهذا الموقع. اسمح بها من إعدادات الموقع في المتصفح، ثم حاول مجددًا.",
      "unsupported": "هذا المتصفح لا يستقبل إشعارات Push.",
      "no_key": "Web Push موقوف في هذا المركز. يستطيع المشرف تشغيله."
    },
    "col_event": "الحدث",
    "col_in_hub": "في الهب",
    "col_on_devices": "على الأجهزة"
  },
  "webhooks": {
    "intro": "أضف رابط خدمة خارجية ليرسل إليه المركز الأحداث التي تختارها. يمكنك توقيع الرسائل لتتحقق الخدمة من مصدرها. كل وجهة إشعار تتبع البروفايل الحالي.",
    "add": "إضافة وجهة إشعار",
    "forwarding_note": "يرسل المركز الأحداث المختارة فور وقوعها إلى الوجهة، من البروفايلات المحددة. إذا فشل الإرسال، يعيد المحاولة بعد 30 ثانية ثم دقيقة ثم دقيقتين، مع مضاعفة الانتظار حتى تنفد المحاولات. يمكنك إعادة الإرسال من سجل التسليم.",
    "none": "لا توجد وجهات إشعار بعد",
    "none_body": "أضف وجهة لإرسال أحداث المركز إلى خدمة خارجية.",
    "facts": "تفاصيل وجهة الإشعار",
    "enabled": "مفعَّل",
    "on": "يعمل",
    "off": "موقوف",
    "signed": "موقَّع",
    "unsigned": "غير موقَّع",
    "no_events": "لم تُختر أحداث",
    "event_count": "الأحداث: {count}",
    "private_allowed": "العنوان الخاص مسموح",
    "stats": "سُلِّم {delivered} · فشل {failed}",
    "last_delivery": "آخر تسليم {when}",
    "last_error": "آخر فشل: {error}",
    "test": "إرسال تجريبي",
    "testing": "يُرسَل التسليم التجريبي…",
    "test_ok": "تم التسليم — ردّت الوجهة برمز الحالة {status}.",
    "test_status": "تعذّر التسليم — ردّت الوجهة برمز الحالة {status}.",
    "test_failed": "لم يُسلَّم: {error}",
    "show_deliveries": "آخر التسليمات",
    "hide_deliveries": "إخفاء التسليمات",
    "deliveries": "آخر التسليمات",
    "no_deliveries": "لم يُرسل المركز شيئًا إلى هذه الوجهة بعد.",
    "col_when": "الوقت",
    "col_event": "الحدث",
    "col_status": "الحالة",
    "col_code": "الرد",
    "col_error": "الخطأ",
    "delivery": {
      "queued": "في الانتظار",
      "delivered": "سُلِّم",
      "failed": "فشل",
      "dead": "توقّفت المحاولات"
    },
    "delete_title": "حذف وجهة الإشعار «{name}»؟",
    "delete_body": "سيتوقف المركز عن إرسال الأحداث إلى هذا الرابط، ويُحذف سجل تسليماته.",
    "edit_title": "تعديل «{name}»",
    "name": "الاسم",
    "url": "العنوان",
    "url_hint": "رابط يبدأ بـ http:// أو https://. يتحقق المركز من الوجهة قبل حفظها.",
    "url_scheme": "استعمل عنوانًا يبدأ بـ http:// أو https://.",
    "url_unresolvable": "لم يتمكن المركز من العثور على هذا العنوان. تحقّق من اسم المضيف.",
    "url_private": "هذا العنوان يشير إلى داخل شبكة خاصة. اسمح بالعناوين الخاصة أدناه إن كان ذلك مقصودًا.",
    "allow_private": "السماح بعنوان خاص",
    "allow_private_hint": "هذا الخيار معطّل افتراضيًا حتى لا تُستخدم الوجهة للوصول إلى أجهزة داخل شبكة المركز.",
    "signing": "سرّ التوقيع",
    "signing_hint": "عند ضبط سرّ، يضيف المركز ترويسة التوقيع أدناه إلى كل رسالة. تتحقق الخدمة باستخدامها من مصدر الرسالة ومحتواها (HMAC-SHA256).",
    "secret_keep": "الإبقاء على السرّ الحالي",
    "secret_new": "إنشاء سرّ جديد",
    "secret_new_hint": "يظهر السرّ مرة واحدة بعد الحفظ؛ انسخه وأرسله إلى الخدمة المستقبِلة.",
    "secret_remove": "إيقاف التوقيع",
    "secret_make": "توقيع التسليمات بسرّ جديد",
    "secret_none": "بلا توقيع",
    "events": "الأحداث",
    "events_hint": "اختر الأحداث التي تُرسل إلى هذه الوجهة.",
    "events_filter": "تصفية الأحداث",
    "events_no_match": "لا حدث يطابق.",
    "secret_title": "سرّ التوقيع",
    "secret_once": "انسخه الآن. يحتفظ به المركز، لكنه لن يعرضه مرة أخرى.",
    "secret_done": "نسختُه",
    "copy": "نسخ",
    "copied": "نُسخ",
    "all_profiles": "كل البروفايلات",
    "profile_count": "البروفايلات: {count}",
    "with_content": "يشمل نص الرسائل",
    "profiles": "البروفايلات",
    "profiles_hint": "اختر البروفايلات التي تُرسل أحداثها إلى هذه الوجهة. تظهر البروفايلات التي يمكنك الوصول إليها فقط.",
    "profiles_all": "كل البروفايلات التي أستطيع الوصول إليها",
    "profiles_some": "هذه البروفايلات فقط",
    "profiles_pick_one": "اختر بروفايلًا واحدًا على الأقل.",
    "include_content": "تضمين نص الرسائل",
    "include_content_hint": "مطفأ: يحمل التسليم المعرّفات والحالات والأوقات فقط، لا ما كتبه الناس والوكلاء.",
    "max_retries": "عدد المحاولات بعد الفشل",
    "max_retries_hint": "من 0 إلى 10. كل انتظار ضعف الذي قبله، يبدأ بـ30 ثانية.",
    "col_attempts": "المحاولات",
    "col_next": "المحاولة التالية",
    "col_actions": "إجراءات",
    "redeliver": "إعادة الإرسال",
    "redelivered": "أُعيد إلى الانتظار، ويُرسَل بعد لحظة."
  },
  "privacy": {
    "access": "التطبيقات والأجهزة التي لها وصول",
    "access_hint": "كل هاتف مقترن وكل تكامل يحمل رمزًا يعمل باسمك. ألغِ أحدها فيتوقف فورًا، ويُفصل الجهاز المقترن.",
    "col_name": "الاسم",
    "col_scopes": "الصلاحيات",
    "col_used": "آخر استعمال",
    "col_expires": "ينتهي",
    "kind_device": "جهاز مقترن",
    "kind_app": "رمز تطبيق",
    "never_used": "لم يُستعمل",
    "no_expiry": "لا ينتهي",
    "revoke": "إلغاء الوصول",
    "revoke_title": "إلغاء وصول «{name}»؟",
    "revoke_body": "كل ما يستعمل هذا الرمز يفقد الوصول فورًا. لا يمكن التراجع.",
    "revoke_device_body": "يفقد هذا الجهاز الوصول فورًا ويُفصل؛ إقرانه من جديد يعطيه رمزًا جديدًا.",
    "none": "لا تطبيق ولا جهاز يحمل رمزًا",
    "none_body": "لا يصل إلى حسابك إلا دخولك أنت.",
    "browsers_note": "المتصفحات التي دخلت منها لا تظهر هنا. تغيير كلمة المرور من «الحساب» يُخرج كل متصفح إلا هذا، ولا يلغي الرموز أعلاه.",
    "redact_title": "ما يصل إلى النموذج من قنوات المراسلة",
    "redact_admin_only": "يغيّره المشرف."
  },
  "people": {
    "title": "المستخدمون",
    "add": "إضافة مستخدم",
    "person": "الشخص",
    "role": "الدور",
    "status": "الحالة",
    "status_active": "نشط",
    "status_disabled": "معطّل",
    "workspaces": "البروفايلات",
    "all_workspaces": "كل البروفايلات",
    "no_workspace": "بلا بروفايل",
    "make_member_for": "إرجاع {name} إلى عضو",
    "owner_note": "حساب المالك لا يُعدَّل من هنا",
    "make_admin": "ترقية إلى مشرف",
    "make_member": "إرجاع إلى عضو",
    "set_password": "تعيين كلمة مرور",
    "set_password_for": "كلمة مرور {name}",
    "password_note": "تُكتب مرّة ولا تُعرض بعدها أبدًا، وتُنهي جلسات هذا الشخص على كل جهاز.",
    "new_password": "كلمة المرور الجديدة",
    "password_short": "ثمانية أحرف على الأقل",
    "disable": "تعطيل",
    "enable": "تفعيل",
    "delete_title": "حذف {name}؟",
    "delete_body": "يُحذف الحساب ورموزه وأجهزته المقترنة. المحادثات تبقى.",
    "username": "اسم المستخدم",
    "username_hint": "حروف إنجليزية صغيرة وأرقام و . _ -",
    "username_bad": "حرفان إلى أربعين، بحروف إنجليزية صغيرة وأرقام و . _ -",
    "display_name": "الاسم المعروض",
    "member_can": "يفتح المحادثات والوكلاء في بروفايلاته",
    "admin_can": "يدير المستخدمين والبروفايلات وإعدادات المركز",
    "lockouts": "الأقفال",
    "clear_lockouts": "فكّ الكل",
    "no_lockouts": "لا أقفال",
    "no_lockouts_body": "يُقفَل عنوان بعد محاولات دخول فاشلة متتالية، ويُفكّ وحده بعد المدة.",
    "ip": "العنوان",
    "lock_kind": "السبب",
    "lock_password": "كلمة مرور",
    "lock_token": "رمز",
    "lock_pairing": "اقتران",
    "failures": "المحاولات",
    "locked_until": "حتى",
    "edit_workspaces": "البروفايلات…",
    "workspaces_for": "بروفايلات {name}",
    "workspaces_hint": "لا يرى العضو إلا البروفايلات المحدّدة هنا: محادثاتها ووكلاءها ومهامها.",
    "workspaces_required": "اختر بروفايلًا واحدًا على الأقل.",
    "admin_everywhere": "المشرف يدخل كل البروفايلات."
  },
  "workspaces": {
    "note": "بروفايلات منفصلة: وكلاؤها ونماذجها ومحادثاتها لا ترى بعضها.",
    "add": "بروفايل جديد",
    "current": "الحالي",
    "default": "الافتراضي",
    "counts": "الوكلاء: {agents} · المحادثات: {sessions}",
    "archive": "أرشفة",
    "archive_title": "أرشفة {name}؟",
    "archive_body": "يُطوى البروفايل هنا وتُلغى عضويّات من فيه. بروفايله في هرمز ومحادثاته ({sessions}) تبقى ولا تُمحى.",
    "name": "الاسم",
    "slug": "المعرّف",
    "slug_hint": "حروف إنجليزية صغيرة وأرقام وشرطات — ويظهر في الروابط.",
    "slug_bad": "حروف إنجليزية صغيرة وأرقام وشرطات، ويبدأ وينتهي بحرف أو رقم",
    "slug_taken": "هذا المعرّف مستخدم",
    "clone": "انسخه من",
    "clone_what": "يُنسخ الإعداد والشخصية (SOUL.md) والمهارات — لا الذاكرة ولا المحادثات ولا القنوات.",
    "origin": "كيف يبدأ؟",
    "origin_blank": "من الصفر",
    "origin_clone": "نسخة من بروفايل",
    "origin_blank_what": "بروفايل هرمز جديد بإعداداته الافتراضية ومهاراته الأساسية.",
    "clone_pick": "اختر البروفايل",
    "refused": "رفض هرمز: {message}",
    "rename_title": "إعادة تسمية {name}",
    "rename_hint": "أي اسم وبأي لغة. يظهر حيثما ذُكر هذا البروفايل، ويظهره هرمز أيضًا. المعرّف ⁦{slug}⁩ لا يتغيّر، فتبقى المحادثات والقنوات والجداول تعمل.",
    "export": "تصدير",
    "export_title": "تصدير {name}",
    "export_what": "يكتب هرمز هذا البروفايل أرشيفًا بصيغته (⁦.tar.gz⁩): شخصيته (⁦SOUL.md⁩) وذاكرته ومهاراته وإعداداته ومحادثاته. يُستورد الملف هنا، أو في إيكو، أو بالأمر ⁦hermes profile import⁩.",
    "export_secrets": "المفاتيح لا تخرج: تُستبعد ملفات الاعتماد (⁦.env⁩ و⁦auth.json⁩)، ويُطمس كل مفتاح مزوّد محفوظ في المركز أينما ظهر. التنزيل لك وحدك، لمدة 24 ساعة.",
    "export_ready": "⁦{file}⁩ (⁦{size}⁩) جاهز وحُفظ.",
    "export_download": "نزّله مرة أخرى",
    "export_removed": "استُبعد: ⁦{files}⁩",
    "export_masked": "طُمست مفاتيح محفوظة في: ⁦{files}⁩",
    "import": "استيراد",
    "import_title": "استيراد بروفايل",
    "import_what": "اختر أرشيف بروفايل هرمز (⁦.tar.gz⁩) — مصدَّرًا من هنا، أو من إيكو، أو بالأمر ⁦hermes profile export⁩. ينشئ منه هرمز بروفايلًا جديدًا بالمعرّف أدناه.",
    "import_choose": "اختر أرشيفًا",
    "import_other_file": "اختر غيره",
    "import_no_file": "لم يُختر ملف",
    "import_uploading": "رفع الأرشيف…",
    "import_too_large": "الأرشيف أكبر مما يقبله المركز في الرفع (50 ميغابايت).",
    "import_done": "استُورد {name}.",
    "import_replace_default": "استبدل البروفايل الافتراضي بهذا",
    "import_replace_default_hint": "للانتقال من برنامج آخر: يصير الأرشيف البروفايل الافتراضي، ويُحفظ الافتراضي الحالي نسخةً احتياطية يمكنك الرجوع إليها.",
    "import_replace_name_hint": "يأخذ البروفايل الافتراضي هذا الاسم.",
    "import_replace_confirm_title": "استبدال البروفايل الافتراضي؟",
    "import_replace_confirm_body": "سيُستبدل بروفايلك الافتراضي الحالي «{name}» بهذا الأرشيف، ويصير الأرشيف هو الافتراضي. ويُحفظ الحالي كاملًا بروفايلًا جديدًا باسم ⁦default-backup⁩ (أو الاسم الحر التالي): تنتقل معه ذاكرته ومهاراته ومحادثات هرمز ومهامه المجدولة وقنواته، وتبقى قنواته تجيب من هناك. المحادثة الجارية الآن تتوقف. والمزوّدون المشتركون ومفاتيحهم يبقون مع الافتراضي. وإن فشل شيء فلا يتغير شيء.",
    "import_replace_confirm": "استبدل الافتراضي",
    "import_replace_done": "بروفايلك الافتراضي السابق محفوظ باسم «⁦{backup}⁩»، ويمكنك حذفه متى شئت.",
    "import_replace_open": "انتقل إلى ⁦{backup}⁩",
    "export_providers": "المزوّدون",
    "export_without_providers": "بدون المزوّدين",
    "export_with_providers": "مع المزوّدين",
    "export_keys_warning": "سيحتوي الملف على مزوّدي هذا البروفايل ومفاتيحهم مكشوفة — مزوّدوه الخاصون والمشتركون الذين يستخدمهم. من يملك الملف يستطيع استعمال هذه المفاتيح. استيراده يجعلهم مزوّدين خاصين للبروفايل الجديد.",
    "export_providers_carried": "المزوّدون في الملف مع مفاتيحهم: {count}"
  },
  "knowledge": {
    "kind": "النوع",
    "kind_all": "الكل",
    "kind_journal": "اليوميات",
    "kind_note": "ملاحظات",
    "kind_file": "ملفات",
    "search": "ابحث في المعرفة",
    "untitled": "بلا عنوان",
    "more": "هناك المزيد — ضيّق البحث أو النوع.",
    "empty": "لا شيء بعد",
    "empty_body": "اليوميات والملاحظات والملفات تظهر هنا حين تُكتب أو تُرفق في محادثة.",
    "no_match": "لا نتائج",
    "no_match_body": "غيّر الكلمة أو وسّع النوع."
  },
  "plugins": {
    "none": "لا إضافات",
    "none_body": "هذا المركز يجيب القائمة ولا مُثبِّت بعد. حين يوجد، تظهر هنا بحالتها.",
    "name": "الإضافة",
    "kind": "النوع",
    "status": "الحالة",
    "status_running": "تعمل",
    "status_stopped": "متوقفة",
    "status_error": "خطأ"
  },
  "updates": {
    "web_note": "هذه الصفحة عن تطبيقات الجوال وسطح المكتب. الويب الذي تنظر إليه يخدمه المركز نفسه ويتغيّر بتغيّره.",
    "source": "المصدر والقناة",
    "default_channel": "القناة الافتراضية",
    "channel_stable": "مستقرة",
    "channel_test": "اختبارية",
    "from_source": "اجلب الإصدارات من مستودع",
    "from_source_hint": "يقرأ المركز إصدارات GitHub بنفسه بدل رفعها يدويًا.",
    "repo": "المستودع",
    "repo_hint": "بصيغة owner/repo.",
    "token": "الرمز",
    "token_hint": "لمستودع خاص. يُكتب ولا يُعرض.",
    "token_stored": "محفوظ. اكتب رمزًا جديدًا لتبديله.",
    "auto_publish": "نشر تلقائي للقناة الاختبارية",
    "auto_publish_hint": "كل إصدار جديد في المصدر يُنشر اختباريًّا وحده.",
    "shelf": "الإصدارات",
    "empty": "لا إصدارات",
    "empty_body": "ما يُنشر هنا تجده تطبيقات الجوال وسطح المكتب. ولم يُبنَ منها شيء بعد.",
    "build": "الإصدار",
    "size": "الحجم",
    "published": "نُشر",
    "mandatory": "إلزامي",
    "platform_android": "أندرويد",
    "platform_ios": "آيفون",
    "platform_macos": "ماك",
    "platform_windows": "ويندوز",
    "platform_linux": "لينكس",
    "delete_title": "حذف {version} من الرفّ؟",
    "delete_body": "يختفي من قائمة التحديثات. ما نُزِّل على جهاز يبقى يعمل."
  },
  "about": {
    "name": "الاسم",
    "server_version": "إصدار الخادم",
    "contract_version": "إصدار العقد",
    "client_version": "إصدار هذه الصفحة",
    "locales": "اللغات",
    "realtime": "قنوات البثّ الحيّ",
    "realtime_note": "ما يفتحه العميل ليعرف بما يحدث دون أن يسأل."
  },
  "skills": {
    "title_of": "مهارات {name}",
    "search": "ابحث في المهارات",
    "new": "مهارة جديدة",
    "none": "لا مهارات",
    "none_body": "المهارات ملفات في مجلد الوكيل. أضف واحدة هنا أو ثبّت حزمة.",
    "no_match": "لا نتائج",
    "no_match_body": "غيّر الكلمة.",
    "category_user": "مهاراتك",
    "enabled": "مفعّلة",
    "pinned": "مثبّتة",
    "pin": "تثبيت",
    "unpin": "إلغاء التثبيت",
    "broken": "لا تُقرأ",
    "delete_title": "حذف {name}؟",
    "delete_body": "يُحذف مجلد المهارة كاملًا بما فيه من ملفات. الإيقاف بديلٌ يُبقي كل شيء.",
    "key": "المعرّف",
    "document": "ملف SKILL.md",
    "editor_note": "هذا ما يقرأه الوكيل حرفيًّا — الترويسة والنصّ. لا شيء يُعاد تشكيله عند الحفظ.",
    "import": {
      "button": "استيراد",
      "running": "يستورد…",
      "done": "استُورد {count}: {names}.",
      "reason": {
        "pack_unrecognised": "حزمة المهارات ملف SKILL.md أو أرشيف zip",
        "pack_has_no_skill": "الأرشيف لا يحوي أي SKILL.md",
        "pack_path_unsafe": "في الأرشيف مسار يقع خارج مهارته",
        "pack_unsupported": "الأرشيف يستعمل شيئًا لا يقرؤه المركز",
        "pack_corrupt": "الأرشيف تالف",
        "pack_too_large": "الأرشيف أكبر من المسموح بعد فكّه",
        "skill_empty": "ملف SKILL.md فارغ",
        "skill_too_large": "ملف SKILL.md أطول مما يقرؤه هرمز",
        "skill_front_matter_missing": "ملف SKILL.md لا يبدأ بترويسة (---)",
        "skill_front_matter_unclosed": "ترويسة SKILL.md غير مغلقة بـ ---",
        "skill_front_matter_invalid": "ترويسة SKILL.md ليست YAML صالحًا",
        "skill_name_required": "ترويسة SKILL.md بلا اسم (name)",
        "skill_description_required": "ترويسة SKILL.md بلا وصف (description)",
        "skill_description_too_long": "الوصف أطول مما يقرؤه هرمز",
        "skill_body_empty": "لا شيء في SKILL.md بعد ترويسته",
        "skill_name_invalid": "اسم المهارة ليس اسمًا يقبله هرمز",
        "skill_not_utf8": "ملف SKILL.md ليس نصًّا بترميز UTF-8",
        "skill_nested": "في الأرشيف مهارة داخل مهارة أخرى",
        "skill_duplicate": "المهارة نفسها ({skill}) مرفوعة مرتين",
        "skill_exists": "في هذا البروفايل مهارة باسم {skill} مسبقًا؛ احذفها أولًا لتستبدلها"
      }
    },
    "builtin": "مدمجة في هرمز",
    "builtin_hint": "من مهارات هرمز نفسه. يبقيها هرمز مطابقة لنسخته، فتُقرأ وتُثبَّت وتُشغَّل أو تُطفأ هنا (بمفتاح هرمز نفسه) ولا تُحرَّر ولا تُحذف.",
    "bundled_refused": "هذه من مهارات هرمز نفسه، وهي للقراءة فقط هنا.",
    "close": "إغلاق",
    "library": {
      "title": "مكتبة Core Hub",
      "hint": "من مهارات Core Hub نفسه. يحدّثها Core Hub ما دامت كما شُحنت، ولك أن تعدّلها: المهارة التي تعدّلها تصير لك ولا يُكتب فوقها أبدًا.",
      "edited": "معدّلة",
      "edited_hint": "عدّلتَ هذه المهارة، فلم يعد Core Hub يحدّثها. «استعادة» ترجع نسخة المكتبة.",
      "edited_count": "المعدّلة: {count}",
      "restore": "استعادة",
      "restore_title": "استعادة {name}؟",
      "restore_body": "تُستبدل تعديلاتك على هذه المهارة بالنسخة التي يشحنها Core Hub. والمهارة التي أطفأتها تبقى مطفأة.",
      "restored": "رجعت {name} إلى نسخة المكتبة.",
      "summary_on": "{installed} من {available} مهارة في هذا البروفايل: الصور والمستندات والبيانات والبحث والترجمة والعروض والجدولة. تُحدَّث تلقائيًا حتى تعدّل إحداها.",
      "summary_none": "لم تُثبَّت بعد في هذا البروفايل: {available} مهارة للصور والمستندات والبيانات والبحث والترجمة والعروض والجدولة.",
      "summary_off": "مطفأة في هذا البروفايل. شغّلها لتُثبَّت مهارات Core Hub من جديد.",
      "install": "تثبيت",
      "switch": "مكتبة Core Hub في هذا البروفايل",
      "off_title": "إيقاف مكتبة Core Hub؟",
      "off_body": "تُحذف مهاراتها من هذا البروفايل، إلا التي عدّلتها فتبقى لك. ولا يثبّتها Core Hub ولا يحدّثها هنا حتى تشغّلها من جديد.",
      "off_confirm": "إيقاف",
      "editor_note": "من مهارات Core Hub نفسه. متى حفظت تعديلًا صارت لك: يتوقف Core Hub عن تحديثها، و«استعادة» ترجع نسخته.",
      "not_library": "هذه المهارة ليست من مهارات Core Hub.",
      "off_refused": "مكتبة Core Hub مطفأة في هذا البروفايل؛ شغّلها أولًا."
    },
    "essential_refused": "دليل هرمز نفسه (hermes-agent) يعمل دائمًا: هرمز لا يسمح بإطفائه."
  },
  "mcp": {
    "title_of": "خوادم MCP لـ {name}",
    "new": "خادم جديد",
    "enabled": "مفعّل",
    "name": "الاسم",
    "config": "إعداد الخادم",
    "name_bad": "حروف وأرقام و . _ - فقط",
    "invalid_json": "النصّ ليس JSON صالحًا بعد.",
    "none": "لا خوادم",
    "none_body": "خوادم MCP تمنح الوكيل أدواتٍ خارج أدواته. أضف واحدًا هنا.",
    "restart_note": "هذه الصفحة تكتب في ملف إعداد الوكيل. هرمز يتّصل بالخوادم عند إقلاعه، فأعد تشغيله ليسري التغيير.",
    "agent_note": "هذه الصفحة تكتب خوادم MCP الخاصة بـ{name} في {path}، وهي نفسها في كل بروفايل. يقرؤها {name} عند بدء المحادثة، فتسري التغييرات من المحادثة التالية. الخادم الموقوف يحفظه كور هب خارج ذلك الملف حتى تعيد تشغيله.",
    "agent_note_no_path": "هذه الصفحة تكتب خوادم MCP الخاصة بـ{name}، وهي نفسها في كل بروفايل. يقرؤها {name} عند بدء المحادثة، فتسري التغييرات من المحادثة التالية.",
    "not_managed": "لا يعرض كور هب خوادم MCP الخاصة بـ{name} بعد. تُضبط في ملف إعداداته، ويمكنك تحريره من «ملفات الإعداد». أدوات كور هب أدناه تصل إلى {name} مع ذلك.",
    "config_has_comments": "ملف إعدادات الوكيل فيه تعليقات سيفقدها كور هب إن أعاد كتابته. احذفها من «ملفات الإعداد»، أو عدّل الخادم هناك.",
    "config_busy": "الوكيل يكتب ملف إعداداته الآن. حاول مرة أخرى بعد لحظة.",
    "editor_note": "كل خادم MCP له حقوله. يُحرَّر كما هو، ولا يُسقَط منه ما لا نعرفه. والمفتاح السرّي يُقرأ [stored]، وتركه كما هو يُبقي المحفوظ.",
    "delete_title": "حذف {name}؟",
    "delete_body": "يُحذف من ملف الإعداد. لا يُحذف شيء من الخادم نفسه.",
    "address": "العنوان",
    "command": "الأمر",
    "test": {
      "button": "اختبار",
      "running": "يختبر…",
      "ok": "اتصل هرمز — {count} أدوات، {seconds} ث.",
      "no_tools": "الخادم لا يعرض أي أداة.",
      "failed": "لم يستطع هرمز الاتصال:"
    },
    "oauth": {
      "status": {
        "connected": "متصل",
        "expired": "منتهي",
        "not_connected": "غير متصل",
        "error": "تعذّرت قراءة الدخول"
      },
      "connect": "ربط عبر OAuth",
      "reconnect": "إعادة الربط عبر OAuth",
      "disconnect": "فصل",
      "disconnect_title": "فصل {name}؟",
      "disconnect_body": "ينسى هرمز تسجيل الدخول إلى هذا الخادم في هذا البروفايل، وتبقى البروفايلات الأخرى على حالها. المحادثة التي تستخدم الخادم الآن تبقى عليه حتى يُعاد تشغيل الوكيل.",
      "per_profile": "كل بروفايل يُربط وحده.",
      "starting": "يطلب من هرمز بدء تسجيل الدخول…",
      "waiting": "أكمل تسجيل الدخول في الصفحة التي فُتحت في تبويب جديد؛ هذه الصفحة تتحدّث وحدها.",
      "open_page": "افتح صفحة تسجيل الدخول",
      "approved": "تم الربط — عدد الأدوات التي يعرضها هرمز: {count}.",
      "test_now": "اختبر الآن",
      "failed": "لم يكتمل تسجيل الدخول:",
      "cancelled": "أُلغي تسجيل الدخول.",
      "expired": "انتهت مهلة تسجيل الدخول قبل أن يكتمل. ابدأه من جديد.",
      "test_needs": "هذا الخادم يحتاج إلى تسجيل دخول.",
      "starting_short": "يبدأ…"
    },
    "signin_add": {
      "how": "طريقة الإضافة",
      "mode_json": "JSON",
      "mode_signin": "تسجيل دخول (OAuth)",
      "note": "لخادم يسجّل الدخول عبر مزوّده مثل ClickUp: أعطِ عنوانه وسجّل الدخول، ويكتب كور هب الباقي.",
      "about": "يضيف كور هب الخادم بهذا العنوان، ويفتح صفحة تسجيل الدخول لدى المزوّد في تبويب جديد، ويختبر الخادم بعد تسجيل دخولك.",
      "url": "عنوان الخادم",
      "url_bad": "عنوان يبدأ بـ https:// (و http:// لهذا الجهاز فقط).",
      "submit": "أضف وسجّل الدخول",
      "name_taken": "يوجد خادم باسم {name}؛ اختر اسمًا آخر."
    },
    "tools": {
      "count": "الأدوات: {count}",
      "count_filtered": "الأدوات: {allowed} من {total}",
      "failed_badge": "فشل الاختبار",
      "tested_at": "آخر اختبار {when}",
      "stale": "تغيّرت إعدادات هذا الخادم بعد آخر اختبار، فقد لا تكون القائمة محدّثة. اختبره مرة أخرى.",
      "auto_testing": "يُختبر الخادم لعرض أدواته…",
      "heading": "الأدوات المسموحة للوكيل",
      "allowed": "المسموح: {allowed} من {total}",
      "all": "الكل",
      "none": "لا شيء",
      "read_only": "للقراءة فقط",
      "read_only_hint": "«للقراءة فقط» تحدد الأدوات التي تقرأ أو تسرد أو تبحث أو تجلب فقط، وتلغي التي تنشئ أو تعدّل أو تحذف أو ترسل أو تشغّل. بجانب كل أداة كيف صُنّفت؛ راجعها قبل الحفظ.",
      "access": {
        "read": "قراءة",
        "write": "تعديل",
        "unknown": "غير واضح"
      },
      "access_annotation": "الخادم يصف هذه الأداة بأنها للقراءة فقط.",
      "access_name": "مُستنتج من اسم الأداة.",
      "search": "ابحث في الأدوات",
      "no_match": "لا أداة تطابق البحث.",
      "locked": "يحددها النمط {pattern} في ملف الإعداد.",
      "note_all": "بلا تصفية: يحصل الوكيل على كل الأدوات، ومنها ما يضيفه الخادم لاحقًا.",
      "note_include": "الأدوات المحددة فقط. الأداة التي يضيفها الخادم لاحقًا تبقى مغلقة حتى تحددها.",
      "note_exclude": "كل الأدوات عدا غير المحددة، ومنها ما يضيفه الخادم لاحقًا.",
      "undo": "تراجع",
      "saved": "حُفظ. يطبّقه Hermes عند اتصاله التالي بهذا الخادم، بعد إعادة التشغيل."
    }
  },
  "hub_tools": {
    "title": "أدوات {product}",
    "subtitle": "يقدّم {product} نفسه لهذا الوكيل خادمَ MCP، فيعمل الوكيل على لوحة المهام والجداول والمحادثات والملفات في هذا البروفايل.",
    "enabled": "تقديم أدوات {product}",
    "acts_as": "كل استدعاء يعمل باسم صاحب المحادثة، في هذا البروفايل وحده، وبصلاحيات ذلك الشخص — ولا يكون مديرًا أبدًا. لا يستعملها إلا ما يشغّله المركز من محادثات؛ الرسالة الواردة من قناة لا تستطيع.",
    "shared_note": "هذه الإعدادات للبروفايل، وهي نفسها في صفحة كل وكيل. يُعطى {name} خادم {product} عند بدء المحادثة، إن كان يستطيع الوصول إلى خادم MCP عبر HTTP.",
    "allow_writes": "السماح بالتعديل",
    "writes_only": "تعديل فقط: لا قراءة هنا.",
    "recent": "آخر الاستدعاءات",
    "no_calls": "لا استدعاءات بعد.",
    "call_ok": "تم",
    "call_failed": "رُفض",
    "group": {
      "tasks": "المهام",
      "schedules": "الجداول",
      "conversations": "المحادثات",
      "notifications": "التنبيهات",
      "workflows": "سير العمل",
      "files": "الملفات",
      "devices": "حواسيبك"
    },
    "group_about": {
      "tasks": "عرض مهام اللوحة؛ ومع السماح بالتعديل: إنشاؤها ونقلها وإسنادها والتعليق عليها.",
      "schedules": "عرض الجداول؛ ومع السماح بالتعديل: إنشاء جدول أو إيقافه أو تشغيله الآن.",
      "conversations": "عرض محادثات هذا البروفايل والبحث فيها وقراءة ملخّص إحداها.",
      "notifications": "إخبار الشخص بشيء: تنبيه في صندوقه.",
      "workflows": "عرض سير العمل؛ ومع السماح بالتعديل: تشغيل أحدها.",
      "files": "قراءة ملفات مجلد هذا البروفايل؛ ومع السماح بالتعديل: كتابتها.",
      "devices": "استعمال المجلدات المشاركة والبرامج على حواسيب الشخص نفسه التي يعمل عليها تطبيق كور هب (كل حاسوب يستأذن صاحبه أولًا). ومع السماح بالتغيير: كتابة الملفات وتشغيل البرامج هناك."
    },
    "unavailable": {
      "runtime_absent": "هرمز غير متاح على جهاز المركز، لذا لا يمكن منحه الأدوات.",
      "hermes_profile_absent": "ليس لهذا البروفايل مجلد في هرمز بعد. ابدأ محادثة فيه أولًا."
    },
    "reason": {
      "hub_tools_no_live_run": "لم تكن هناك محادثة جارية، فلا أحد يُعمل باسمه",
      "hub_tools_run_ambiguous": "كانت لعدة أشخاص محادثات جارية ولم يعرف المركز لمن هذه",
      "hub_tools_tool_off": "هذه الأداة مطفأة هنا",
      "path_outside_profile": "المسار خارج مجلد البروفايل",
      "forbidden": "لا يحق للشخص ذلك",
      "not_found": "غير موجود",
      "validation_failed": "المدخلات غير صحيحة",
      "hub_tools_sender_not_linked": "جاءت الرسالة من حساب مراسلة لم يربطه أحد",
      "hub_tools_sender_no_access": "صاحب ذلك الحساب لا يدخل هذا البروفايل",
      "hub_tools_group_chat": "جاءت الرسالة من محادثة مجموعة"
    }
  },
  "memory": {
    "title_of": "ذاكرة {name}",
    "persona": "يُقرأ عند كل إقلاع",
    "content": "النصّ",
    "note": "ثلاث وثائق يقرأها الوكيل عند بدء المحادثة، فما تغيّره هنا يصل إلى محادثته التالية. تُفرَغ بالتحرير، ولا تُحذف.",
    "write": "اكتب",
    "doc_soul": "الشخصية",
    "doc_memory": "الذاكرة",
    "doc_user": "عنك",
    "about_soul": "من هو الوكيل. يقرأها في بداية كل محادثة.",
    "about_memory": "ما تعلّمه واختار أن يحتفظ به.",
    "about_user": "ما يعرفه عنك أنت.",
    "empty_soul": "لم تُكتب بعد — الوكيل بلا شخصية محدّدة.",
    "empty_memory": "لم يحتفظ بشيء بعد.",
    "empty_user": "لم يكتب عنك شيئًا بعد.",
    "entries_hint": "قائمة مدخلات قصيرة، يفصل بين كل مدخل والذي يليه سطر فيه § وحده. ولها حدّ من الأحرف: إذا تجاوزته لم يستطع الوكيل أن يضيف إليها شيئًا.",
    "too_long": "أطول مما تتّسع له هذه الذاكرة: {length} حرفًا، والحد {limit}. اختصر المدخلات أو ادمجها.",
    "add_entry": "أضف مدخلًا",
    "edit_all": "حرّر الكل",
    "edit_entry": "حرّر هذا المدخل",
    "remove": "أزل",
    "remove_title": "إزالة هذا المدخل؟",
    "entry": "المدخل",
    "add_entry_title": "مدخل جديد في {name}",
    "edit_entry_title": "مدخل في {name}",
    "budget": "{count} من {limit} حرفًا",
    "budget_over": "{count} من {limit} حرفًا — ممتلئة: لا يستطيع الوكيل أن يحتفظ بجديد"
  },
  "channels": {
    "title_of": "قنوات {name}",
    "enabled": "مفعّلة",
    "exclusive": "هوية واحدة",
    "not_configured": "غير مهيّأة",
    "fields_n": "الحقول: {count}",
    "clear": "نسيان الهوية",
    "none": "لا منصة مربوطة بعد",
    "none_body": "اربط منصة ليرد الوكيل على الناس فيها: تيليجرام وواتساب وديسكورد والبريد وغيرها.",
    "restart_note": "هرمز يتّصل بهذه المنصّات عند إقلاعه: أعد تشغيله ليسري التغيير.",
    "editor_note": "الحقول من ملف الوكيل لا من استمارة كتبناها. السرّ يُقرأ [stored]، وتركه كما هو يُبقي المحفوظ.",
    "secret_hint": "اتركه كما هو للإبقاء على المحفوظ.",
    "no_fields": "لا حقول في هذه القناة بعد.",
    "clear_title": "نسيان هوية {name}؟",
    "clear_body": "تُحذف الرموز والأسرار وتُطفأ القناة. باقي إعداداتها يبقى كما هو.",
    "login": {
      "button": "ربط برمز QR",
      "title": "ربط {name}",
      "note": "يربط هرمز وكيل هذا البروفايل بجوّال. امسح الرمز من واتساب في الجوّال: الإعدادات ← الأجهزة المرتبطة ← ربط جهاز.",
      "expires": "الرمز صالح حتى {time}.",
      "done": "تم الربط. يردّ الوكيل عليه بعد إعادة تشغيله القادمة.",
      "done_as": "تم الربط باسم {account}. يردّ الوكيل عليه بعد إعادة تشغيله القادمة.",
      "failed": "فشل الربط.",
      "cancelled": "أُوقف الربط.",
      "again": "ابدأ من جديد",
      "close": "إغلاق",
      "not_supported": "هذه المنصّة لا تُربط برمز QR؛ املأ حقولها بدلًا من ذلك.",
      "done_now": "تم الربط. يردّ الوكيل عليه الآن؛ أوّل من يراسله ينتظر موافقتك هنا.",
      "done_as_now": "تم الربط باسم {account}. يردّ الوكيل عليه الآن؛ أوّل من يراسله ينتظر موافقتك هنا.",
      "done_self_now": "تم الربط. افتح «مراسلة نفسي» في واتساب على جوّالك واكتب للوكيل.",
      "done_as_self_now": "تم الربط باسم {account}. افتح «مراسلة نفسي» في واتساب على جوّالك واكتب للوكيل."
    },
    "linked": "مربوط",
    "not_linked": "غير مربوط",
    "linked_as": "مربوط بحساب {account}",
    "unlink": "إلغاء الربط",
    "unlink_title": "إلغاء ربط {name}؟",
    "unlink_body": "يتوقّف الوكيل عن الردّ على هذا الرقم، وتُحذف جلسته من هذا البروفايل، وتُطفأ القناة. المرسلون المعتمدون يبقون. احذف الجهاز من الجوّال أيضًا: واتساب ← الأجهزة المرتبطة.",
    "unlinked_note": "أُلغي الربط. احذف الجهاز أيضًا من واتساب في الجوّال: الإعدادات ← الأجهزة المرتبطة.",
    "unlink_not_linked": "لا رقم مربوط في هذا البروفايل.",
    "unlink_not_supported": "هذه المنصّة لا تُربط بجهاز، فلا ربط يُلغى؛ انسَ هويتها بدلًا من ذلك.",
    "applies_now": "في هذا البروفايل يعيد المركز تشغيل بوابة الرسائل بنفسه، فيسري التغيير فورًا.",
    "status": {
      "online": "متّصلة",
      "offline": "غير متّصلة",
      "error": "خطأ",
      "unknown": "غير معروف"
    },
    "gateway": {
      "running": "البوابة تعمل",
      "starting": "البوابة تُقلع",
      "stopped": "لا بوابة تعمل",
      "error": "البوابة متعطّلة"
    },
    "how": {
      "title": "كيف تستخدمه",
      "step_message": "1) أرسل رسالة إلى الرقم المربوط من حساب واتساب آخر.",
      "step_message_as": "1) أرسل رسالة إلى {account} من حساب واتساب آخر.",
      "step_approve": "2) يصل المرسلَ رمزُ اقتران، ويظهر طلبه في «الموافقات» أعلى هذه الصفحة: وافق عليه، فيبدأ الوكيل بالردّ عليه.",
      "personal_warning": "تنبيه: إن كان هذا رقمك الشخصي فكلّ من يراسله يتلقّى ردّ الاقتران من الوكيل. اختر «أنا (مراسلة نفسي)» بدلًا من ذلك.",
      "self_step_open": "1) افتح واتساب في جوّالك، ثم محادثة «مراسلة نفسي» (ابحث عن اسمك).",
      "self_step_open_as": "1) افتح واتساب في الجوّال الذي عليه {account}، ثم محادثة «مراسلة نفسي» (ابحث عن اسمك).",
      "self_step_write": "2) اكتب للوكيل هناك. يردّ في المحادثة نفسها، وكل ردّ مميّز بأنه من الوكيل.",
      "self_note": "لا يصل إلى الوكيل أحد غيرك ممن يراسل هذا الرقم."
    },
    "pairing": {
      "title": "طلبات بانتظار الموافقة",
      "note": "من يراسل الوكيل أوّل مرة يتلقّى رمز اقتران وينتظر هنا. الطلب ينتهي بعد ساعة.",
      "none": "لا طلبات الآن.",
      "unnamed": "بلا اسم",
      "approve": "موافقة",
      "deny": "رفض",
      "approved_title": "المرسلون المعتمدون",
      "approved_none": "لا أحد معتمد بعد.",
      "revoke": "إزالة",
      "revoke_title": "إزالة {name}؟",
      "revoke_body": "لن يردّ الوكيل عليه بعد الآن، ورسالته التالية تصير طلب اقتران جديدًا.",
      "just_now": "الآن",
      "minutes_ago": "قبل {count} د",
      "hours_ago": "قبل {count} س"
    },
    "telegram": {
      "link_button": "ربط",
      "title": "ربط تيليجرام",
      "intro": "الوكيل يرد عبر بوت تيليجرام خاص بك. تصنع البوت بنفسك في تيليجرام خلال دقيقة، والمركز لا يصنعه نيابة عنك.",
      "step_open": "افتح تيليجرام وابحث عن ‎@BotFather‎ (الرسمي، بعلامة التوثيق الزرقاء).",
      "step_newbot": "أرسل له ‎/newbot‎، ثم اختر اسمًا للبوت واسم مستخدم ينتهي بـ bot.",
      "step_copy": "سيرد عليك برمز (توكن) يشبه ‎123456789:AA…‎ — انسخه والصقه هنا.",
      "token": "رمز البوت",
      "token_hint": "يُحفظ سرًّا في ملفات هرمز لهذا البروفايل، ولا يُعرض مرة أخرى.",
      "allowed": "أشخاص لا يحتاجون موافقة (اختياري)",
      "allowed_hint": "أرقام معرّفات تيليجرام، تفصل بينها فاصلة. لتعرف رقمك راسل ‎@userinfobot‎ في تيليجرام. كل من سواهم يصله رمز اقتران توافق عليه هنا.",
      "allowed_invalid": "معرّف مستخدم تيليجرام أرقام فقط.",
      "submit": "تحقّق واربط",
      "checking": "نسأل تيليجرام…",
      "done_as": "تم الربط: {account}.",
      "done_now": "الوكيل يرد على البوت الآن. أول من يراسله ينتظر موافقتك في «الموافقات» أعلى صفحة القنوات.",
      "done_restart": "في البروفايل الافتراضي أعد تشغيل هرمز من بطاقته ليبدأ الرد على البوت.",
      "token_invalid": "هذا لا يبدو رمز بوت. الرمز رقم البوت ثم نقطتان ثم رمز طويل، كما أرسله BotFather.",
      "token_rejected": "رفض تيليجرام هذا الرمز: {message}. انسخه من جديد من BotFather (أو أرسل له ‎/token‎ لرمز جديد).",
      "unreachable": "لم يرد تيليجرام. تأكد من اتصال المركز بالإنترنت وحاول مرة أخرى.",
      "token_in_use": "هذا البوت مربوط في البروفايل «{profile}». البوت يرد من مكان واحد فقط: ألغِ ربطه هناك أولًا.",
      "how_title": "كيف تبدأ",
      "how_open": "1) افتح البوت:",
      "how_open_unnamed": "1) افتح البوت في تيليجرام.",
      "how_message": "2) أرسل له أي رسالة، وسيرد برمز اقتران.",
      "how_approve": "3) وافق على الطلب من زر «الموافقات» أعلى هذه الصفحة، وبعدها يرد الوكيل.",
      "unlink_body": "يُحذف الرمز من هذا البروفايل ويتوقف الوكيل عن الرد على البوت. البوت نفسه يبقى في تيليجرام (احذفه من ‎@BotFather‎ إن أردت). ويبقى الأشخاص الذين سمحت لهم في القائمة.",
      "unlinked_note": "أُلغي الربط. البوت لم يعد يرد من هذا البروفايل."
    },
    "settings": {
      "open": "الإعدادات",
      "title": "إعدادات تيليجرام",
      "applies_now": "الحفظ يعيد تشغيل بوابة هذا البروفايل، فتسري التغييرات فورًا.",
      "applies_restart": "في البروفايل الافتراضي تسري التغييرات بعد إعادة تشغيل هرمز.",
      "section": {
        "access": "من يراسل البوت",
        "replies": "الردود",
        "groups": "المجموعات والقنوات",
        "media": "الوسائط والصوت",
        "advanced": "متقدم"
      },
      "media_note": "هذه إعدادات البروفايل نفسه: تغيّر واتساب وكل قنوات هذا البروفايل أيضًا.",
      "shared": "يغيّر واتساب والقنوات الأخرى أيضًا",
      "default_is": "الافتراضي: {value}",
      "default_none": "الافتراضي: لا شيء",
      "on": "مفعّل",
      "off": "معطّل",
      "reset": "رجوع للافتراضي",
      "discard": "تجاهل التغييرات",
      "list_placeholder": "123456789, 987654321",
      "invalid": "هذه القيمة غير مقبولة. تحقّق من الصيغة.",
      "saved_now": "تم الحفظ. تُعاد تشغيل البوابة بالإعدادات الجديدة.",
      "saved_restart": "تم الحفظ. أعد تشغيل هرمز من بطاقته لتسري.",
      "option": {
        "allowed_users": {
          "label": "أشخاص لا يحتاجون موافقة",
          "help": "معرّفات مستخدمي تيليجرام الذين يراسلون البوت دون رمز اقتران. لتعرف رقمك راسل ‎@userinfobot‎."
        },
        "unauthorized_dm_behavior": {
          "label": "عندما يراسل البوتَ شخصٌ غريب",
          "help": "يُرسَل له رمز اقتران توافق عليه هنا، أو يُتجاهل بصمت."
        },
        "show_reasoning": {
          "label": "إظهار تفكير النموذج",
          "help": "قبل كل إجابة يُضاف تفكير النموذج في كتلة مستقلة."
        },
        "reasoning_style": {
          "label": "شكل التفكير",
          "help": "طريقة عرض كتلة التفكير."
        },
        "tool_progress": {
          "label": "إظهار ما يفعله الوكيل",
          "help": "رسائل عن الأدوات التي يستخدمها الوكيل أثناء العمل."
        },
        "cleanup_progress": {
          "label": "حذف رسائل التقدّم بعد الانتهاء",
          "help": "تُحذف رسائل «يعمل…» والأدوات بعد إجابة ناجحة."
        },
        "streaming": {
          "label": "كتابة الإجابة أولًا بأول",
          "help": "تظهر الإجابة وهي تُكتب بتعديل رسالة واحدة، بدل إرسالها كاملة في النهاية."
        },
        "reply_to_mode": {
          "label": "الرد باقتباس",
          "help": "هل تقتبس الإجابة الرسالة التي ترد عليها."
        },
        "reactions": {
          "label": "التفاعلات",
          "help": "تفاعل 👀 أثناء العمل، ثم ✅ أو ❌ عند الانتهاء."
        },
        "typing_indicator": {
          "label": "مؤشر «يكتب…»",
          "help": "يظهر «يكتب…» أثناء عمل الوكيل."
        },
        "disable_link_previews": {
          "label": "بلا معاينة للروابط",
          "help": "تُرسل الروابط دون بطاقة المعاينة."
        },
        "notifications": {
          "label": "صوت الإشعار",
          "help": "أي رسائل البوت تُصدر تنبيهًا في الجوال."
        },
        "require_mention": {
          "label": "في المجموعات: الرد عند الإشارة فقط",
          "help": "في المجموعة يرد البوت فقط على رسالة تشير إليه ‎@‎ أو ترد عليه. المحادثات الخاصة لا تتأثر."
        },
        "allowed_chats": {
          "label": "هذه المجموعات فقط",
          "help": "معرّفات المجموعات التي يرد فيها البوت (تبدأ بـ ‎-100‎). فارغ: أي مجموعة يُضاف إليها."
        },
        "free_response_chats": {
          "label": "مجموعات بلا حاجة للإشارة",
          "help": "معرّفات مجموعات يرد فيها البوت على كل رسالة حتى لو كانت الإشارة مطلوبة."
        },
        "group_allowed_users": {
          "label": "أشخاص مسموح لهم في المجموعات",
          "help": "معرّفات مستخدمين يرد البوت على رسائلهم في المجموعات، ولا يعني هذا السماح لهم بمراسلته على الخاص."
        },
        "observe_unmentioned_group_messages": {
          "label": "قراءة رسائل المجموعة التي لا يرد عليها",
          "help": "تُحفظ رسائل المجموعة بلا إشارة سياقًا للإجابة التالية."
        },
        "guest_mode": {
          "label": "الرد على الإشارة في أي مجموعة",
          "help": "يرد على ‎@‎الإشارة حتى في مجموعات ليست في القائمة أعلاه."
        },
        "exclusive_bot_mentions": {
          "label": "تجاهل الرسائل الموجّهة لبوتات أخرى",
          "help": "تُتجاهل رسالة المجموعة التي تشير إلى بوت آخر."
        },
        "allow_bots": {
          "label": "رسائل البوتات الأخرى",
          "help": "هل يرد على الرسائل التي ترسلها بوتات أخرى."
        },
        "stt_enabled": {
          "label": "تحويل الرسائل الصوتية إلى نص",
          "help": "الرسائل الصوتية تُحوَّل نصًا يفهمه الوكيل."
        },
        "stt_echo_transcripts": {
          "label": "إظهار النص المحوَّل",
          "help": "يُعاد النص المحوَّل للمرسل ليرى ما فُهم."
        },
        "voice_auto_tts": {
          "label": "الرد برسائل صوتية",
          "help": "تُرسل الإجابات صوتًا أيضًا. في المحادثة يغيّر ‎/voice‎ هذا لتلك المحادثة."
        },
        "home_channel": {
          "label": "المحادثة الرئيسية",
          "help": "معرّف المحادثة التي تصلها المهام المجدولة والتنبيهات. في تيليجرام يضبطها ‎/sethome‎ أيضًا."
        },
        "gateway_restart_notification": {
          "label": "التنبيه عند العودة",
          "help": "رسالة في المحادثة الرئيسية عند إعادة تشغيل الوكيل."
        },
        "command_menu_max": {
          "label": "عدد الأوامر في القائمة",
          "help": "كم أمرًا تعرض قائمة ‎/‎ في البوت (من 1 إلى 100)."
        },
        "proxy_url": {
          "label": "بروكسي",
          "help": "الوصول إلى تيليجرام عبر بروكسي مثل ‎socks5://host:1080‎. اتركه فارغًا للاتصال المباشر."
        },
        "allowed_roles": {
          "label": "أدوار مسموح لها",
          "help": "معرّفات أدوار السيرفر (أرقام). من يحمل أحدها يرد عليه البوت."
        },
        "allowed_channels": {
          "label": "هذه القنوات فقط",
          "help": "معرّفات القنوات التي يرد فيها. فارغ: كل قناة يصلها."
        },
        "free_response_channels": {
          "label": "قنوات بلا حاجة للإشارة",
          "help": "معرّفات قنوات يرد فيها على كل رسالة."
        },
        "ignored_channels": {
          "label": "قنوات يتجاهلها",
          "help": "معرّفات قنوات لا يرد فيها أبدًا، ولو أُشير إليه."
        },
        "auto_thread": {
          "label": "الرد في سلسلة (Thread)",
          "help": "عند الإشارة إليه في قناة يفتح سلسلة ويرد فيها."
        },
        "thread_require_mention": {
          "label": "في السلاسل: الرد عند الإشارة فقط",
          "help": "داخل السلاسل لا يرد إلا إذا أُشير إليه."
        },
        "no_thread_channels": {
          "label": "قنوات بلا سلاسل",
          "help": "معرّفات قنوات يرد فيها مباشرة دون فتح سلسلة."
        },
        "disable_dms": {
          "label": "تجاهل الرسائل المباشرة",
          "help": "لا يرد على الرسائل المباشرة، في القنوات فقط."
        },
        "reply_in_thread": {
          "label": "الرد في سلسلة",
          "help": "يرد في سلسلة تحت الرسالة بدل القناة نفسها."
        },
        "reply_broadcast": {
          "label": "إظهار الرد في القناة أيضًا",
          "help": "أول جزء من الرد في السلسلة يظهر في القناة كذلك."
        },
        "strict_mention": {
          "label": "إشارة صريحة في كل رسالة",
          "help": "في السلاسل لا يرد إلا على رسالة فيها إشارة صريحة إليه."
        },
        "free_response_rooms": {
          "label": "غرف بلا حاجة للإشارة",
          "help": "معرّفات غرف يرد فيها على كل رسالة (تبدأ بـ !)."
        },
        "allowed_rooms": {
          "label": "هذه الغرف فقط",
          "help": "معرّفات الغرف التي يرد فيها. الرسائل المباشرة لا تتأثر."
        },
        "dm_mention_threads": {
          "label": "سلسلة عند الإشارة في الخاص",
          "help": "في المحادثة المباشرة، الإشارة إليه تفتح سلسلة."
        },
        "e2ee_mode": {
          "label": "التشفير من الطرف للطرف",
          "help": "هل يستعمل التشفير في الغرف المشفّرة."
        },
        "reply_mode": {
          "label": "شكل الرد",
          "help": "في سلسلة تحت الرسالة، أو رسالة عادية في القناة."
        },
        "require_authenticated_sender": {
          "label": "التحقق من المرسل",
          "help": "لا يُقبل إلا بريد تحقّق خادمك من مرسله (SPF/DKIM/DMARC)، فلا ينتحل أحد عنوانًا في القائمة."
        },
        "skip_attachments": {
          "label": "تجاهل المرفقات",
          "help": "لا تُقرأ مرفقات الرسائل."
        },
        "poll_interval": {
          "label": "فحص البريد كل (ثانية)",
          "help": "كم ثانية بين فحص وآخر للبريد الجديد (من 5 إلى 3600)."
        }
      },
      "choice": {
        "unauthorized_dm_behavior": {
          "pair": "إرسال رمز اقتران",
          "ignore": "تجاهل"
        },
        "reasoning_style": {
          "code": "كتلة برمجية",
          "blockquote": "اقتباس",
          "subtext": "نص صغير"
        },
        "tool_progress": {
          "off": "إيقاف",
          "new": "الأدوات الجديدة فقط",
          "all": "كل أداة",
          "verbose": "كل أداة بالتفصيل"
        },
        "reply_to_mode": {
          "off": "أبدًا",
          "first": "أول رسالة من الإجابة",
          "all": "كل رسالة"
        },
        "notifications": {
          "important": "الإجابات النهائية والموافقات فقط",
          "all": "كل رسالة"
        },
        "allow_bots": {
          "none": "تجاهلها",
          "all": "الرد عليها",
          "mentions": "الرد عند الإشارة فقط"
        },
        "e2ee_mode": {
          "off": "معطّل",
          "optional": "عند الحاجة",
          "required": "إلزامي"
        },
        "reply_mode": {
          "off": "رسالة عادية",
          "thread": "في سلسلة"
        }
      },
      "title_of": "إعدادات {name}",
      "platform": {
        "discord": {
          "option": {
            "allowed_users": {
              "label": "أشخاص يرد عليهم البوت",
              "help": "معرّفات مستخدمي ديسكورد. من ليس هنا، ولا يحمل دورًا مسموحًا، لا يُرد عليه."
            },
            "require_mention": {
              "label": "في القنوات: الرد عند الإشارة فقط",
              "help": "في قنوات السيرفر يرد فقط على رسالة تشير إليه ‎@‎. الرسائل المباشرة لا تتأثر."
            },
            "home_channel": {
              "label": "القناة الرئيسية",
              "help": "معرّف القناة التي تصلها المهام المجدولة والتنبيهات. يضبطها ‎/set-home‎ أيضًا."
            },
            "reactions": {
              "label": "التفاعلات",
              "help": "تفاعل أثناء العمل وبعد الانتهاء على رسالتك."
            }
          },
          "list_placeholder": "123456789012345678, 876543210987654321"
        },
        "slack": {
          "option": {
            "allowed_users": {
              "label": "أشخاص لا يحتاجون موافقة",
              "help": "معرّفات أعضاء سلاك (مثل U01ABCDEF). كل من سواهم يصله رمز اقتران."
            },
            "require_mention": {
              "label": "في القنوات: الرد عند الإشارة فقط",
              "help": "في القنوات يرد فقط على رسالة تشير إليه. الرسائل المباشرة لا تتأثر."
            },
            "home_channel": {
              "label": "القناة الرئيسية",
              "help": "معرّف القناة (يبدأ بـ C) التي تصلها المهام المجدولة والتنبيهات."
            },
            "reactions": {
              "label": "التفاعلات",
              "help": "تفاعل أثناء العمل وبعد الانتهاء على رسالتك."
            }
          },
          "list_placeholder": "C01ABCDEF, C02GHIJKL"
        },
        "matrix": {
          "option": {
            "allowed_users": {
              "label": "أشخاص لا يحتاجون موافقة",
              "help": "معرّفات ماتريكس الكاملة (مثل ‎@sara:matrix.org‎). كل من سواهم يصله رمز اقتران."
            },
            "require_mention": {
              "label": "في الغرف: الرد عند الإشارة فقط",
              "help": "في الغرف يرد فقط على رسالة تشير إليه. الرسائل المباشرة لا تتأثر."
            },
            "home_channel": {
              "label": "الغرفة الرئيسية",
              "help": "معرّف الغرفة (يبدأ بـ !) التي تصلها المهام المجدولة والتنبيهات."
            },
            "reactions": {
              "label": "التفاعلات",
              "help": "تفاعل أثناء العمل وبعد الانتهاء على رسالتك."
            }
          },
          "section": {
            "groups": "الغرف"
          },
          "list_placeholder": "!abc:matrix.org"
        },
        "mattermost": {
          "option": {
            "allowed_users": {
              "label": "أشخاص لا يحتاجون موافقة",
              "help": "معرّفات مستخدمي ماترموست. كل من سواهم يصله رمز اقتران."
            },
            "require_mention": {
              "label": "في القنوات: الرد عند الإشارة فقط",
              "help": "في القنوات يرد فقط على رسالة تشير إليه ‎@‎. الرسائل المباشرة لا تتأثر."
            },
            "home_channel": {
              "label": "القناة الرئيسية",
              "help": "معرّف القناة التي تصلها المهام المجدولة والتنبيهات."
            }
          },
          "list_placeholder": "channelid1, channelid2"
        },
        "email": {
          "option": {
            "allowed_users": {
              "label": "عناوين يرد عليها الوكيل",
              "help": "عناوين بريد. رسائل غيرهم تُتجاهل، ولا يُرسل لهم رمز اقتران."
            },
            "home_channel": {
              "label": "العنوان الرئيسي",
              "help": "العنوان الذي تصله نتائج المهام المجدولة والتنبيهات."
            }
          },
          "section": {
            "access": "من يراسل الوكيل",
            "media": "المرفقات"
          },
          "list_placeholder": "sara@example.com, ali@example.com"
        }
      }
    },
    "platform": {
      "link_title": "ربط {name}",
      "badge_first_use": "يُنزَّل عند أول تشغيل",
      "badge_inbound": "يحتاج عنوانًا عامًّا",
      "how_title": "كيف تبدأ مع {name}",
      "how_pairs": "أول من يراسل الوكيل يصله رمز اقتران، ووافق عليه من زر «الموافقات» أعلى هذه الصفحة.",
      "how_allowlist": "لا يرد الوكيل إلا على الأشخاص في قائمة المسموح لهم. تعدّلها من «الإعدادات».",
      "generic_intro": "اكتب قيم {name} كما يقرؤها هرمز. تُحفظ سرًّا في ملفات هرمز لهذا البروفايل.",
      "generic_note": "المركز لا يتحقق من هذه القيم قبل حفظها. إن كان فيها خطأ ستظهر رسالة هرمز في صف المنصة بعد تشغيل البوابة.",
      "first_use_note": "مكتبة هذه المنصة ليست في صورة المركز: ينزّلها هرمز من الإنترنت مرة واحدة عند أول تشغيل، ثم تبقى في مجلد البيانات.",
      "inbound_note": "هذه المنصة ترسل الرسائل إلى عنوان ويب يجب أن يصله الإنترنت، وصورة المركز لا تفتح منفذه وحدها. تحتاج إعدادًا إضافيًا في الخادم.",
      "optional": "{label} (اختياري)",
      "secret_hint": "يُحفظ سرًّا في ملفات هرمز لهذا البروفايل، ولا يُعرض مرة أخرى.",
      "allowed": "أشخاص لا يحتاجون موافقة (اختياري)",
      "allowed_hint": "تفصل بينهم فاصلة. كل من سواهم يصله رمز اقتران توافق عليه هنا.",
      "allowed_hint_generic": "تفصل بينهم فاصلة، كما تسمّيهم المنصة. تُحفظ في {key}.",
      "allowlist_empty": "{name} لا يرد على أي أحد ليس في هذه القائمة، ولا يرسل رمز اقتران. أضف نفسك على الأقل.",
      "submit": "ربط",
      "submit_check": "تحقّق واربط",
      "checking": "نسأل {name}…",
      "done": "تم الربط.",
      "done_as": "تم الربط: {account}.",
      "done_now": "الوكيل يرد على المنصة الآن.",
      "done_restart": "في البروفايل الافتراضي أعد تشغيل هرمز من بطاقته ليبدأ الرد.",
      "invalid": "القيمة «{field}» ناقصة أو بصيغة غير صحيحة.",
      "rejected": "رفض {name} هذه البيانات: {message}",
      "unreachable": "لم يرد {name}. تأكد من العنوان ومن اتصال المركز بالإنترنت، وحاول مرة أخرى.",
      "in_use": "هذا الحساب في {name} مربوط في البروفايل «{profile}». يرد من مكان واحد فقط: ألغِ ربطه هناك أولًا.",
      "unlink_body": "تُحذف بيانات {name} من هذا البروفايل ويتوقف الوكيل عن الرد عليه. الحساب نفسه يبقى في المنصة، ويبقى الأشخاص المسموح لهم والإعدادات.",
      "unlinked_note": "أُلغي ربط {name}. لم يعد يرد من هذا البروفايل.",
      "name": {
        "discord": "ديسكورد",
        "slack": "سلاك",
        "matrix": "Matrix",
        "mattermost": "Mattermost",
        "email": "البريد الإلكتروني",
        "telegram": "تيليجرام",
        "whatsapp": "واتساب",
        "whatsapp_cloud": "واتساب للأعمال",
        "teams": "مايكروسوفت تيمز",
        "google_chat": "قوقل شات",
        "signal": "سيجنال",
        "line": "لاين",
        "sms": "الرسائل النصية (Twilio)"
      },
      "field": {
        "DISCORD_BOT_TOKEN": "رمز البوت (Bot Token)",
        "SLACK_BOT_TOKEN": "رمز البوت (يبدأ بـ xoxb-)",
        "SLACK_APP_TOKEN": "رمز التطبيق (يبدأ بـ xapp-)",
        "MATRIX_HOMESERVER": "عنوان الخادم (Homeserver)",
        "MATRIX_ACCESS_TOKEN": "رمز الدخول (Access Token)",
        "MATTERMOST_URL": "عنوان خادم Mattermost",
        "MATTERMOST_TOKEN": "رمز حساب البوت",
        "EMAIL_ADDRESS": "عنوان البريد",
        "EMAIL_PASSWORD": "كلمة المرور (أو كلمة مرور التطبيق)",
        "EMAIL_IMAP_HOST": "خادم الاستقبال IMAP",
        "EMAIL_IMAP_PORT": "منفذ IMAP (الافتراضي 993)",
        "EMAIL_SMTP_HOST": "خادم الإرسال SMTP",
        "EMAIL_SMTP_PORT": "منفذ SMTP (الافتراضي 587)"
      },
      "discord": {
        "intro": "الوكيل يرد عبر بوت ديسكورد تصنعه أنت من بوابة المطوّرين. المركز يسأل ديسكورد عن البوت قبل أن يحفظ الرمز.",
        "step1": "افتح بوابة مطوّري ديسكورد واضغط New Application، واختر اسمًا.",
        "step2": "من قسم Bot اضغط Reset Token وانسخ الرمز. وفي الصفحة نفسها فعّل Message Content Intent.",
        "step3": "من OAuth2 ← URL Generator اختر الصلاحيتين bot وapplications.commands، ثم Send Messages وRead Message History، وافتح الرابط لتضيف البوت إلى سيرفرك.",
        "step4": "الصق الرمز هنا، واكتب معرّفك في ديسكورد (فعّل Developer Mode ثم اضغط اسمك بالزر الأيمن ← Copy User ID).",
        "allowed": "أشخاص يرد عليهم البوت",
        "allowed_hint": "معرّفات مستخدمي ديسكورد (أرقام)، تفصل بينها فاصلة. ديسكورد لا يرسل رمز اقتران للغرباء، فمن ليس هنا لا يُرد عليه.",
        "how": "أضف البوت إلى سيرفرك بالرابط من بوابة المطوّرين إن لم تفعل، ثم راسله على الخاص أو أشر إليه ‎@‎ في قناة."
      },
      "slack": {
        "intro": "الوكيل يرد عبر تطبيق سلاك تصنعه أنت. المركز يسأل سلاك عن الرمزين قبل أن يحفظهما.",
        "step1": "افتح api.slack.com/apps واضغط Create New App ← From scratch، واختر فريقك في سلاك.",
        "step2": "من Socket Mode فعّله وأنشئ رمز تطبيق بصلاحية connections:write (يبدأ بـ xapp-).",
        "step3": "من OAuth & Permissions أضف للبوت: chat:write وapp_mentions:read وchannels:history وim:history وim:read وim:write وusers:read.",
        "step4": "من Event Subscriptions فعّلها واشترك في app_mention وmessage.im وmessage.channels، ثم من App Home فعّل تبويب Messages.",
        "step5": "اضغط زر التثبيت (Install) في صفحة OAuth & Permissions وانسخ رمز البوت (يبدأ بـ xoxb-)، والصق الرمزين هنا.",
        "allowed_hint": "معرّفات أعضاء سلاك (مثل U01ABCDEF)، تفصل بينها فاصلة. كل من سواهم يصله رمز اقتران توافق عليه هنا.",
        "how": "ادعُ التطبيق إلى قناة بـ ‎/invite‎، ثم أشر إليه أو راسله مباشرة."
      },
      "matrix": {
        "intro": "الوكيل يرد عبر حساب ماتريكس. اصنع حسابًا للبوت على خادمك، والمركز يسأل الخادم عنه قبل الحفظ.",
        "step1": "أنشئ حسابًا للبوت على خادم ماتريكس (مثلًا في Element).",
        "step2": "سجّل الدخول بهذا الحساب في Element، ومن الإعدادات ← Help & About انسخ Access Token.",
        "step3": "اكتب عنوان الخادم (مثل https://matrix.org) والصق الرمز هنا.",
        "allowed_hint": "معرّفات ماتريكس الكاملة (مثل ‎@sara:matrix.org‎)، تفصل بينها فاصلة. كل من سواهم يصله رمز اقتران.",
        "how": "ادعُ حساب البوت إلى غرفة، أو ابدأ معه محادثة مباشرة. مكتبة ماتريكس تُنزَّل عند أول تشغيل."
      },
      "mattermost": {
        "intro": "الوكيل يرد عبر حساب بوت في ماترموست. المركز يسأل الخادم عن الحساب قبل الحفظ.",
        "step1": "في ماترموست افتح Integrations ← Bot Accounts ← Add Bot Account (يفعّلها مدير النظام).",
        "step2": "اختر اسمًا للبوت وانسخ الرمز الذي يظهر بعد الإنشاء.",
        "step3": "اكتب عنوان خادمك (مثل https://chat.example.com) والصق الرمز هنا.",
        "allowed_hint": "معرّفات مستخدمي ماترموست، تفصل بينها فاصلة. كل من سواهم يصله رمز اقتران.",
        "how": "أضف البوت إلى قناة وأشر إليه ‎@‎، أو راسله مباشرة."
      },
      "email": {
        "intro": "الوكيل يقرأ صندوق بريد ويرد على الرسائل. المركز يسجّل الدخول إلى خادمي الاستقبال والإرسال قبل الحفظ، ولا يقرأ ولا يرسل شيئًا.",
        "step1": "يُفضّل بريد مخصّص للوكيل. في Gmail فعّل التحقق بخطوتين ثم أنشئ «كلمة مرور تطبيق».",
        "step2": "اكتب العنوان وكلمة المرور وخادمي IMAP وSMTP (في Gmail: imap.gmail.com وsmtp.gmail.com).",
        "step3": "اكتب العناوين التي يرد عليها الوكيل. البريد لا يرسل رمز اقتران، فمن ليس في القائمة يُتجاهل.",
        "allowed": "عناوين يرد عليها الوكيل",
        "allowed_hint": "عناوين بريد، تفصل بينها فاصلة. رسائل غيرهم تُتجاهل.",
        "how": "أرسل رسالة إلى البريد من عنوان في القائمة، ويرد الوكيل في السلسلة نفسها."
      },
      "badge_program": "يحتاج برنامج {program}",
      "program_note": "يشغّل هرمز برنامج {program} لهذه المنصة، وصورة المركز لا تتضمنه. ثبّته في الخادم أولًا، وإلا ستقول المنصة إنه مفقود عند تشغيل البوابة."
    },
    "guide": "كيف تبدأ",
    "picker": {
      "open": "ربط منصة",
      "title": "ربط منصة",
      "intro": "اختر المنصة التي يرد عليها الوكيل. كل منصة تطلب ما تحتاجه.",
      "search": "ابحث عن منصة",
      "popular": "الأكثر استخدامًا",
      "more": "منصات أخرى",
      "none": "لا منصة تطابق «{query}»."
    },
    "mode": {
      "title": "كيف سيُستعمل هذا الرقم؟",
      "bot": "بوت (رقم مخصص للوكيل)",
      "bot_hint": "يراسل الناس هذا الرقم ويردّ عليهم الوكيل. من يكتب أوّل مرة يصله رمز اقتران وينتظر موافقتك.",
      "self": "أنا (مراسلة نفسي)",
      "self_hint": "رقمك الشخصي: تكلّم الوكيل من محادثة «مراسلة نفسي» في واتساب. لا أحد غيرك ممن يراسلك يصل إلى الوكيل ولا يصله ردّ اقتران.",
      "continue": "متابعة",
      "badge_bot": "بوت",
      "badge_self": "مراسلة نفسي",
      "change": "تغيير الوضع",
      "change_title": "كيف يُستعمل واتساب",
      "change_note": "يبقى الهاتف مرتبطًا. يعيد المركز تشغيل اتصال هرمز بواتساب لتطبيق التغيير فورًا.",
      "save": "حفظ"
    },
    "reply_header": {
      "open": "عنوان الردود",
      "title": "عنوان الردود",
      "note": "في «مراسلة نفسي» رسائلك ورسائل الوكيل من رقم واحد، فيبدأ كل ردّ من الوكيل بهذا العنوان.",
      "agent_name": "اسم الوكيل ({name})",
      "agent_name_plain": "اسم الوكيل",
      "custom": "نص مخصص",
      "custom_label": "نص العنوان",
      "custom_hint": "سطر واحد، حتى 64 حرفًا.",
      "preview": "سيبدأ الردّ هكذا:",
      "preview_body": "ردّ الوكيل…",
      "hermes_now": "الآن: عنوان هرمز نفسه («☤ Hermes Agent»). الحفظ يضع اختيارك مكانه.",
      "no_none": "هرمز يضع عنوانًا فوق الردود هنا دائمًا، فيمكن تغييره لا حذفه.",
      "save": "حفظ"
    },
    "approvals": {
      "open": "الموافقات",
      "open_count": "الموافقات: {count} بانتظارك",
      "title": "الموافقات",
      "close": "إغلاق",
      "waiting_review": "{count} بانتظار الموافقة — راجِع"
    },
    "restart_needed": "يحتاج هرمز إلى إعادة تشغيل ليتّصل بـ{name}.",
    "restart_now": "أعد التشغيل الآن",
    "webhooks": {
      "title": "ويب هوك",
      "new": "ويب هوك جديد",
      "intro": "دع خدمة خارجية — GitHub أو نموذجًا أو سكربتًا — تشغّل هذا الوكيل بإرسال طلب إلى عنوان. لكل ويب هوك موجّهه وسرّه.",
      "public_note": "ترسل الخدمات الخارجية إلى عنوان هذا المركز ({origin}). لا تصل إليه إلا إذا كان هذا العنوان مفتوحًا على الإنترنت.",
      "public_private": "هذه الصفحة مفتوحة على {origin}، وهو عنوان لا يصل إليه إلا شبكتك أو جهازك. تحتاج الخدمات الخارجية عنوانًا عامًا لهذا المركز (نطاقًا أو نفقًا) قبل أن تعمل معها هذه الروابط.",
      "none": "لا توجد روابط ويب هوك بعد.",
      "listener_online": "يستقبل",
      "listener_unknown": "يبدأ",
      "listener_offline": "لا يستقبل",
      "listener_error": "خطأ",
      "listener_off": "متوقف",
      "static": "من config.yaml",
      "prompt_label": "الموجّه:",
      "prompt_empty": "(الطلب كاملًا)",
      "url": "العنوان",
      "secret": "السر",
      "secret_global": "يُوقَّع بالسر المشترك للمستقبِل في config.yaml.",
      "show_secret": "إظهار السر",
      "hide_secret": "إخفاء السر",
      "copy": "نسخ",
      "copied": "نُسخ",
      "copy_url": "نسخ عنوان {name}",
      "copy_secret": "نسخ سر {name}",
      "test": "اختبار",
      "testing": "يختبر…",
      "test_accepted": "قُبل الطلب: الوكيل يعمل الآن بموجّه هذا الرابط. جاء هذا الاختبار من المركز نفسه، فلا يثبت أن العنوان العام يعمل.",
      "test_refused": "أجاب المستقبِل بالرمز {status}. {reason}",
      "delete": "حذف",
      "delete_title": "حذف الويب هوك {name}؟",
      "delete_body": "ستُرفض الخدمات التي ما زالت ترسل إلى عنوانه.",
      "new_title": "ويب هوك جديد",
      "new_intro": "اسم للعنوان، وما يُطلب من الوكيل حين يصل طلب.",
      "name": "الاسم",
      "name_hint": "حروف إنجليزية صغيرة وأرقام و - و _. هو جزء من العنوان.",
      "name_invalid": "استخدم حروفًا إنجليزية صغيرة وأرقامًا و - و _، تبدأ بحرف أو رقم.",
      "name_taken": "يوجد ويب هوك بهذا الاسم.",
      "prompt": "الموجّه",
      "prompt_hint": "يُستبدل {a.b} بتلك القيمة من JSON الطلب، و{event_type} باسم الحدث، و{__raw__} بالطلب كاملًا. اتركه فارغًا ليُرسَل الطلب كاملًا.",
      "prompt_placeholder": "فُتحت مشكلة جديدة: {issue.title}. اقرأها واقترح تصنيفًا.",
      "description": "الوصف (اختياري)",
      "events": "الأحداث (اختياري)",
      "events_hint": "لا يشغّل الوكيلَ إلا هذه الأحداث (X-GitHub-Event من GitHub، أو event_type في الطلب). الفراغ يقبل كل حدث.",
      "deliver": "أرسل الرد إلى",
      "deliver_log": "لا مكان — يبقى في سجل الوكيل",
      "deliver_to": "{name} (محادثته الرئيسية)",
      "create": "إنشاء",
      "creating": "يُنشئ…"
    }
  },
  "question": {
    "title": "سؤال",
    "recommended": "موصى به",
    "own": "أو اكتب ردّك",
    "skip": "تخطٍّ",
    "send": "إرسال",
    "left": "متبقٍّ {time}",
    "answered": "إجابتك:",
    "skipped": "تُخطّي السؤال",
    "expired": "انتهى الوقت دون إجابة"
  },
  "agent_jobs": {
    "title_of": "المهام المجدولة · {name}",
    "note": "ما يعمل وحده لهذا الوكيل في هذا البروفايل. في هرمز هي المهام في مجدوله الخاص، وهرمز من يشغّلها. وهي نفسها التي تعرضها صفحة الجدولة؛ أنشئ مهمة أو عدّلها هناك.",
    "open_schedules": "افتح صفحة الجدولة",
    "none": "لا مهام مجدولة",
    "none_body": "لا شيء مجدول لهذا الوكيل في هذا البروفايل. أنشئ جدولة في صفحة الجدولة وستظهر هنا.",
    "active": "مفعّلة",
    "in_hermes": "في مجدول هرمز",
    "delete_body": "تُحذف من مجدول هرمز أيضًا."
  },
  "agent_plugins": {
    "title_of": "الإضافات · {name}",
    "note": "الإضافات التي يملكها هرمز في هذا البروفايل، بحالتها كما يسمّيها هرمز. ما لم يُفعَّل لا يعمل، إلا منصّات المراسلة ومزوّدي النماذج المرفقة مع هرمز فتعمل حين تُستخدم. ويصل أي تغيير إلى جلسة الوكيل القادمة.",
    "none": "لا إضافات",
    "none_body": "لا يذكر هرمز أي إضافة في هذا البروفايل.",
    "enabled": "مفعّلة",
    "status": {
      "enabled": "مفعّلة",
      "disabled": "معطّلة",
      "not_enabled": "غير مفعّلة"
    },
    "source": {
      "bundled": "تأتي مع هرمز",
      "user": "مثبّتة",
      "external": "من حزمة"
    },
    "install": "ثبّت",
    "install_label": "الإضافة المراد تثبيتها",
    "install_placeholder": "chrome-profiles · owner/repo · https://…",
    "install_hint": "اسم من كتالوج إضافات هرمز، أو owner/repo، أو رابط Git. يجلبها هرمز ويفحصها ويثبّتها في هذا البروفايل وهي مطفأة، وتشغّلها متى شئت.",
    "installed": "ثُبّتت {name} وهي مطفأة.",
    "remove": "أزِل",
    "remove_title": "إزالة {name}؟",
    "remove_body": "يُزال مجلدها من إضافات هذا البروفايل. إطفاؤها يبقيها.",
    "bundled_refused": "هذه الإضافة تأتي مع هرمز؛ أطفئها بدل إزالتها."
  },
  "trajectory": {
    "tab": "المسار",
    "chat_tab": "المحادثة",
    "tabs_label": "عرض المحادثة",
    "timeline": "الخط الزمني",
    "lane": {
      "input": "المُدخل",
      "model": "النموذج",
      "tools": "الأدوات",
      "subagents": "الوكلاء الفرعيون"
    },
    "kind": {
      "input": "مُدخل",
      "turn": "دور",
      "reasoning": "تفكير",
      "tool": "استدعاء أداة",
      "subagent": "وكيل فرعي"
    },
    "status": {
      "running": "يعمل",
      "failed": "فشل",
      "cancelled": "أُوقف",
      "succeeded": "تم"
    },
    "tool_call_only": "استدعاء أداة فقط",
    "no_text": "بلا نص",
    "no_details": "لم يُسجَّل شيء آخر لهذه الخطوة.",
    "first_token_here": "أول كلمة بعد {time}",
    "filters": "تصفية الخطوات",
    "filter": {
      "duration": "المدة",
      "turns": "الأدوار",
      "calls": "الاستدعاءات"
    },
    "search": "ابحث في الخطوات",
    "no_match": "لا خطوة تطابق هذه التصفية.",
    "download": "سجل الجلسة",
    "empty_title": "لم يحدث شيء بعد",
    "empty_body": "أرسل رسالة وستظهر هنا كل خطوة يخطوها الوكيل.",
    "untimed": "هذه المحادثة أقدم من تسجيل أزمنة الخطوات في الخادم، فلا خط زمني لها — الخطوات وحدها.",
    "not_started": "انتهى الدور قبل أن يبدأ الوكيل، فلا خط زمني — فقط ما أُرسل.",
    "partial": "الأدوار الأولى سُجّلت قبل أن يحفظ الخادم أزمنة الخطوات؛ الخط الزمني يعرض ما بعدها.",
    "unit": {
      "ms": "ملّي ث",
      "s": "ث",
      "min": "د"
    },
    "metric": {
      "turns": "الأدوار",
      "steps": "الخطوات",
      "model_time": "وقت النموذج",
      "tool_time": "وقت الأدوات",
      "first_token": "متوسط الوقت حتى أول كلمة",
      "tokens_per_second": "رمز/ث",
      "cache_hit": "من الذاكرة المؤقتة",
      "input_tokens": "رموز الإدخال",
      "output_tokens": "رموز الإخراج"
    },
    "model": "النموذج: {model}",
    "fallback": "انتقل احتياطيًا من {failed}"
  },
  "terminal": {
    "warning": "هذه طرفية على الخادم بصلاحيات حساب المركز",
    "warning_detail": "كل ما تكتبه يُنفَّذ على جهاز المركز بحساب المركز نفسه، في مجلد البروفايل. ويُسجَّل فتح كل طرفية وإغلاقها في السجلات.",
    "no_pty": "هذا المركز بلا PTY: الأوامر تعمل وتطبع، لكن بلا تحرير للسطر، ولا تعمل برامج ملء الشاشة.",
    "idle": "تُغلق الطرفية التي لا يكتب فيها أحد بعد {minutes} دقيقة، ولا يُفتح أكثر من {max} في الوقت نفسه.",
    "new": "طرفية جديدة",
    "tab": "طرفية {n}",
    "close": "إغلاق {name}",
    "copy": "نسخ",
    "paste": "لصق",
    "copy_hint": "‏Ctrl+Shift+C ينسخ المحدَّد، وCtrl+Shift+V يلصق.",
    "clipboard_denied": "لم يسمح المتصفح بالوصول إلى الحافظة. استخدم Ctrl+Shift+V أو اللصق من المتصفح.",
    "limit": "هناك {max} طرفيات مفتوحة بالفعل. أغلق واحدة أولًا.",
    "empty": "لا طرفية مفتوحة",
    "empty_body": "تبدأ الطرفية الجديدة في مجلد البروفايل {profile}.",
    "disabled": "الطرفية غير مفعّلة في هذا المركز.",
    "disabled_body": "لا تعمل إلا إذا شُغّل المركز مع COREHUB_WEB_TERMINAL=1، وحتى حينها لا يراها إلا المالك.",
    "connecting": "جارٍ الاتصال بالطرفية…",
    "ended": "انتهت هذه الطرفية: {reason}",
    "reason_exited": "خرجت الصدفة",
    "reason_closed": "أُغلقت",
    "reason_idle": "لم يكتب فيها أحد مدة طويلة",
    "reason_shutdown": "توقّف المركز",
    "gone": "هذه الطرفية لم تعد على المركز.",
    "folder": "المجلد:"
  },
  "this_device": {
    "not_desktop": "هذه الصفحة لتطبيقَي سطح المكتب والجوال.",
    "unavailable": "لم يُجب التطبيق. أعد تشغيله وحاول مرة أخرى.",
    "connection": "الاتصال",
    "mode": "الوضع",
    "mode_remote": "متصل بمركز",
    "mode_local": "يعمل على هذا الحاسوب",
    "hub": "عنوان المركز",
    "hub_state": "المركز",
    "hub_checking": "جارٍ التحقق…",
    "hub_unreachable": "لا يُجيب",
    "hub_connected": "يُجيب (بناء {version})",
    "app_version": "إصدار التطبيق",
    "platform": "النظام",
    "platform_macos": "macOS",
    "platform_windows": "Windows",
    "platform_linux": "Linux",
    "change": "تغيير الاتصال",
    "change_hint": "اتصل بمركز آخر أو بدّل بين مركز وهذا الحاسوب. ما يحفظه كلٌّ منهما يبقى عنده.",
    "window": "النافذة",
    "close_to_tray": "استمر في العمل عند إغلاق النافذة",
    "close_to_tray_hint": "يبقى التطبيق في شريط النظام ويواصل عرض الإشعارات. أنهِه من هناك.",
    "no_tray": "سطح المكتب هذا بلا شريط نظام، فإغلاق النافذة يُنهي التطبيق.",
    "voice": "الصوت",
    "data_dir": "مجلد البيانات",
    "hermes": "وكيل هرمز",
    "hermes_program": "مثبَّت على هذا الحاسوب",
    "hermes_gateway": "يعمل مسبقًا على هذا الحاسوب",
    "hermes_none": "غير موجود — يظهر هرمز في الوكلاء غير مثبَّت",
    "hermes_path": "برنامج هرمز",
    "local_sign_in": {
      "title": "الدخول على هذا الحاسوب",
      "label": "الدخول دون كلمة مرور على هذا الحاسوب",
      "hint": "يُدخلك التطبيق — أنت المالك — إلى المركز الذي يعمل على هذا الحاسوب دون كلمة المرور. الهواتف والمتصفحات والحواسيب الأخرى ما زالت تحتاجها.",
      "refused": "لا يشغّل هذا إلا المالك وهو مسجّل الدخول. سجّل الدخول من جديد وحاول مرة أخرى.",
      "recovery_on": "إن نسيت كلمة المرور، فإن «نسيت كلمة المرور؟» في شاشة الدخول تعيد تعيينها بعد أن يؤكّد هذا الحاسوب أنه أنت.",
      "recovery_off": "لا توجد على هذا الحاسوب طريقة لتأكيد أنه أنت (مثل Windows Hello أو طلب كلمة مرور)، لذا لا تظهر «نسيت كلمة المرور؟» هنا."
    }
  },
  "helper": {
    "title": "الوكلاء على هذا الحاسوب",
    "intro": "يسمح لوكيل باستعمال هذا الحاسوب — المجلدات والبرامج التي تشاركها فقط، وكما تسمح فقط — من المركز الذي على هذا الحاسوب أو من مركز على خادم. مطفأ حتى تشغّله.",
    "enable": "اسمح للوكلاء باستعمال هذا الحاسوب",
    "enable_hint": "يستمع على هذا الحاسوب فقط ويطلب مفتاحه مع كل طلب.",
    "exposed": "ما يستطيع الوكلاء فعله",
    "tool_list_allowed_folders": "معرفة المجلدات المشارَكة",
    "tool_list_directory": "عرض محتوى مجلد مشارَك",
    "tool_read_text_file": "قراءة الملفات النصية في المجلدات المشارَكة",
    "tool_write_text_file": "كتابة ملفات نصية في المجلدات المشارَكة للكتابة",
    "tool_open_path": "فتح ملفات المجلدات المشارَكة ببرامجها",
    "tool_open_url": "فتح روابط الويب في متصفحك",
    "folders": "المجلدات المشارَكة",
    "no_folders": "لا مجلد مشارَك: لا يرى الوكلاء شيئًا على هذا الحاسوب.",
    "add_folder": "مشاركة مجلد…",
    "remove": "إيقاف المشاركة",
    "writable": "يستطيع الوكلاء الكتابة هنا",
    "allow_open": "السماح بفتح الملفات وروابط الويب",
    "allow_open_hint": "الملفات داخل المجلدات المشارَكة فقط، والروابط http وhttps فقط.",
    "connection": "الاتصال",
    "address": "العنوان",
    "token": "المفتاح",
    "copy": "نسخ",
    "copied": "نُسخ",
    "show": "إظهار",
    "hide": "إخفاء",
    "new_token": "مفتاح جديد",
    "new_token_hint": "ما يستخدم المفتاح القديم يتوقف إلى أن يُعطى الجديد.",
    "add_to_hermes": "إضافته إلى هرمز في هذا المركز",
    "added_to_hermes": "أُضيف إلى هرمز باسم «{name}». يسري عند تشغيل هرمز التالي.",
    "no_hermes_agent": "لا يوجد في هذا المركز وكيل هرمز لإضافته إليه.",
    "remote_note": "المركز الذي على خادم يصل إلى هذا الحاسوب عبر اتصال الجهاز، الذي يُبقيه هذا التطبيق مفتوحًا ما دام يعمل، ولو من شريط النظام.",
    "activity": "آخر الاستخدام",
    "no_activity": "لم يستخدم أحد المساعد بعد.",
    "refused": "رُفض",
    "not_running": "المساعد مفعَّل لكنه لا يعمل: {message}",
    "local_note": "المركز الذي على هذا الحاسوب يصل إلى المساعد على هذا العنوان. أضفه إلى هرمز مرة واحدة، ويأخذ كل بروفايل البرامج التي شغّلتها له.",
    "default_folder": "مجلد كور هب",
    "default_folder_hint": "أنشأ التطبيق هذا المجلد لملفات كور هب حين شغّلت المساعد. البرامج تضع ما تنتجه هنا (فيديو مصدَّر مثلًا) ما لم تقل غير ذلك. تستطيع إيقاف مشاركته متى شئت.",
    "via_hub": "من المركز",
    "via_local": "من هذا الحاسوب"
  },
  "desktop_updates": {
    "title": "التحديثات",
    "auto": "البحث عن الإصدارات الجديدة تلقائيًا",
    "auto_hint": "بعد نحو عشر ثوانٍ من تشغيل كور هب، ثم كل ست ساعات. يُنزَّل الإصدار الجديد في الخلفية، ولا يُعاد تشغيل كور هب إلا حين تطلب.",
    "check": "تحقّق الآن",
    "checking": "جارٍ التحقق…",
    "current": "هذا الإصدار: {version}",
    "available": "كور هب {version} متاح.",
    "download": "تنزيل",
    "notes": "ما الجديد",
    "up_to_date": "هذا أحدث إصدار لهذا الحاسوب.",
    "failed": "تعذّر التحقق: {message}",
    "checked_at": "آخر تحقق {time}",
    "all_releases": "كل الإصدارات",
    "from_store": "التحديثات تأتي من متجر مايكروسوفت.",
    "store_page": "فتح في متجر مايكروسوفت",
    "size": "{size} MB",
    "auto_hint_notify": "بعد نحو عشر ثوانٍ من تشغيل كور هب، ثم كل ست ساعات. يخبرك كور هب حين يصدر إصدار جديد، ولا يُنزَّل شيء.",
    "ready": "كور هب {version} جاهز للتثبيت.",
    "ready_hint": "إن لم تُعِد التشغيل الآن فسيُثبَّت عند إغلاق كور هب في المرة القادمة.",
    "restart": "أعد التشغيل للتحديث",
    "later": "لاحقًا",
    "downloading": "يجري تنزيل كور هب {version}…",
    "downloading_percent": "يجري تنزيل كور هب {version}… {percent}%",
    "download_page": "افتح صفحة التنزيل",
    "available_hint": "نزّله من صفحة التنزيل وثبّته فوق هذه النسخة.",
    "notice_label": "إصدار جديد من كور هب"
  },
  "rooms": {
    "filter": "تصفية الغرف",
    "active": "النشطة",
    "archived": "المؤرشفة",
    "none": "لا غرف بعد. أنشئ غرفة، أو انضم إلى غرفة برمزها.",
    "none_archived": "لا غرف مؤرشفة.",
    "counts": "الوكلاء: {agents} · الأشخاص: {people}",
    "pick_title": "افتح غرفة",
    "pick_body": "اختر غرفة من القائمة، أو أنشئ غرفة جديدة، أو انضم إلى غرفة برمزها.",
    "agent_badge": "وكيل",
    "archive": "أرشفة",
    "unarchive": "إعادة من الأرشيف",
    "archived_notice": "هذه الغرفة مؤرشفة: رسائلها تبقى مقروءة، ولا يُكتب فيها جديد.",
    "back": "رجوع إلى الغرف",
    "deleted": "حُذفت هذه الغرفة.",
    "removed": "لم تعد عضوًا في هذه الغرفة.",
    "delete_title": "حذف هذه الغرفة؟",
    "delete_body": "ستُحذف الغرفة «{name}» ورسائلها ووكلاؤها نهائيًا.",
    "leave": "مغادرة الغرفة",
    "leave_title": "مغادرة هذه الغرفة؟",
    "leave_body": "تغادر «{name}». للعودة تحتاج رمزها من جديد.",
    "rename": "إعادة تسمية",
    "empty": "لا توجد رسائل بعد. اكتب رسالة واذكر وكيلًا باستخدام @ لتسأله.",
    "empty_no_seats": "لا وكلاء في هذه الغرفة بعد. أضف وكيلًا من لوحة الأعضاء.",
    "older": "عرض الرسائل الأقدم",
    "handoff_to": "مرّر الدور إلى @{name}",
    "activity": {
      "queued": "{name} هو التالي",
      "thinking": "{name} يفكّر",
      "working": "{name} يردّ",
      "waiting": "{name} ينتظر موافقة",
      "typing": "{names} يكتب…"
    },
    "status": {
      "idle": "متاح",
      "queued": "في الدور",
      "thinking": "يفكّر",
      "running": "يردّ",
      "waiting_approval": "ينتظر موافقة",
      "offline": "غير متصل"
    },
    "composer": {
      "label": "رسالة إلى الغرفة",
      "placeholder": "اكتب للغرفة — @ لذكر وكيل",
      "mentions": "وكلاء للذكر",
      "all": "كل الوكلاء",
      "lead_hint": "الرسالة التي لا تذكر أحدًا يجيب عنها @{name}.",
      "no_lead_hint": "الرسالة التي لا تذكر أحدًا تُقرأ فقط — اذكر وكيلًا بـ@."
    },
    "invite": {
      "button": "دعوة",
      "title": "دعوة إلى الغرفة",
      "description": "ينضم بهذا الرمز أو الرابط كل من يستطيع دخول هذا البروفايل. الرمز الجديد يُبطل القديم.",
      "rotate": "رمز جديد",
      "copy": "نسخ الرابط",
      "copied": "نُسخ"
    },
    "join": {
      "description": "الصق رمز الغرفة أو رابطها.",
      "code": "الرمز أو الرابط",
      "join": "انضمام",
      "open": "فتح الغرفة",
      "unknown": "لا غرفة يمكنك الانضمام إليها بهذا الرمز."
    },
    "new": {
      "description": "أنت من يدير الغرفة التي تنشئها. اختر الوكلاء الآن، ويمكنك إضافة غيرهم لاحقًا.",
      "name": "اسم الغرفة",
      "agents": "الوكلاء",
      "create": "إنشاء الغرفة",
      "no_agents": "لا وكيل مثبّت في هذا البروفايل بعد.",
      "seat_failed": "أُنشئت الغرفة، لكن لم تُضف هذه المقاعد: {list}"
    },
    "members": {
      "title": "الأعضاء",
      "agents": "الوكلاء",
      "people": "الأشخاص",
      "lead": "القائد",
      "make_lead": "اجعله القائد",
      "no_agents": "لا وكلاء بعد.",
      "owner": "المدير",
      "online": "في الغرفة",
      "offline": "غائب",
      "remove": "إزالة",
      "default_model": "نموذج الوكيل نفسه",
      "stop": "إيقاف @{name}"
    },
    "seat": {
      "add": "إضافة وكيل",
      "add_title": "إضافة وكيل إلى الغرفة",
      "edit_title": "تعديل المقعد",
      "description": "لكل وكيل في الغرفة اسمه ودوره وتعليماته ونموذجه.",
      "agent": "الوكيل",
      "name": "الاسم في الغرفة",
      "name_hint": "يُذكر بـ@الاسم؛ لا يتكرر في الغرفة.",
      "role": "الدور",
      "instructions": "التعليمات",
      "instructions_hint": "تُعطى لهذا الوكيل في كل دور له في هذه الغرفة.",
      "model": "النموذج",
      "model_hint": "اتركه فارغًا لنموذج الوكيل نفسه.",
      "remove": "إزالة",
      "remove_title": "إزالة هذا الوكيل من الغرفة؟",
      "remove_body": "يغادر @{name} الغرفة، ويبقى ما قاله."
    },
    "handoff": {
      "active": "مرّر @{from} الدور إلى @{to} (التمرير {depth})",
      "stopped_max_depth": "توقّف تمرير الدور: @{from} ← @{to} يتجاوز حدّ الغرفة.",
      "stopped_loop_detected": "توقّف تمرير الدور: @{from} ← @{to} يكرّر تمريرًا حدث من قبل.",
      "stopped_interrupted": "أُوقف تمرير الدور عند @{from} ← @{to}.",
      "stopped_error": "توقّف تمرير الدور: تعذّر على @{to} أن يجيب.",
      "continue": "جولة أخرى"
    },
    "clear": {
      "menu": "مسح السياق",
      "title": "مسح سياق الغرفة؟",
      "body": "تبقى الرسائل، لكن الوكلاء ينسونها: يبدأ كل منهم محادثة جديدة، ويبدأ الملخّص وعدّاد الرموز من الصفر.",
      "confirm": "مسح"
    },
    "settings": {
      "title": "إعدادات الغرفة",
      "mention_all": "السماح بـ@all (كل الوكلاء معًا)",
      "handoff": "يمرّر الوكلاء الدور بعضهم لبعض",
      "max_depth": "أقصى عدد تمريرات متتالية",
      "max_depth_hint": "من 1 إلى 20؛ فارغ بلا حدّ. تكرار تمريرة في السلسلة نفسها يوقفها دائمًا.",
      "project": "المشروع الذي يرسل تقاريره هنا",
      "project_none": "لا مشروع",
      "project_hint": "حين تبدأ مهمة من هذا المشروع أو تنتهي، تُبلَّغ الغرفة."
    },
    "memory": {
      "title": "الملخّص",
      "none": "لا ملخّص بعد. يُكتب كل بضع رسائل، ويُعطى للوكلاء في كل دور.",
      "refresh": "لخّص الآن",
      "edit": "تعديل الملخّص",
      "working": "يُلخِّص…",
      "failed": "تعذّر التلخيص"
    }
  },
  "voice": {
    "dictate": "إملاء",
    "stop_dictation": "أوقف وحوّل إلى نص",
    "requesting": "بانتظار الميكروفون…",
    "listening": "أستمع… {seconds} ث",
    "transcribing": "أحوّل الكلام إلى نص…",
    "cancel": "إلغاء",
    "browser_engine": "بمتعرّف المتصفح نفسه: لا يوجد مزوّد تحويل كلام إلى نص في هذا البروفايل.",
    "error": {
      "no_provider": "الإملاء يحتاج مزوّد تحويل كلام إلى نص، وهذا المتصفح لا يملك متعرّفًا خاصًا به.",
      "mic_denied": "لم يُسمح للمتصفح باستخدام الميكروفون.",
      "mic_unavailable": "تعذّر فتح أي ميكروفون.",
      "no_speech": "لم يُسمع شيء. جرّب مرة أخرى أقرب قليلًا من الميكروفون.",
      "failed": "تعذّر الإملاء: {detail}"
    },
    "open_models": "اضبطه في صفحة النماذج",
    "menu": "خيارات الصوت",
    "language": "لغة الإملاء",
    "language_auto": "تلقائي",
    "language_ar": "العربية",
    "language_en": "English",
    "auto_read": "اقرأ الردود تلقائيًا",
    "mode": "الوضع الصوتي",
    "speak": "اقرأ بصوت",
    "stop_speaking": "أوقف القراءة",
    "loading_audio": "أجهّز الصوت…",
    "browser_voice": "اقرأ بصوت المتصفح (لا يوجد مزوّد تحويل نص إلى كلام في هذا البروفايل)",
    "no_tts": "لا يوجد مزوّد تحويل نص إلى كلام جاهز لهذا البروفايل.",
    "stage": {
      "title": "الوضع الصوتي",
      "turn_by_turn": "دورًا بدور: مزوّدو الكلام في المركز لا يبثّون، فيُرسل كلامك حين تتوقف، ويُقرأ الرد جملةً جملة وهو يصل.",
      "ready": "اضغط لتتكلم",
      "listening": "أستمع",
      "transcribing": "أحوّل إلى نص",
      "thinking": "أفكّر",
      "speaking": "أتكلّم",
      "tap_to_send": "اضغط لترسل",
      "interrupt": "قاطِع",
      "close": "أنهِ الوضع الصوتي",
      "hint": "اضغط لتبدأ واضغط مرة أخرى لترسل — أو اضغط مطوّلًا وأفلِت لترسل.",
      "you_said": "قلت:"
    }
  },
  "perf": {
    "live": "مباشر",
    "paused": "متوقف مؤقتًا ما دام هذا التبويب مخفيًا",
    "every": "يتحدّث كل {count} ثوانٍ",
    "at": "وقت القياس: {time}",
    "no_proc": "لا يوجد ‎/proc‎ على هذا الجهاز، لذا تظهر عمليات هرمز دون أرقامها.",
    "host": "الجهاز",
    "hub": "عملية المركز",
    "cpu": "المعالج",
    "cores": "أنوية المعالج: {count}",
    "memory": "الذاكرة",
    "of": "{used} من {total}",
    "load": "الحِمل",
    "load_hint": "1 · 5 · 15 دقيقة",
    "one_core": "من نواة واحدة",
    "rss": "الذاكرة (RSS)",
    "heap": "الكومة {size}",
    "lag": "تأخّر حلقة الأحداث",
    "ms": "{count} ملّي ثانية",
    "uptime": "مدة التشغيل",
    "hermes": "عمليات هرمز",
    "hermes_rss": "ذاكرة كل عمليات هرمز",
    "hermes_none": "لا يشغّل المركز أي عملية هرمز الآن.",
    "kind_tui_gateway": "بوابة TUI (المحادثات)",
    "kind_dashboard": "hermes serve",
    "kind_gateway": "بوابة المراسلة · {profile}",
    "process": "العملية",
    "state": "الحالة",
    "profiles": "البروفايلات",
    "profile": "البروفايل",
    "active_runs": "التشغيلات الجارية",
    "sessions": "المحادثات",
    "sockets": "الاتصالات",
    "dh": "{d} يوم {h} ساعة",
    "hm": "{h} ساعة {m} دقيقة",
    "m": "{m} دقيقة",
    "s": "{s} ثانية"
  },
  "logview": {
    "kept": "تُحفظ أحدث أسطر سجل المركز وبوابات هرمز في الذاكرة، وتُمسح عند إعادة تشغيل المركز.",
    "source": "المصدر",
    "source_all": "الكل",
    "source_hub": "المركز",
    "source_hermes": "Hermes",
    "source_errors": "الأخطاء فقط",
    "profile": "البروفايل",
    "all_profiles": "كل البروفايلات",
    "level": "المستوى",
    "level_debug": "كل شيء",
    "level_info": "معلومات فما فوق",
    "level_warn": "التحذيرات والأخطاء",
    "level_error": "الأخطاء",
    "level_short_error": "خطأ",
    "level_short_warn": "تحذير",
    "level_short_info": "معلومة",
    "level_short_debug": "تفصيل",
    "search": "ابحث في الأسطر",
    "lines": "الأسطر",
    "last_n": "آخر {count}",
    "tail": "متابعة مباشرة",
    "tail_paused": "متوقفة ما دام هذا التبويب مخفيًا",
    "download": "تنزيل",
    "no_match": "لا سطر يطابق البحث.",
    "empty": "لا أسطر بعد.",
    "showing": "الأسطر المعروضة: {count}",
    "hub": "المركز",
    "tui": "هرمز · بوابة المحادثات",
    "hermes_of": "هرمز · {profile}"
  },
  "files": {
    "button": "الملفات",
    "button_count": "الملفات ({count})",
    "title": "الملفات",
    "list_label": "ملفات هذه المحادثة",
    "empty": "لا ملفات بعد. يظهر هنا ما يكتبه الوكيل في مجلد هذه المحادثة وما يُرفق فيها.",
    "truncated": "في المجلد ملفات أكثر مما يُعرض؛ الأحدث هي المعروضة.",
    "load_failed": "تعذّرت قراءة الملفات.",
    "panel_label": "الملفات المفتوحة",
    "close_tab": "أغلق {name}",
    "open": "افتح {name}",
    "download": "تنزيل",
    "open_new_tab": "افتح في تبويب جديد",
    "view_source": "اعرض المصدر",
    "view_rendered": "اعرض الصفحة",
    "loading": "يُحمَّل الملف…",
    "too_large": "هذا الملف أكبر من أن يُعرض هنا ({size}). نزّله لتفتحه.",
    "no_preview": "لا يمكن عرض هذا النوع من الملفات هنا. نزّله لتفتحه.",
    "source": {
      "tool": "كتبته أداة",
      "working_dir": "في المجلد",
      "attachment": "مرفق"
    },
    "rows_capped": "تُعرض أول {shown} صفًّا من {total}.",
    "columns_capped": "تُعرض أول {count} عمودًا فقط.",
    "sheets_label": "الأوراق",
    "slide": "الشريحة {number}",
    "untitled_slide": "شريحة بلا عنوان",
    "pptx_outline": "مخطط بعناوين الشرائح ونصوصها. الشرائح نفسها لا تُرسم هنا؛ نزّل الملف لتراها.",
    "docx_note": "نص المستند؛ الصور وتخطيط الصفحات لا تظهر.",
    "office_error": {
      "too_many_entries": "في الملف أجزاء أكثر من أن يُفتح بأمان.",
      "too_large": "الملف يتفكك إلى أكبر مما يُفتح بأمان.",
      "not_office": "هذا ليس ملف أوفيس كما يقول اسمه.",
      "damaged": "الملف تالف ولا يمكن قراءته."
    },
    "html_note": "تُعرض في عزل: سكربتاتها تعمل بمعزل عن التطبيق ولا تستطيع الاتصال بشيء.",
    "modified": "عُدّل {time}",
    "updated": "حُدِّث الآن",
    "gone": "لم يعد هذا الملف في مجلد المحادثة.",
    "close": "أغلق الملفات",
    "cannot_play": "لا يستطيع هذا المتصفح تشغيل هذا الملف. نزّله لتفتحه في مشغّل."
  },
  "workspace_files": {
    "intro": "مجلد عمل البروفايل «{profile}»: المجلدات التي تعمل فيها محادثاته ومهامه. مدير ملفات فقط — لا شيء هنا يشغّل أمرًا.",
    "root": "{profile}",
    "breadcrumb": "مسار المجلد",
    "caption": "الملفات في {folder}",
    "name": "الاسم",
    "size": "الحجم",
    "modified": "آخر تعديل",
    "actions": "الإجراءات",
    "actions_for": "إجراءات {name}",
    "up": "إلى المجلد الأعلى",
    "empty": "هذا المجلد فارغ",
    "empty_body": "أفلت الملفات هنا، أو استخدم «رفع» أو «مجلد جديد» أو «ملف جديد».",
    "truncated": "في هذا المجلد أكثر من 5,000 عنصر؛ تُعرض أول 5,000 فقط.",
    "limits": "الحدود: الرفع {upload} للملف · التحرير {edit} · الضغط {zip}.",
    "new_folder": "مجلد جديد",
    "new_file": "ملف جديد",
    "new_name": "الاسم",
    "create": "إنشاء",
    "upload": "رفع",
    "uploading": "جارٍ رفع {names}…",
    "uploaded": "الملفات المرفوعة: {count}",
    "drop_zone": "محتوى المجلد؛ أفلت الملفات هنا لرفعها",
    "drop_here": "أفلت للرفع إلى هذا المجلد",
    "replace_title": "استبدال «{name}»؟",
    "replace_body": "في هذا المجلد ملف بهذا الاسم. لا يمكن التراجع عن الاستبدال.",
    "replace": "استبدال",
    "download": "تنزيل",
    "download_zip": "تنزيل مضغوطًا",
    "preview": "معاينة",
    "preview_of": "معاينة {name}",
    "no_preview": "لا معاينة لهذا النوع من الملفات",
    "no_preview_body": "نزّله لتفتحه على جهازك.",
    "pdf_fallback": "هذا المتصفح لا يعرض ملف PDF هنا. نزّله بدلًا من ذلك.",
    "close": "إغلاق",
    "attach": "إرفاق بمحادثة",
    "attach_title": "إرفاق «{name}» بمحادثة",
    "attach_body": "تذهب نسخة من الملف إلى خانة الكتابة في المحادثة جاهزة للإرسال، ويبقى الملف هنا كما هو.",
    "attach_new_chat": "محادثة جديدة",
    "rename_title": "إعادة تسمية «{name}»",
    "move": "نقل",
    "copy": "نسخ",
    "move_title": "نقل «{name}»",
    "copy_title": "نسخ «{name}»",
    "destination": "مسار الوجهة",
    "destination_hint": "داخل ملفات هذا البروفايل، مثل reports/2026/plan.md. يجب أن يكون المجلد موجودًا.",
    "moved": "نُقل إلى {path}",
    "copied": "نُسخ إلى {path}",
    "delete_title": "حذف «{name}»؟",
    "delete_body": "يُزال الملف من مجلد البروفايل. لا يمكن التراجع عن ذلك.",
    "delete_folder_body": "يُزال المجلد وكل ما فيه من مجلد البروفايل. لا يمكن التراجع عن ذلك.",
    "deleted": "حُذف {name}",
    "failed": "لم تنجح العملية",
    "back_to_top": "العودة إلى المجلد الأعلى",
    "link": "رابط",
    "link_outside": "رابط إلى الخارج",
    "link_outside_hint": "يشير هذا الرابط إلى خارج ملفات البروفايل، فلا يُفتح هنا.",
    "edit_title": "تحرير {name}",
    "new_file_title": "ملف جديد {name}",
    "editor_label": "نص {name}",
    "saved": "حُفظ {name}",
    "unsaved": "تغييرات غير محفوظة",
    "all_saved": "كل التغييرات محفوظة",
    "conflict": "تغيّر الملف على القرص بعد أن فتحته (كتبه وكيل أو تبويب آخر). لم يُحفظ شيء.",
    "conflict_reload": "تحميل النسخة الجديدة (وتجاهل تعديلاتي)",
    "conflict_overwrite": "إبقاء نصي والكتابة فوقه",
    "discard_title": "تجاهل تغييراتك؟",
    "discard_body": "تعديلاتك على {name} غير محفوظة.",
    "discard": "تجاهل"
  },
  "changes": {
    "label": "الملفات التي غيّرها هذا التشغيل",
    "summary": {
      "zero": "لم يغيّر أي ملف",
      "one": "غيّر ملفًا واحدًا",
      "two": "غيّر ملفين",
      "few": "غيّر {count} ملفات",
      "many": "غيّر {count} ملفًا",
      "other": "غيّر {count} ملف"
    },
    "kind": {
      "added": "جديد",
      "modified": "معدَّل",
      "deleted": "محذوف",
      "renamed": "منقول"
    },
    "binary": "ثنائي",
    "open_diff": "اعرض ما غيّره هذا التشغيل في {name}",
    "diff_tab": "{name} (التغييرات)",
    "show_all": "اعرض الكل ({count})",
    "show_less": "اعرض أقل",
    "unlisted": "وملفات أخرى لم تُسرد هنا ({count}).",
    "incomplete": "المجلد أكبر مما يقرؤه المركز عند بدء التشغيل، فقد يفوت هنا تغيير.",
    "live": "حتى الآن"
  },
  "diff": {
    "layout": "طريقة عرض التغييرات",
    "unified": "موحّد",
    "split": "جنبًا إلى جنب",
    "open_file": "افتح الملف",
    "open_file_named": "افتح {name}",
    "loading": "تُحمَّل التغييرات…",
    "renamed_from": "نُقل من",
    "truncated": "قُصّت التغييرات هنا لتبقى ضمن حد الحجم.",
    "no_lines": "نُقل دون أن تتغيّر أسطره.",
    "state": {
      "available": "لا أسطر تُعرض.",
      "binary": "ملف ثنائي: لا أسطر تُقارن.",
      "too_large": "تغييرات هذا الملف أكبر من أن تُعرض هنا.",
      "unavailable": "رأى المركز أن هذا الملف تغيّر، لكنه لم يحتفظ بنسخة منه قبل التشغيل، فلا يستطيع عرض الأسطر."
    }
  },
  "subagents": {
    "title": "الوكلاء الفرعيون",
    "running_count": "يعمل الآن: {count}",
    "finished": "انتهت ({count})",
    "stop": "إيقاف",
    "steer": "توجيه",
    "steer_placeholder": "قل له ما يغيّره…",
    "steer_send": "أرسل",
    "steer_queued": "أُرسل، ويقرؤه قبل خطوته التالية.",
    "steer_rejected": "لم يعد يقبل التوجيه.",
    "view": "عرض",
    "tools": "الأدوات: {count}",
    "last_tool": "آخرها: {tool}",
    "status": {
      "running": "يعمل",
      "completed": "اكتمل",
      "failed": "فشل",
      "interrupted": "أُوقف"
    },
    "observe_note": "هذا الوكيل يخبر فقط ببدء وكلائه الفرعيين وانتهائهم.",
    "sheet_title": "وكيل فرعي",
    "close": "إغلاق",
    "status_label": "الحالة",
    "model": "النموذج",
    "elapsed": "المدة",
    "tool_count": "الأدوات",
    "summary": "آخر ما قاله",
    "recent_tools": "آخر الأدوات",
    "output": "المخرجات الحيّة",
    "no_output": "لا شيء يُعرض بعد.",
    "output_truncated": "يظهر الجزء الأخير فقط.",
    "open_trajectory": "افتح في المسار"
  },
  "background": {
    "open": "في الخلفية",
    "open_count": "يعمل في الخلفية: {count}",
    "title": "في الخلفية",
    "close": "إغلاق",
    "none": "لا شيء يعمل الآن.",
    "none_body": "تظهر هنا المحادثات والمهام والجدولات وسير العمل والأعمال والوكلاء الفرعيون أثناء عملها.",
    "finished": "انتهت خلال آخر 24 ساعة ({count})",
    "stop": "إيقاف",
    "open_item": "افتح",
    "kind": {
      "chat_run": "محادثة",
      "task_run": "مهمة",
      "schedule_run": "جدولة",
      "workflow_run": "سير عمل",
      "job": "عمل",
      "subagent": "وكيل فرعي"
    },
    "status": {
      "queued": "في الانتظار",
      "running": "يعمل",
      "succeeded": "اكتمل",
      "failed": "فشل",
      "cancelled": "أُوقف"
    }
  },
  "config_files": {
    "title_of": "ملفات إعداد {name}",
    "shared": "هذه الملفات مشتركة بين كل البروفايلات: يقرؤها وكلاء البرمجة من مجلد المستخدم الذي يعمل به كور هب، أيًّا كان بروفايل المحادثة. أي تغيير هنا يسري على الجميع من محادثة الوكيل التالية.",
    "none": "ليس لهذا الوكيل ملفات إعداد يحرّرها كور هب.",
    "file_instructions": "التعليمات",
    "file_settings": "الإعدادات",
    "about_instructions": "ما يقرؤه الوكيل في بداية كل محادثة، في كل مشروع.",
    "about_settings": "إعدادات الوكيل نفسه، يقرؤها حين تبدأ المحادثة. قد يحمل ملف الإعدادات مفاتيح: لا يرى هذه الصفحة إلا المالك والمشرفون.",
    "not_yet": "لم يُنشأ بعد",
    "unsaved": "تغييرات غير محفوظة",
    "revert": "تراجع",
    "reload": "حمّل الملف الحالي",
    "saved": "حُفظ. يقرؤه الوكيل من محادثته التالية، وتبقى النسخة السابقة احتياطًا في المركز.",
    "changed": "تغيّر الملف بعد أن فتحته (يدويًا أو من الوكيل). لم يُكتب شيء.",
    "invalid_json": "هذا ليس JSON صالحًا، فلم يُكتب شيء: {message}",
    "symlink_outside": "هذا الملف رابط إلى مكان خارج مجلد الوكيل والمجلد الرئيسي، فلن يفتحه كور هب.",
    "not_text": "هذا الملف ليس نصًا بترميز UTF-8، فلا يُحرَّر هنا.",
    "too_large": "الملف أكبر من ‎1 MiB‎، وهو أقصى ما تحرّره هذه الصفحة.",
    "empty_placeholder": "الملف فاضٍ. اكتب إعداداته هنا، ويُنشأ الملف عند الحفظ."
  },
  "channel_accounts": {
    "title": "حسابات المراسلة",
    "subtitle": "اربط حساب تيليجرام أو واتساب الخاص بك ليتمكن بوت الوكيل من استخدام أدوات كور هب بصلاحياتك عندما تراسله. لا تُمنح هذه الأدوات للحسابات غير المرتبطة أو لمحادثات المجموعات.",
    "none": "لا يوجد حساب مراسلة مرتبط بك.",
    "platform": "المنصة",
    "account": "الحساب",
    "linked_at": "تاريخ الربط",
    "last_used": "آخر استعمال",
    "actions": "إجراءات",
    "platform_telegram": "تيليجرام",
    "platform_whatsapp": "واتساب",
    "link": "اربط حسابًا",
    "send_this": "من حساب تيليجرام أو واتساب الذي تريد ربطه، أرسل هذا إلى بوت الوكيل:",
    "copy": "نسخ",
    "copied": "نُسخ",
    "expires": "يعمل الرمز مرة واحدة، حتى {time}.",
    "must_answer": "يجب أن يكون البوت قادرًا على استقبال رسائلك مسبقًا، عبر الاقتران أو إضافتك إلى قائمة المسموح لهم. سيؤكد لك ربط الحساب برسالة.",
    "waiting": "بانتظار الرسالة…",
    "linked": "تم الربط. الرسائل من ذلك الحساب تستعمل أدوات كور هب باسمك الآن.",
    "unlink": "فكّ الربط",
    "unlink_title": "فكّ ربط هذا الحساب؟",
    "unlink_body": "رسالته التالية لا تحصل على أدوات كور هب. يبقى الوكيل يردّ عليها.",
    "all_title": "حسابات المراسلة المرتبطة",
    "all_subtitle": "حسابات تيليجرام وواتساب المرتبطة بالمستخدمين. تستخدم الرسائل الواردة من كل حساب صلاحيات صاحبه في البروفايلات المسموح له بها.",
    "all_none": "لم يربط أي مستخدم حساب مراسلة.",
    "remove": "إزالة",
    "remove_title": "إزالة ربط {name}؟"
  },
  "device_link": {
    "title": "الاتصال بهذا المركز",
    "intro": "المركز الذي على خادم لا يستعمل مجلدات هذا الحاسوب وبرامجه المشاركة إلا بعد ربط الحاسوب به جهازًا. بعدها يُبقي التطبيق اتصاله الخاص ولو أُغلقت النافذة، ولا شيء ينتظر اتصالًا على هذا الحاسوب.",
    "link": "اربط هذا الحاسوب بالمركز",
    "refused": "لم يعد المركز يقبل هذا الحاسوب (أُلغي ربطه هناك). اربطه من جديد.",
    "profiles": "البروفايلات التي تستعمل هذا الحاسوب",
    "profiles_hint": "كل بروفايلاتك حتى تحدّد. البروفايل غير المختار لا يصل إلى مجلدات هذا الحاسوب ولا برامجه.",
    "unlink": "ألغِ ربط هذا الحاسوب",
    "status_connected": "متصل",
    "status_connecting": "يتصل…",
    "status_offline": "غير متصل — يعيد المحاولة",
    "status_refused": "مرفوض",
    "status_stopped": "متوقف",
    "status_unlinked": "غير مربوط"
  },
  "programs": {
    "title": "برامج هذا الجهاز",
    "count": "{on} من {all} مشغّل",
    "intro": "برامج سجّلت تكاملها مع الذكاء الاصطناعي (خادم MCP) لدى مساعد آخر على هذا الحاسوب: Claude Desktop وإضافاته، وClaude Code، وCodex، وCursor، وWindsurf. كل برنامج مطفأ حتى تختار البروفايلات التي يخدمها؛ يعمل بصلاحيات حسابك، ويستأذنك الحاسوب مرة في كل جلسة قبل أن يستعمله وكيل.",
    "rescan": "ابحث من جديد",
    "empty": "لم يُعثر على برنامج. البرامج تسجّل نفسها لدى تلك المساعدات: ثبّت تكامل البرنامج هناك، ثم ابحث من جديد.",
    "source": {
      "claude_desktop": "Claude Desktop",
      "claude_desktop_extension": "إضافة Claude Desktop",
      "claude_code": "Claude Code",
      "codex": "Codex",
      "cursor": "Cursor",
      "windsurf": "Windsurf"
    },
    "status": {
      "ready": "جاهز",
      "needs_setup": "يحتاج إعدادًا",
      "remote": "خادم على الشبكة",
      "invalid": "لا يمكن تشغيله"
    },
    "on_for": "مشغّل لـ{count}",
    "found_in": "وُجد في",
    "remote_note": "هذا خادم على الشبكة لا برنامج على هذا الحاسوب؛ لا يُمرَّر في هذه النسخة.",
    "invalid_note": "تسجيله لا يسمّي برنامجًا يُشغَّل.",
    "settings": "الإعدادات",
    "needs_setup_hint": "يحتاج قيمة لا يملكها إلا أنت، احتفظ بها المساعد الآخر لنفسه. أدخلها هنا؛ يحفظ التطبيق الأسرار مختومة بسلسلة مفاتيح نظامك.",
    "save": "احفظ",
    "clear": "احذف",
    "saved_secret": "محفوظ — اكتب لتستبدله",
    "profiles": "البروفايلات التي تستعمله",
    "profiles_hint": "بلا اختيار: مطفأ (الافتراضي).",
    "failed": "لم يعمل: {message}",
    "tools": "ما يقدّمه",
    "consent_note": "قبل أن يستعمل وكيل برنامجًا، يسألك هذا الحاسوب: اسمح مرة، أو اسمح لهذه الجلسة، أو ارفض. كل استدعاء يظهر تحت «آخر استعمال».",
    "resolve": {
      "title": "DaVinci Resolve",
      "ready": "جاهز",
      "not_ready": "ليس جاهزًا بعد",
      "check": "افحص",
      "intro": "يتحقق أن تكامل Resolve موجود، وأن Resolve يعمل، وأن البرمجة من خارجه مسموحة، وأنه إصدار Studio.",
      "integration": "التكامل",
      "integration_missing": "غير موجود",
      "integration_found": "موجود وغير مشغّل",
      "integration_shared": "موجود ومشغّل",
      "running": "يعمل",
      "unknown": "تعذّر التحقق",
      "yes": "نعم",
      "no": "لا",
      "scripting": "البرمجة الخارجية",
      "scripting_reachable": "تستجيب",
      "scripting_unreachable": "لا تستجيب",
      "scripting_unknown": "لم تُفحص",
      "edition": "الإصدار",
      "step_install_integration": "ثبّت تكامل DaVinci Resolve مع الذكاء الاصطناعي في Claude Desktop (أو مساعد آخر من المذكورين أعلاه)، ثم اضغط «ابحث من جديد».",
      "step_share_program": "شغّل DaVinci Resolve أعلاه للبروفايلات التي تستعمله.",
      "step_start_resolve": "افتح DaVinci Resolve وأبقه يعمل: البرمجة تخاطب التطبيق وهو يعمل.",
      "step_enable_scripting": "في Resolve: Preferences ← System ← General ← External scripting using ← Local. ثم أعد تشغيل Resolve.",
      "step_needs_studio": "البرمجة من خارج Resolve تحتاج DaVinci Resolve Studio؛ الإصدار المجاني يسمح بها من داخل التطبيق فقط.",
      "support": "دعم DaVinci Resolve وتنزيلاته"
    }
  },
  "desktop_voice": {
    "intro": "الإملاء والقراءة بصوت عالٍ هنا كما في المتصفح: يسجّل الميكروفون على هذا الحاسوب، ويكتب مركزك الكلام ويقرأ الردود بمزوّدي الصوت في البروفايل.",
    "mic_label": "الميكروفون:",
    "mic_granted": "مسموح",
    "mic_granted_hint": "النظام يسمح لكور هب باستخدامه.",
    "mic_denied": "محظور",
    "mic_denied_hint": "النظام يمنعه عن كور هب. اسمح لكور هب من إعدادات الميكروفون في النظام، ثم أعد المحاولة.",
    "mic_not_determined": "لم يُسأل بعد",
    "mic_not_determined_hint": "يسألك النظام أول مرة تُملي فيها، أو الآن.",
    "mic_restricted": "مقيّد",
    "mic_restricted_hint": "سياسة على هذا الحاسوب لا تسمح للتطبيقات باستخدامه.",
    "mic_unknown": "لا مفتاح في النظام",
    "mic_unknown_hint": "ليس في هذا النظام مفتاح لكل تطبيق؛ يطلبه كور هب حين تُملي.",
    "ask": "اسمح بالميكروفون",
    "open_settings": "افتح إعدادات الميكروفون في النظام",
    "no_providers": "ليس في هذا البروفايل مزوّد جاهز لتحويل الكلام إلى نص ولا لتحويل النص إلى كلام، فلا إملاء ولا قراءة بصوت عالٍ.",
    "no_stt": "ليس في هذا البروفايل مزوّد جاهز لتحويل الكلام إلى نص: الاختبار يقول فقط هل وصل صوت.",
    "no_tts": "ليس في هذا البروفايل مزوّد جاهز لتحويل النص إلى كلام، فلا تُقرأ الردود بصوت عالٍ.",
    "test": "اختبر الميكروفون",
    "testing": "تكلّم الآن… ({seconds} ثوانٍ)",
    "level": "مستوى الصوت",
    "heard_text": "سمع المركز: «{text}»",
    "heard_sound": "وصل صوت من الميكروفون.",
    "heard_nothing": "لم يُسمع شيء. تأكد أن الميكروفون الصحيح مختار في النظام وتكلّم أقرب قليلًا.",
    "speak_test": "اختبر القراءة بصوت عالٍ",
    "sample": "هكذا يقرأ كور هب ردودك بصوت عالٍ.",
    "speak_failed": "لم يستطع المركز قراءة الجملة. راجع مزوّد تحويل النص إلى كلام في البروفايل من «النماذج»."
  },
  "outside": {
    "title": "الوصول من خارج البيت",
    "intro": "المركز الذي على هذا الحاسوب لا يجيب إلا هذا الحاسوب. لتستخدمه من جوالك خارج البيت افتح له طريقًا بحساب لك أنت: نفق Cloudflare، أو شبكة Tailscale الخاصة بك. كور هب لا يشغّل لك أي خدمة.",
    "warning": "تشغيل هذا يجعل مركزك قابلًا للوصول من الإنترنت عبر نفقك أنت. من يصل إليه يبقى عليه أن يسجّل الدخول، فاستخدم كلمة مرور قوية، وأطفئه حين لا تحتاجه.",
    "route": "كيف تصل إليه الأجهزة",
    "cloudflare": "نفق Cloudflare",
    "cloudflare_hint": "عنوان عام على نطاق في حسابك على Cloudflare. يعمل من أي شبكة.",
    "tailscale": "Tailscale",
    "tailscale_hint": "لا يصل إليه إلا أجهزة شبكتك الخاصة (tailnet). يحتاج Tailscale على هذا الحاسوب وعلى الجوال.",
    "cf_step_create": "في لوحة Cloudflare افتح Zero Trust ← Networks ← Tunnels، وأنشئ نفقًا من نوع Cloudflared.",
    "cf_step_route": "أعطه اسم مضيف عامًا (Public hostname) خدمته",
    "cf_step_token": "انسخ رمز النفق (النص الطويل بعد ‎--token‎ في أمر التثبيت) والصقه أدناه. ينزّل كور هب برنامج cloudflared الرسمي من Cloudflare مرة واحدة ويشغّله.",
    "copy": "انسخ",
    "copied": "نُسخ",
    "token_kept": "رمز محفوظ في سلسلة مفاتيح هذا الحاسوب (النفق {tunnel}).",
    "forget_token": "انسَ الرمز",
    "token": "رمز النفق",
    "token_replace": "رمز نفق جديد (اختياري)",
    "token_hint": "يُحفظ في سلسلة مفاتيح هذا الحاسوب؛ لا يُعرض مرة أخرى ولا يُرسل إلى أي مكان إلا إلى cloudflared.",
    "hostname": "اسم المضيف العام",
    "hostname_hint": "الاسم الذي أعطيته للنفق، مثل hub.example.com. به تقترن الأجهزة.",
    "route_elsewhere": "يشير إلى مكان آخر — اجعل الخدمة {service}",
    "tailnet_found": "هذا الحاسوب على شبكة Tailscale بالعنوان",
    "tailnet_missing": "هذا الحاسوب ليس على شبكة Tailscale. ثبّت Tailscale وسجّل الدخول ثم عد إلى هنا.",
    "tailscale_phone": "يستمع كور هب على عنوان الشبكة هذا فقط. ثبّت Tailscale على الجوال بالحساب نفسه ثم اقرنه.",
    "turn_on": "شغّل",
    "turn_off": "أطفئ",
    "save": "احفظ",
    "connected": "مفتوح. تقترن الأجهزة بالعنوان {url}.",
    "pair_phone": "اقرن جوالًا",
    "no_hostname": "النفق متصل لكن ليس له اسم مضيف عام بعد. أضف واحدًا في Cloudflare واكتبه أعلاه.",
    "state_off": "مطفأ",
    "state_connected": "متصل",
    "state_connecting": "يتصل…",
    "state_error": "لا يعمل",
    "error": {
      "token_invalid": "لم تقبل Cloudflare الرمز. انسخه مرة أخرى من صفحة النفق.",
      "download_failed": "تعذّر تنزيل cloudflared من إصدارات Cloudflare. تحقّق من الاتصال بالإنترنت وأعد المحاولة.",
      "checksum_mismatch": "الملف الذي نُزّل ليس الملف الذي نشرته Cloudflare، فلم يُشغَّل.",
      "unsupported_platform": "لا تنشر Cloudflare برنامج cloudflared لهذا الحاسوب.",
      "start_failed": "لم يبدأ cloudflared.",
      "tunnel_exited": "توقف cloudflared؛ يعيد كور هب تشغيله.",
      "not_on_tailnet": "هذا الحاسوب ليس على شبكة Tailscale.",
      "listen_failed": "تعذّر على كور هب الاستماع على عنوان شبكة Tailscale."
    },
    "refused": {
      "token_invalid": "هذا ليس رمز نفق Cloudflare. الصق النص الطويل الذي بعد ‎--token‎ فقط.",
      "token_required": "الصق رمز النفق أولًا.",
      "route_required": "اختر نفق Cloudflare أو Tailscale أولًا.",
      "hostname_invalid": "هذا ليس اسم مضيف. اكتبه مثل hub.example.com.",
      "relay_unavailable": "لا يفتح طريقًا إلا المركز الذي يشغّله تطبيق سطح المكتب على هذا الحاسوب.",
      "relay_host_not_answering": "لم يجب تطبيق سطح المكتب. أعد المحاولة بعد قليل."
    }
  },
  "presets": {
    "title": "الإعدادات المحفوظة",
    "subtitle": "إعدادات هذا الوكيل في هذا البروفايل محفوظة باسم: نموذج المحادثة وبدائله، ونموذج الوكيل نفسه، والمهارات وخوادم MCP المفعّلة، والإعدادات أدناه. لا تحفظ مفتاحًا ولا كلمة مرور أبدًا.",
    "name": "اسم للإعدادات الحالية",
    "save": "احفظ الإعدادات الحالية",
    "none": "لا إعدادات محفوظة بعد.",
    "activate": "فعّل",
    "activate_title": "تفعيل «{name}»؟",
    "activate_body": "تحلّ إعداداته محلّ إعدادات هذا الوكيل الحالية في هذا البروفايل، ويُعاد تشغيل ما يلزم لتسري.",
    "delete_title": "حذف «{name}»؟ لن تتغيّر إعدادات الوكيل.",
    "applied": "طُبّقت.",
    "applied_partly": "طُبّقت، ما عدا ما لم يعد موجودًا منذ حُفظت: {skipped}.",
    "restarting": "يُعاد تشغيل ما تحتاجه الإعدادات.",
    "separator": "، ",
    "part": {
      "model": "النموذج",
      "skills": "{count} مهارات",
      "mcp_servers": "{count} خوادم MCP",
      "settings": "{count} أقسام إعدادات"
    },
    "part_name": {
      "model": "النموذج",
      "skills": "المهارات",
      "mcp_servers": "خوادم MCP",
      "settings": "الإعدادات"
    }
  },
  "linked_hubs": {
    "intro": "اربط هذا المركز بكور هب آخر. الربط يُري كل طرف أسماء الوكلاء الذين يشاركهم الآخر، ويتيح لشخص هنا أن يسأل أحدهم سؤالًا واحدًا — يجيبه نموذج ذلك الوكيل بلا أدوات ولا ملفات ولا ذاكرة. لا يُشارَك غير ذلك: لا ملفات ولا ذاكرة ولا مهام ولا مزوّدين ولا مفاتيح. ويلزم أن يوافق المالكان كلاهما.",
    "invite_title": "ادعُ مركزًا آخر",
    "invite_hint": "أنشئ رابطًا وأرسله إلى مالك المركز الآخر. يصلح مرة واحدة خلال 10 دقائق.",
    "invite_create": "أنشئ رابط دعوة",
    "invite_again": "أنشئ غيره",
    "invite_expires": "يصلح مرة واحدة حتى {time}.",
    "own_fingerprint": "مفتاح هذا المركز",
    "their_fingerprint": "مفتاحه",
    "copy": "نسخ",
    "redeem_title": "استخدم دعوة",
    "redeem_hint": "الصق الرابط الذي أرسله لك مالك المركز الآخر، ثم يوافق مالكه.",
    "redeem_url": "رابط الدعوة",
    "redeem_name": "اسم له هنا (اختياري)",
    "redeem_submit": "اطلب الربط",
    "redeem_sent": "أُرسل الطلب. يكتمل الربط حين يوافق مالكه.",
    "peers_heading": "المراكز",
    "none": "لا مراكز مرتبطة.",
    "enabled": "مفعّل",
    "off": "موقوف",
    "approve": "وافق",
    "refuse": "ارفض",
    "unlink": "افصل",
    "unlink_title": "فصل «{name}»؟",
    "unlink_body": "يُنسى مفتاحه فورًا فلا يستطيع أن يسأل هنا شيئًا بعدها. ويبقى السجل.",
    "rename": "أعد التسمية",
    "rename_title": "إعادة تسمية المركز",
    "rename_label": "الاسم",
    "asks_per_hour": "عدد أسئلته المسموحة في الساعة",
    "their_agents": "وكلاؤه المشارَكون",
    "their_agents_none": "لا يشارك أي وكيل.",
    "ask_hint": "سؤال واحد وجواب واحد. يجيب وكيلهم بلا أدوات ولا ملفات ولا ذاكرة.",
    "ask_agent": "الوكيل",
    "ask_question": "سؤالك",
    "ask_send": "اسأل",
    "log": "السجل",
    "shares_title": "الوكلاء الذين تسألهم المراكز المرتبطة",
    "shares_hint": "موقوفة حتى تفعّل وكيلًا. لا يرى المركز المرتبط إلا اسمه، ويسأله أسئلة مفردة يجيبها بلا أدوات.",
    "share_label": "شارك {name} ({profile})",
    "pending_hint": "طلب الربط؛ قارن مفتاحه بما يراه مالكه، ثم وافق أو ارفض.",
    "status": {
      "pending": "بانتظار موافقتك",
      "waiting": "بانتظار موافقتهم",
      "linked": "مرتبط"
    },
    "direction": {
      "inbound": "استخدم دعوة هذا المركز.",
      "outbound": "استخدم هذا المركز دعوته."
    },
    "event": {
      "joined": "استخدم دعوة",
      "requested": "طُلب الربط",
      "approved": "وافقت",
      "approved_by_peer": "وافقوا",
      "updated": "عُدّل",
      "unlinked": "فُصل",
      "unlinked_by_peer": "فصلوا الربط",
      "list_in": "اطّلعوا على الوكلاء المشارَكين",
      "list_out": "اطّلعت على وكلائهم",
      "ask_in": "سألوا سؤالًا",
      "ask_out": "سألتهم سؤالًا",
      "refused": "رُفض اتصال"
    },
    "reason": {
      "own_url_not_https": "يجب أن يُفتح هذا المركز عبر HTTPS ليُربط.",
      "https_required": "يجب أن يبدأ الرابط بـ https://.",
      "invite_url_invalid": "هذا ليس رابط دعوة.",
      "invite_refused": "الدعوة مستخدمة أو منتهية أو غير معروفة. اطلب دعوة جديدة.",
      "fingerprint_mismatch": "أجاب المركز الآخر بمفتاح غير الذي يذكره الرابط. لم يتم الربط.",
      "peer_unreachable": "لم يُجب المركز الآخر.",
      "peer_exists": "هذا المركز مرتبط به من قبل.",
      "peer_is_self": "هذه دعوة هذا المركز نفسه.",
      "peer_limit": "المراكز المرتبطة كثيرة.",
      "invite_limit": "الدعوات غير المستخدمة كثيرة. انتظر حتى تنتهي.",
      "peer_pending": "لم يوافق مالكهم بعد.",
      "peer_not_linked": "لم يكتمل الربط بعد.",
      "peer_disabled": "الربط موقوف.",
      "agent_not_shared": "هذا الوكيل غير مشارَك.",
      "no_answer": "لم يُجب وكيلهم.",
      "rate_limited": "أسئلة كثيرة. حاول لاحقًا.",
      "peer_calls": "اتصالات كثيرة. حاول بعد دقيقة.",
      "peer_asks": "استنفدوا أسئلتهم لهذه الساعة.",
      "peer_not_pending": "لا يُوافَق إلا على مركز ينتظر الموافقة."
    }
  },
  "secrets": {
    "unlock_title": "أدخل كلمة المرور لفتح الأسرار",
    "unlock_hint": "تُطلب في كل مرة تُفتح فيها هذه الصفحة، ثم تبقى مفتوحة خمس دقائق في هذه الصفحة وحدها.",
    "password": "كلمة المرور",
    "unlock": "فتح الأسرار",
    "lock": "إغلاق الأسرار",
    "expired": "أُغلقت الصفحة تلقائيًا. أدخل كلمة المرور مرة أخرى لفتحها.",
    "unsupported": "هذا المركز لا يقدّم الأسرار بعد. حدّث المركز لاستعمال هذه الصفحة.",
    "audit_note": "القيم مخفية. كل قيمة تعرضها أو تنسخها تُكتب في سجل التدقيق — من، وأي سر، ومتى، لا القيمة نفسها — وتختفي بعد 30 ثانية.",
    "time_left": "تُغلق بعد {minutes}:{seconds}",
    "empty": "لا يحفظ المركز أي سر بعد.",
    "shared": "مشترك بين كل البروفايلات",
    "whole_hub": "المركز كله",
    "hidden_value": "قيمة مخفية",
    "show": "إظهار {name}",
    "hide": "إخفاء {name}",
    "hides_in": "تختفي بعد {seconds} ث",
    "copy": "نسخ {name}",
    "copied": "نُسخ",
    "copy_failed": "لم يسمح المتصفح بالنسخ.",
    "kind": {
      "provider_key": "مفاتيح المزوّدين",
      "channel": "القنوات",
      "mcp": "خوادم MCP",
      "webhook_out": "وجهات الإشعار الصادرة",
      "webhook_in": "الويبهوك الواردة",
      "other": "أخرى"
    }
  }
}
